"use strict";
/*
 * Cookies.js - 1.2.2
 * https://github.com/ScottHamper/Cookies
 *
 * This is free and unencumbered software released into the public domain.
 */
(function (global, undefined) {
  'use strict';

  var factory = function (window) {
    if (typeof window.document !== 'object') {
      throw new Error('Cookies.js requires a `window` with a `document` object');
    }

    var Cookies = function (key, value, options) {
      return arguments.length === 1 ?
        Cookies.get(key) : Cookies.set(key, value, options);
    };

    // Allows for setter injection in unit tests
    Cookies._document = window.document;

    // Used to ensure cookie keys do not collide with
    // built-in `Object` properties
    Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)

    Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');

    Cookies.defaults = {
      path: '/',
      secure: false
    };

    Cookies.get = function (key) {
      if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
        Cookies._renewCache();
      }

      var value = Cookies._cache[Cookies._cacheKeyPrefix + key];

      return value === undefined ? undefined : decodeURIComponent(value);
    };

    Cookies.set = function (key, value, options) {
      options = Cookies._getExtendedOptions(options);
      options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);

      Cookies._document.cookie = Cookies._generateCookieString(key, value, options);

      return Cookies;
    };

    Cookies.expire = function (key, options) {
      return Cookies.set(key, undefined, options);
    };

    Cookies._getExtendedOptions = function (options) {
      return {
        path: options && options.path || Cookies.defaults.path,
        domain: options && options.domain || Cookies.defaults.domain,
        expires: options && options.expires || Cookies.defaults.expires,
        secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
      };
    };

    Cookies._isValidDate = function (date) {
      return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
    };

    Cookies._getExpiresDate = function (expires, now) {
      now = now || new Date();

      if (typeof expires === 'number') {
        expires = expires === Infinity ?
          Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
      } else if (typeof expires === 'string') {
        expires = new Date(expires);
      }

      if (expires && !Cookies._isValidDate(expires)) {
        throw new Error('`expires` parameter cannot be converted to a valid Date instance');
      }

      return expires;
    };

    Cookies._generateCookieString = function (key, value, options) {
      key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
      key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
      value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
      options = options || {};

      var cookieString = key + '=' + value;
      cookieString += options.path ? ';path=' + options.path : '';
      cookieString += options.domain ? ';domain=' + options.domain : '';
      cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
      cookieString += options.secure ? ';secure' : '';

      return cookieString;
    };

    Cookies._getCacheFromString = function (documentCookie) {
      var cookieCache = {};
      var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

      for (var i = 0; i < cookiesArray.length; i++) {
        var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);

        if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
          cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
        }
      }

      return cookieCache;
    };

    Cookies._getKeyValuePairFromCookieString = function (cookieString) {
      // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
      var separatorIndex = cookieString.indexOf('=');

      // IE omits the "=" when the cookie value is an empty string
      separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

      var key = cookieString.substr(0, separatorIndex);
      var decodedKey;
      try {
        decodedKey = decodeURIComponent(key);
      } catch (e) {
        if (console && typeof console.error === 'function') {
          console.error('Could not decode cookie with key "' + key + '"', e);
        }
      }

      return {
        key: decodedKey,
        value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
      };
    };

    Cookies._renewCache = function () {
      Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
      Cookies._cachedDocumentCookie = Cookies._document.cookie;
    };

    Cookies._areEnabled = function () {
      var testKey = 'cookies.js';
      var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
      Cookies.expire(testKey);
      return areEnabled;
    };

    Cookies.enabled = Cookies._areEnabled();

    return Cookies;
  };

  var cookiesExport = typeof global.document === 'object' ? factory(global) : factory;

  // AMD support
  if (typeof define === 'function' && define.amd) {
    define('cookies', function () { return cookiesExport; });
    // CommonJS/Node.js support
  } else if (typeof exports === 'object') {
    // Support Node.js specific `module.exports` (which can be a function)
    if (typeof module === 'object' && typeof module.exports === 'object') {
      exports = module.exports = cookiesExport;
    }
    // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
    exports.Cookies = cookiesExport;
  } else {
    global.Cookies = cookiesExport;
  }
})(typeof window === 'undefined' ? this : window);
/* abTestRegistry and abTestRegistryOverride must be two arrays. */
define('gc/abTestRegistry', ['gc/abTestRegistryOverride','gc/errorLogging'], function (abTestRegistryOverride,errorLogging) {
    'use strict';

    function union_arrays (x, y) {
      var obj = {}; // create an object to store properties named for the values in x and y.
      for (var i = x.length-1; i >= 0; -- i) // for each item in the first array...
         obj[x[i]] = x[i];                   // copy the value to our object as a property name.
      for (var i = y.length-1; i >= 0; -- i) // for each item in the second array...
         obj[y[i]] = y[i];                   // copy the value to our object as a property name - same values overwrite existing properties.
      var res = [] // create an array to return
      for (var k in obj) { // for each property of our object
        if (obj.hasOwnProperty(k))  // if it is a property on our object and not a prototype property
          res.push(obj[k]); // push it to our array.
      }
      return res; // return the array
    }

    try {
      // NOTE: Adding any tests to this list must also be added here:
      // https://ewegithub.sb.karmalab.net/EWE/globalcontrols-service/blob/master/web/src/main/java/com/expedia/www/globalcontrols/controllers/RenderHtmlController.java
      var abTestRegistry = [
          6739, // esstech@expedia.com : trigger typeahead  at 1 or 2 characters
          8263, // esstech@expedia.com : ticker dashboard //GC
          8664, // esstech@expedia.com : Expose Higher level regions in Hotels LOB
          9433, // esstech@expedia.com : consuming ESS typeahead v4 for packages LOB
          9598,  // esstech@expedia.com : Adding MER signup to the hotel tab
          11054, // Change Recommender Module URL from HRS to HIS
          11582, // esstech@expedia.com Expose Recent history from Scratchpad in Hotels LOB
          10901, // SitesmithsTeam@expedia.com : Amex marketing header.
          11237, // SitesmithsTeam@expedia.com : AmexProper marketing header.
          10921, // SitesmithsTeam@expedia.com : MasterCard marketing header.
          11776, // SitesmithsTeam@expedia.com : Cimb marketing header.
          8455,  // CorporateBenefits abacus experiment
          10406, // pukarde : OpenSearch in corewizard
          10120, // enable date based search (date picker) for Cruise
          11046, // Rail Tab
          11841, // Reduced Padding on mobile
          11842, // Reduced Font Size on mobile
          11872,  // Radio buttons on mobile
          11636, //Cars_CMAYoungDriver: Add driver age component to cars tab in wizard
          11877, //Cars_CMAPackagesYoungDriver: Add driver age component to packages tabs in wizard
          12234,  // Remove 30 days booking limit for cars
          12609,  // DFP Native promo module on e.com AWS home page
          10188,   // Intent Media Exit Units on Package Launch Tabs
          12087,  // smyrick: Nautilus - open search bar in the header
          12963,   // Ab Test for US AWS homepage AA test
          12978,   // Ab Test for AU AWS homepage AA test
          11714,  // TAAP alert bell GBV To Next Tier message
          13119,   // Rail Tab for DE
          14318,   // Rail Tab for IT
          12571, // AB Test for TUV reassurance messaging
          13429,	// MOBILE_BACKTAB_ECOM_HP_HOTELS - mingle story 17517
          13430,	    // MOBILE_BACKTAB_ECOM_HP_FLIGHTS - mingle story 17517
          13543,  // MTTLaunchpad_AirNZ_pointMessage Triple Airpoint Message for AirNz
          13851, //AirNZ SSO abacus experiment
          14261,         //Ab test for Global Signin Signup Loader
          13985, // Cruise_CheapticketsOnStorefront: Cheaptickets integration into BEX shopping path for Cruise
          13986,  // Cruise_DirectStorefrontTrafficToBexPages: Orbitz integration into BEX shopping path for Cruise
          14541,   // EPC footer link more visible
          14592,  // Mobile Download Banner for header
          14135,  // App Install GROAppInstallFooterBEXMTB
          15252,  // App Install MAD Footer
          16064,  // mad_footer_placement_comet
          16065,  // mad_footer_placement_bex
          14763,   // Mobile Download Banner COMET brands
          14764,    //Header text change for Air Newzealand CA and US POS
          15108,    // AirNZ header redesign
          15190,   // Test off notification bell for all users
          14767,    //AirNZ HK header
          14693,   //AAG and Expedia JP Car trawler test for showing and hiding Car Rental
          15538,    //AAG and Expedia MY - enable Malay language support - showing and hiding language text from the header
          15174,   // spteam@expedia.com : My List Name Alternatives
          15714,    //Orbitz App Download Banner
          15749,    // enable passenger selection (pax) for Cruise
          15805,      //App download banner from placement service
          15904,    //SBC for expedia BR
          16316,   //Remove secondary banner on Dtop
          16000  // Adding Travel Tips new link to header

      ];


      abTestRegistry = union_arrays(abTestRegistry, abTestRegistryOverride);

      return abTestRegistry;
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/abTestRegistryOverride', 'main');
    }
});

define('gc/abTest', ['jquery', 'gc/pageModel', 'cookies', 'gc/errorLogging', 'env'], function($, pageModel, Cookies, errorLogging, env) {

    var EVALUATE_URI = '/api/bucketing/v1/evaluateExperiments/';
    var LOG_URI = '/api/bucketing/v1/evaluateExperimentsAndLog/';
    var DOMAIN = '//' + window.location.host;

    var user = pageModel.user;
    var tpid = pageModel.site.tpid;
    var eapid = pageModel.site.eapid;
    var testMap = {};
    $.each(pageModel.abTests, function(index, test) {
        testMap[test.id] = test;
    });


    var instance = {
        _abTestMap: testMap,
        _loggedTests: [],

        /*

        Returns the variant of an Abacus ID.
        If 'get' returns 0, use doneCallback(experiment) to get the variant asynchronously or call get a second time.

        abtestId: integer
        doneCallback: function(experiment) experiment example : {"id":6739,"name":"CWTAOneTwoCharTriggered","value":1,"instanceId":33429}
        isToBeLogged: boolean
         */
        get : function(abtestId, doneCallback, isToBeLogged) {
          try {
            var test = {id:abtestId, value:0};
            if (!user.guid || !tpid || !abtestId) {
              return test;
            }
            if(typeof abtestId == 'string') {
                abtestId = parseInt(abtestId);
            }
            var testCached = false;
            if(!!this._abTestMap[abtestId]) {
                test = this._abTestMap[abtestId];
                testCached = true;
            }

            if(isToBeLogged) {
                this.log(abtestId, doneCallback);
            } else if(!testCached) {
                var evaluationServiceUrl = getDctkUrl(EVALUATE_URI, abtestId);
                $.ajax({
                    url: evaluationServiceUrl,
                    dataType: 'json',
                    timeout: 1000
                }).then(function(response) { // if success
                    logErrors(response);
                    if(response.evaluatedExperiments && response.evaluatedExperiments.length>0) {
                        test = response.evaluatedExperiments[0];
                        if(!instance._abTestMap[test.id]){
                            instance._abTestMap[test.id] = test;
                        }
                    }
                    if (typeof doneCallback == 'function') {
                        doneCallback(test);
                    }
                }, function(response) {
                    logErrors(response);
                    doneCallback(responseForFailedEvaluation(abtestId))
                }); // if fail
            } else if (typeof doneCallback == 'function') {
                doneCallback(test);
            }

            return test;
          } catch (e) {
            errorLogging.logError(e, 'header', 'gc/abTest', 'get');
          }
        },

        /*

         Returns the variant of an Abacus ID AND log it.
         If 'log' returns 0, use doneCallback(experiment) to get the variant asynchronously or call get a second time.

         abtestId: integer
         doneCallback: function
         */
        log : function(abtestId, doneCallback) {
            var self = this;
            if (!user.guid || !tpid || !abtestId) {
              return;
            }
            if(typeof abtestId == 'string') {
                abtestId = parseInt(abtestId);
            }

            var test = {id:abtestId, value:0};
            var logginServiceUrl = getDctkUrl(LOG_URI, abtestId);
            $.getJSON(logginServiceUrl)
            .then(function(response) {// if success

                logErrors(response);
                if(response.evaluatedExperiments && response.evaluatedExperiments.length>0) {
                    test = response.evaluatedExperiments[0];
                    instance._loggedTests[test.id] = test;
                    if(!instance._abTestMap[test.id]){
                        instance._abTestMap[test.id] = test;
                    }
                }

                if (typeof doneCallback == 'function' ) {
                    var doneCallbackString = doneCallback.toString();
                    var loggingCallbackString = self.loggingCallback.toString();
                    if(doneCallbackString != loggingCallbackString) {
                        // prevent this being called again if people pass in loggingCallback as the doneCallBack.
                        doneCallback(test);
                    }
                }
            }, logErrors); // if fail

        },

        /*

         Overrides the variant of an Abacus ID.
         If 'log' returns 0, use doneCallback(experiment) to get the variant asynchronously or call get a second time.

         testId: integer
         variant: the variant number (0=control, 1=variant1, etc)
         */
        override: function(testId, variant) {
            var overrideValue = [testId, '0', variant].join('|');
            var newAbov = _.compact([Cookies.get('abov'), overrideValue]).join(':');
            Cookies.set('abov', newAbov);
        },

        loggingCallback: function(test){
          if(window.dctk && window.dctk.onReady) {
              dctk.onReady(function () {
                  test['tpid'] = tpid;
                  test['eapid'] = eapid;
                  test['guid'] = user.guid;
                  delete test["name"];
                  dctk.logExperiment(test);
              });
          }
        }
    };

    function logErrors(response) {
        // Only log errors on local environment to keep console clean
        if (env.version === 'local' && response.message && response.message.type && console !== 'undefined') {
            var experimentErrors = response.evaluatedExperiments.filter(function(experiment) {
                return experiment.hasOwnProperty('message')
            }).map(function(experimentWithErrors) {
                return "Experiment " + experimentWithErrors.id + " errored [" + experimentWithErrors.message.id + "] - " + experimentWithErrors.message.description
            });
            var errorType = response.message.type;
            if (errorType.indexOf('WARN') > -1 || errorType.indexOf('ERROR') > -1) {
                console.log("abTests error: [" + response.message.id + "] " + response.message.description, experimentErrors);
            }
        }
    }

    function getDctkUrl(serviceURI, abtestId) {
        return  DOMAIN + serviceURI +
                '?guid=' + user.guid +
                '&tpid=' + tpid +
                '&eapid=' + eapid +
                '&id=' + abtestId;
    }

    function responseForFailedEvaluation(abTestId) {
        return {
            id: abTestId,
            name: 'INVALID_EXPERIMENT_NAME',
            value: 0,
            instanceId: 99990
        }
    }

    return instance;

});

/* get the model.json and publish it as an AMD module for anyone to use */
require(['jquery', 'gc/abTestRegistry', 'env', 'gc/errorLogging'], function($, abTestRegistry, env, errorLogging)
{
    function getUrlParameterValue(name) {
        var query = window.location.search;
        var queryToken = name + '=';
        var result;

        if (query.indexOf(queryToken) > -1) {
            result = '&' + queryToken + query.split(queryToken)[1].split('&')[0];
        } else {
            result = '';
        }

        return result;
    }

    function buildPageModel(model) {
        try {
            var pageModel = model;

            pageModel.hasUser = function() {
                return !!pageModel.user;
            };

            pageModel.isUserAnonymous = function() {
                return pageModel.hasUser() && pageModel.user.userStatus && pageModel.user.userStatus.match(/^ANONYMOUS$/i);
            };

            pageModel.isUserIdentified = function() {
                return pageModel.hasUser() && pageModel.user.userStatus && pageModel.user.userStatus.match(/^(AUTHENTICATED|IDENTIFIED)$/i);
            };

            pageModel.isUserAuthenticated = function() {
                return pageModel.hasUser() && pageModel.user.userStatus && pageModel.user.userStatus.match(/^AUTHENTICATED$/i);
            };

            _pageModel = pageModel;
        } catch (e) {
            errorLogging.logError(e, 'pagemodel', 'gc/pageModel', 'buildPageModel');
        }
    }

    function definePageModel() {
        define('gc/pageModel', [], function() {return _pageModel;});
    }

    function logAjaxFailure(jqXHR, textStatus, errorThrown) {
        // build pageModel based on defaults
        buildPageModel(_pageModel);
        errorLogging.logError(errorThrown, 'pagemodel', 'gc/pageModel', '$.ajax', 'Ajax Failed: ' + textStatus + ' : ' + errorThrown);
        if (typeof console !== 'undefined') {
            console.warn('failed to get model.json: [' + textStatus + '] [' + errorThrown + ']');
        }
    }

      try {
        var abtestIdParams = getUrlParameterValue('langid') + getUrlParameterValue('locale') + getUrlParameterValue('currency');
        var _pageModel = {
          "site": {
            "id": 0,
            "tpid": 0,
            "eapid": 0,
            "brandName": "",
            "companyCode": 0,
            "defaultDomain": "",
            "langId": 0,
            "locale": "",
            "resolvedCurrency": "USD"
          },
          "user": {
            "guid": "",
            "userStatus": "ANONYMOUS",
            "hasGroups": false,
            "arranged": false
          },
          "abTests": []
        };



        for (var i = 0; i < abTestRegistry.length; i ++) {
          if (abtestIdParams.indexOf(abTestRegistry[i]) === -1) {
            abtestIdParams += "&id=" + abTestRegistry[i];
          }
        }

        if (window.__pageModel) {
          definePageModel(buildPageModel(window.__pageModel));
        } else {
          $.ajax({
              url: '//' + window.location.host + '/gc/model.json',
              data: abtestIdParams,
              dataType: 'json',
              cache: false,
              timeout: env.pageModelTimeout
          })
          .done(buildPageModel)
          .fail(logAjaxFailure)
          .always(definePageModel);
        }

      } catch (e) {
        errorLogging.logError(e, 'pagemodel', 'gc/pageModel', 'main');
      }

});

/*  
    Read data-tab attribute from the header-container (set by attributes on the JSP tag)
    Set the tab with the matching id to the selected tab by adding the selected-tab class to it.
*/

require(['gc/pageModel', 'jquery'], function(pageModel, $) {
  var tabId = $('#header-container').data('tab');

  if (tabId !== undefined && tabId !== '') {
    $('ul.utility-nav > li').each(function() {
      $(this).removeClass('selected-tab');
    });
    $('#' + tabId).addClass('selected-tab');
  }

  if(pageModel.site && pageModel.site.resolvedCurrency){
    $("#header-currency-menu .selected-item").text(pageModel.site.resolvedCurrency);
    $("#currency-"+pageModel.site.resolvedCurrency).hide();
  }
});

(function() {
  define('gc/sp-tray-item-prototype', ['jquery'], function($) {

    return {
      set: function(attr, value, updateUI) {
        var update = false;

        if (this.attributes[attr] && this.attributes[attr] === value) {
          return;
        } else {
          this.attributes[attr] = value;
          if (updateUI) this.updateDisplay();
        }
      },

      get: function(attr) {
        var returnValue = null;
        if (this.attributes[attr]) returnValue = this.attributes[attr];

        return returnValue;
      },

      localizedAsOfKey: function() {
        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          return 'asOfTime';
        } else {
          return 'asOfDate'; // default
        }
      },

      insertBefore: function($el) {
        this.$el.insertBefore($el);
      },

      appendTo: function($el) {
        $el.append(this.$el);
      },

      removeFromTray: function() {
        this.$el.remove();
      },

      moveToIndex: function(index) {
        this.trayIndex = index;
      },

      updateDisplay: function() {
        var newContent = $($.trim(this.template(this.attributes))).find('.item-link');
        this.$el.empty().html(newContent);

        if (this.trayIndex === 1) this.$el.addClass('first');
      }
    };

  });

})();

(function() {

  define('gc/sp-car-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      // var lastSeen = self.localizer(self.locStrings.asOfDate, [data.lastSeenDate]);
      var carTitleString = (data.pickupRegionType == "AIRPORT")
        ? strings.carsAt
        : strings.carsNear;

      carTitleString = carTitleString.replace('{{destination}}', data.pickupLocation);

      var templateString = '<li class="scratchpad-item">'
          + '<a href="' + data.deepLink + '" class="item-link" data-onclick="">'
          + '<div class="item-data">'
          + '<span class="item-img-icon">'
          + '<span class="icon icon-carsalt"></span>'
          + '</span>'
          + '<h4 class="item-title">' + carTitleString + '</h4>'
          + '<p class="item-date">' + data.pickupDate + ' - ' + data.dropOffDate + '</p>'
          + '<p class="item-dummy item-nested"></p>'
          + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' + strings.daily
          + '<p class="item-nested">' + data.lastSeen + '</p></div>'
          + '</div>'
          + '</a>'
          + '</li>';


      return templateString;
    };
    
    var module = function(data) {
      var prefix = '';
      var locStrings = scratchpadTray.view.strings.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      var locStrings = STRINGS.item;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'carSearch';
      this.attributes = data.carSearch;

      //For Title
      if (this.get('pickupRegionType') == "AIRPORT") {
        this.set('txtPreLocation', locStrings.carsAt.replace('{{destination}}', this.get('pickupLocation')));
      }else
      {
        this.set('txtPreLocation', locStrings.carsNear.replace('{{destination}}', this.get('pickupLocation')));
      }

      // price module
      if (!this.get('price')) {
        this.set('price', '');
        this.set('lastSeen', 'See price');
      } else {
        var priceFromString = locStrings.from.replace('{{itemPrice}}', this.get('price'));
        this.set('price', priceFromString);

        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
        } else {
          this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
        }
      }
      // generating html using template
      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;


    return module;
  });

})();

(function() {

  define('gc/sp-cruise-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {

        var destination = strings.allDestinations;
        
        if (data.destination) {
            destination = data.destination;
        }
            
        var departureDate = strings.allMonths;
        
        if (data.departureDate) {
            departureDate = data.departureDate;
        }
                   
        var templateString = '<li class="scratchpad-item">'
          + '<a href="' + data.deepLink + '" class="item-link" data-onclick="">'
          + '<div class="item-data">'
          + '<span class="item-img-icon">'
          + '<span class="icon icon-cruisealt"></span>'
          + '</span>'
          + '<h4 class="item-title">' + destination + '</h4>'
          + '<p class="item-date">' + departureDate + '</p>'
          + '<p class="item-dummy item-nested"></p>'
          + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' + strings.perNight
          + '<p class="item-nested">' + data.lastSeen + '</p></div>'
          + '</div>'
          + '</a>'
          + '</li>';

      return templateString;
    };
    
    var module = function(data) {
      var prefix = '';
      var locStrings = scratchpadTray.view.strings.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      var locStrings = STRINGS.item;

      if (!data.product) return; 

      this.type = 'cruiseSearch';
      this.attributes = data.cruiseSearch;

      // price module
      if (!this.get('price')) {
        this.set('price', '');
        this.set('lastSeen', 'See price');
      } else {
        var priceFromString = locStrings.from.replace('{{itemPrice}}', this.get('price'));
        this.set('price', priceFromString);

        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
        } else {
          this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
        }
      }
      // generating html using template
      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;


    return module;
  });

})();

(function() {

  define('gc/sp-flight-details-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      var legCount = data.legs.length;
      var legsHtml = '';
      var i = 0;

      for (i; i < legCount; i++) {
        var leg = data.legs[i];
        var imageUrl = '//images.trvl-media.com/media/content/expus/graphics/static_content/fusion/v0.1b/images/airlines/s/';
        var airlineImageFileName = 'multiple_airlines_logo';
        var airlineLogoAlt = strings.multiAirlineAltText;
        var fromTo = strings.fromToAirports.replace('{{departureAirportCode}}', leg.departureAirportCode).replace('{{arrivalAirportCode}}', leg.arrivalAirportCode);
        var timeRange = strings.fromToTime.replace('{{startTime}}', leg.departureTime ).replace('{{endTime}}', leg.arrivalTime);
        var legSeparator = '';

        if (i > 0) legSeparator = ' item-group-gap';

        // setting number of days
        var numberOfDays = (leg.numberOfDays)
          ? ' <span class="number-of-days">+' + leg.numberOfDays + '</span>'
          : '';

        // setting image url
        if (leg.airlineImageFileName) {
          airlineImageFileName = leg.airlineImageFileName;
          airlineLogoAlt = leg.airlineName + strings.airlineLogoAltText;
        }

        imageUrl = imageUrl + airlineImageFileName + '_sq.jpg';

        legsHtml = legsHtml
          + '<span class="item-img-icon' + legSeparator + '">'
          +   '<img src="' + imageUrl + '" alt="' + airlineLogoAlt + '" class="image" aspectRatio="1-1">'
          + '</span>'
          + '<h4 class="item-title' + legSeparator + '">' + fromTo + '</h4>'
          + '<p class="item-date">'
          +   '<span class="departure-date">' + leg.departureDate + '</span><!--'
          +   '--><span class="time-range">' + timeRange + '</span>'
          +   numberOfDays
          + '</p>';
      }

      var templateString = '<li class="scratchpad-item flight-detail">'
          + '<a href="' + data.deepLinkUrl + '" class="item-link" data-onclick="">'
          +   '<div class="item-data">'
          +     legsHtml
          +     '<div class="item-price-urgency"><strong class="price">' + data.formattedPricePerPerson + '</strong>'
          +     '<p class="item-nested">' + data.lastSeen + '</p></div>'
          +   '</div>'
          + '</a>'
          +'</li>';

      return templateString;
    };

    var module = function(data) {
      var prefix = '';
      var locStrings = STRINGS.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'flightDetail';
      this.attributes = data.flightDetail;

      // price module
      if (!this.get('formattedPricePerPerson')) {
        this.set('formattedPricePerPerson', '');
        this.set('lastSeen', 'See price');
      } else {
        this.set('price', this.get('formattedPricePerPerson'));
        // var lastSeenString = locStrings[this.localizedAsOfKey()].replace('####', this.get('lastSeenDate'));

        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
        } else {
          this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
        }
      }

      // creating link url
      prefix = /\?/.test(this.attributes.url) ? '&' : '?';
      this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'FD'));
      this.set('deepLinkUrl', (this.get('url') + this.get('rfrrString')));

      // generating html using template
      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;


    return module;
  });

})();

(function() {

  define('gc/sp-flight-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'],  function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      var templateString = '<li class="scratchpad-item">'
        + '<a href="' + data.deepLinkUrl + '" class="item-link" data-onclick="">'
          + '<div class="item-data">'
            + '<span class="item-img-icon">'
              + '<span class="icon icon-flightsalt"></span>'
            + '</span>'
            + '<h4 class="item-title">' +data.airportToAirport+ '</h4>'
            + '<p class="item-date">' + data.departureDate + data.returnDate + '</p>'
            + '<p class="item-info item-nested">' + data.routeType + '</p>'
            + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' 
            + '<p class="item-nested">' + data.lastSeen + '</p></div>'
          + '</div>'
        + '</a>'
      + '</li>';

      return templateString;
    };
    
    var module = function(data) {
      var prefix = '';
      var locStrings = STRINGS.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'flight';
      this.attributes = data.flight;

      var airportToAirport = locStrings.fromToAirports
        .replace('{{departureAirportCode}}', this.get('departureAirportCode'))
        .replace('{{arrivalAirportCode}}', this.get('arrivalAirportCode'));

      this.set('airportToAirport', airportToAirport);

      if (!this.get('price')) {
        this.set('price', '');
        this.set('lastSeen', 'See price');
      } else {
        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeen')));
        } else {
          this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeen')));
        }

        var priceFromString = locStrings.from.replace('{{itemPrice}}', this.get('price'));
        this.set('price', priceFromString);
      }

      prefix = /\?/.test(this.attributes.deepLinkUrl) ? '&' : '?';

      if (this.get('returnDate')) {
        this.set('returnDate', (' - ' + this.get('returnDate'))); // LOC (-)
      } else {
        this.set('returnDate', '');
      }

      this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'FS'));
      this.set('deepLinkUrl', (this.get('deepLinkUrl') + this.get('rfrrString')));
      
      if (this.get('routeType')) {
        var newType = this.get('routeType')
          .replace('ROUND_TRIP', locStrings.roundTrip)
          .replace('ONE_WAY', locStrings.oneWay);
        this.set('routeType', newType);
      }

      this.$el = $($.trim(this.template(this.attributes, locStrings)));
      
      if (!this.get('departureDate')) {
        this.$el.addClass('dateless');
      } else if (this.get('price') === '') {
        this.$el.addClass('priceless');
      }
    };

    module.prototype = PROTO;


    return module;
  });

})();

(function() {

  define('gc/sp-hotel-details-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      var templateString =   '<li class="scratchpad-item">'
        + '<a href="' + data.deepLinkUrl + '" class="item-link" data-onclick="">'
          + '<div class="item-data">'
            + '<span class="item-img-icon">'
              + '<img src="//images.trvl-media.com' + data.thumbnailUrl + '" alt="' + data.hotelName + '" class="image" aspectRatio="1-1">'
            + '</span>'
            + '<h4 class="item-title">' + data.hotelName + '</h4>'
            + '<p class="item-date">' + data.checkInDate + ' - ' + data.checkOutDate + '</p>' // LOC (-)
            + '<p class="item-watches item-nested">&nbsp;</p>'
            + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' 
            + '<p class="item-nested">' + data.lastSeenDate + '</p></div>'
          + '</div>'
        + '</a>'
      + '</li>';

      return templateString;
    };
    
    var module = function(data) {
      var prefix = '';
      var locStrings = STRINGS.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'hotel';
      this.attributes = data.hotel;
      
      if (!this.get('price')) {
        this.set('price', '');
        this.set('lastSeenDate', locStrings.seePrice);
      } else {
        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeenDate', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
        } else {
          this.set('lastSeenDate', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
        }
      }

      prefix = /\?/.test(this.get('deepLinkUrl')) ? '&' : '?';

      this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'HI'));
      this.set('deepLinkUrl', (this.get('deepLinkUrl') + this.get('rfrrString')));

      if (this.get('thumbnailUrl')) {
        this.set('thumbnailUrl', (this.get('thumbnailUrl').replace('_s', '_t')));
      }


      this.$el = $($.trim(this.template(this.attributes, locStrings)));

      // TODO: make this data that the template uses to assign classes
      if (!this.get('checkInDate') || !this.get('checkOutDate')) {
        this.$el.addClass('dateless');
      } else if (this.get('price') === '') {
        this.$el.addClass('priceless');
      }
    };

    module.prototype = PROTO;

    return module;
  });

})();

(function() {

  define('gc/sp-hotel-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      var priceElement = (data.amount)
          ? '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' + '<p class="item-package-message">' + strings.hotelSearchAvgPerNight + '</p>' + '<p class="item-nested">' +  strings.asOfDate.replace('{{lastSeenDate}}', data.lastSeenDate)  + '</p></div>'
          : '';

      var templateString = '<li class="scratchpad-item">'
          + '<a href="' + data.deepLinkUrl + '" class="item-link" data-onclick="">'
            + '<div class="item-data">'
              + '<span class="item-img-icon"><span class="icon icon-hotelsalt"></span></span>'
              + '<h4 class="item-title">' + strings.hotels.replace('{{destination}}', data.destination) + '</h4>'
              + '<p class="item-date">' + strings.fromToDate.replace('{{startDate}}', data.checkInDate).replace('{{endDate}}', data.checkOutDate) + '</p>'
              + '<p class="item-watches item-nested">&nbsp;</p>'
              + priceElement
            + '</div>'
          + '</a>'
        + '</li>';

      return templateString;
    };
    
    var module = function(data) {
      var prefix = '';
      var locStrings = STRINGS.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'hotelSearch';
      this.attributes = data.hotelSearch;
      this.set('viewCount', 0);

      prefix = /\?/.test(this.get('deepLinkUrl')) ? '&' : '?';

      this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'HS'));
      this.set('deepLinkUrl', (this.get('deepLinkUrl') + this.get('rfrrString')));

      if (this.get('thumbnailUrl')) {
          this.set('thumbnailUrl', (this.get('thumbnailUrl').replace('_s', '_t')));
      }

      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;

    return module;
  });

})();

(function() {

  define('gc/sp-package-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {
      var productDescription = strings.packageIncludes;
      var productName = strings.packages.replace("{{packageDestination}}", data.packageDestination);


      var templateString = '<li class="scratchpad-item">'
        + '<a href="' + data.deepLinkUrl + '" class="item-link" data-onclick="">'
        + '<div class="item-data">'
        + '<span class="item-img-icon">'
        + '<span class="icon icon-packagesalt"></span>'
        + '</span>'
        + '<h4 class="item-title">' + productName + '</h4>'
        + '<p class="item-date item-nested">' + data.departureDate + data.returnDate + '</p>'
        + '<p class="item-info item-nested">' + productDescription + '</p>'
        + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' + '<p class="item-package-message">' + strings.perPerson +'</p><p class="item-package-message">' + data.lastSeen  + '</p></div>' // LOC
        + '<span class="item-img-icon">'
        + '</span>'
        + '</div>'
        + '</a>'
        + '</li>';

      return templateString;
    };

    var module = function(data) {
      var prefix = '';
      var locStrings = STRINGS.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'package';
      this.attributes = data.packages;

      if (!this.get('price')) {
        this.set('price', '');
        this.set('lastSeen', 'See price');
      } else {
        var priceFromString = locStrings.from
          .replace('{{itemPrice}}', this.get('price'));

        if (this.get('dateTimeFormatType') === "SHORT_TIME") {
          this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeen')));
        } else {
          this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeen')));
        }

        this.set('price', priceFromString);
      }

      if (this.get('returnDate')) {
        this.set('returnDate', (' - ' + this.get('returnDate'))); // LOC (-)
      } else {
        this.set('returnDate', '');
      }

      prefix = /\?/.test(this.attributes.deepLinkUrl) ? '&' : '?';

      this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'PS'));
      this.set('deepLinkUrl', (this.get('deepLinkUrl') + this.get('rfrrString')));

      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;


    return module;
  });

})();

;(function() {

  define('gc/scratchpadtrayitem', [
    'gc/sp-hotel-details-item',
    'gc/sp-hotel-search-item',
    'gc/sp-flight-details-item',
    'gc/sp-flight-search-item',
    'gc/sp-package-search-item',
    'gc/sp-car-details-item',
    'gc/sp-car-search-item',
    'gc/sp-cruise-search-item',
    'gc/sp-activity-search-item',
    'gc/sp-activity-details-item'
  ], function(HotelDetail, HotelSearch, FlightDetail, FlightSearch, PackageSearch, CarDetail, CarSearch, CruiseSearch, activitySearch, activityDetail) {

    var units = {
      validateItemLob: function(rawItem) {
        return rawItem.hasOwnProperty('product');
      },
      validateItemActionType: function(rawItem) {
        return rawItem.hasOwnProperty('type');
      },
      buildCompoundItemType: function(rawItem) {
        return rawItem.product + '-' + rawItem.type;
      }
    };

    var compositions = {
      isSourceDataValid: function(rawItem) {
        return (
          units.validateItemLob(rawItem)
          && units.validateItemActionType(rawItem)
        );
      },

      determineSourceDataType: function(rawItem) {
        return (this.isSourceDataValid(rawItem))
          ? (units.buildCompoundItemType(rawItem) || 'NOT-FOUND')
          : { /* TODO: MAKE A DEFAULT ITEM */};
      }
    };


    return function(config) {
      var models = {
        'HOTEL-DETAIL': HotelDetail,
        'HOTEL-SEARCH': HotelSearch,
        'AIR-DETAIL': FlightDetail,
        'AIR-SEARCH': FlightSearch,
        'PACKAGE-SEARCH': PackageSearch,
        'CAR-DETAIL': CarDetail,
        'CAR-SEARCH': CarSearch,
        'CRUISE-SEARCH': CruiseSearch,
        'ACTIVITY-SEARCH': activitySearch,
        'ACTIVITY-DETAIL': activityDetail
      };
      var type = compositions.determineSourceDataType(config);

      return new models[type](config);
    };
  });

})();

;(function(GLOBAL) {

  var scratchpadApiName = (/localhost/.test(window.location))

  define('gc/scratchpadtraycontroller', ['gc/userhistoryapi', 'gc/scratchpadtrayitem', 'gc/abTest', 'uitk'], function(API, TrayItem, abTest, uitk) {
    return {

      requiresHistory: true,
      init: function(view) {
        this.view = view;

        return this
          .buildRfrr()
          .bindListeners()
          .getCount();
      },
      buildRfrr: function() {
        var scratchpadLink = $('#header-history');
        var newHref = scratchpadLink.attr('href') + "?rfrr=SP.NoTray.SP";
        scratchpadLink.attr('href', newHref);
        return this;
      },
      bindListeners: function() {
        var self = this;

        this.view.on('click.tab', function() {
          self.logInteraction('Header.SP.Tray.Interaction');
        });

        uitk.subscribe('sp:count:newCount', function(msg, data) {
          self.handleCountSuccess(data.response);
        });

        uitk.subscribe('sp:count:fail', function(msg, data) {
          self.handleCountSuccess(data.response);
        });

        return this;
      },
      getCount: function() {
        var myListABValue = abTest.get(15174, null, true).value;
        if (myListABValue === 0 ) {
            API.getHistoryCount();
        } else {
            this.handleCountFail();
        }


        return this;
      },
     handleCountSuccess: function(data) {
        // data.count = 10; // TEMP HACK REMOVE SOON
        if (data && data.hasOwnProperty('count')) {
          this.view.badge.updateContent(data.count);

          $('.site-navigation .user-history-tab').css("margin-left","0px");
          return this;

        } else {
          this.handleCountFail();
        }

        return this;
      },
      handleCountFail: function(){
        this.view.badge.hide();
        $('.site-navigation .user-history-tab').css("margin-left","0px");
        return this;
      },
      logInteraction: function(tag) {
        if (window.dctk && window.dctk.onReady) {
          dctk.onReady(function () {
            dctk.omtr.eVar28 = tag;
            dctk.omtr.events = 'event80';
            dctk.omtr.linkTrackVars = "eVar28,events";
            dctk.omtr.linkTrackEvents = "event80,event81";
            dctk.omtr.tl(true,"o","RFRR Action Link");
          });
        }
        return this;
      },
      logExperimentExposure: function(id, bucket) {}
    }
  });

  define('gc/scratchpadtrayview', ['jquery', 'gc/abTest'/*, 'handlebars'*/], function($, abTest) {

    return {
      _callbacks: {},
      _$el: null,
      init: function() {
        return this
          ._captureEls()
          ._captureStrings()
          ._captureTemplates()
          ._bindClickHandlers();
      },
      on: function(message, callback) {
        if (typeof callback === 'function') {
          this._callbacks[message] = this._callbacks[message] || [];
          this._callbacks[message].push(callback);
        }

        return this;
      },
      trigger: function(message, data) {
        var callbacks = this._callbacks[message] || [];
        // while (callbacks.length) { callbacks.shift()(data); }
        for (var i = 0; i < callbacks.length; i++) {
          callbacks[i](data);
        }

        return this;
      },
      badge: {
        $el: null,
        strings: {},
        updateContent: function(newCount) {
          this
            ._updateCount(newCount)
            ._updateScreenReaderText(newCount);

          $('.site-navigation .user-history-tab').css("margin-left","0px");
          return this[(newCount > 0) ? 'show' : 'hide']();
        },
        show: function() {
          this.$el.css('display', 'inline-block');
          return this;
        },
        hide: function() {
          this.$el.hide();
          return this;
        },
        flareAnimation: function() {},
        bindClickHandlers: function(context) {},
        unbindClickHandlers: function() {},
        _updateCount: function(newCount) {
          this.$el.find('.count').text(newCount);
          return this;
        },
        _updateScreenReaderText: function(newCount) {

          var newText = (newCount === 1)
            ? this.strings.badgeSRSingle
            : this.strings.badgeSRMany.replace('{{count}}', newCount);

          this.$el.find('.badge-description').text(newText)

          return this;
        }
      },
      navAnchor: {
        $el: null,
        bindClickHandlers: function(context, withFirst) {
          if (withFirst) {
            this.bindFirstClickHandler(context);
          } else {
            this.bindDefaultClickHandler(context);
          }

          return this;
        },
        bindFirstClickHandler: function(context) {
          var self = this;
          var onceFunc = function() {
                context.trigger('click.tab.first')
                self.bindDefaultClickHandler(context);
              };

          this.$el
            .off('click')
            .on('click', onceFunc);

          return this;
        },
        bindDefaultClickHandler: function(context) {
          this.$el
            .off('click')
            .on('click', function() {
              context.trigger('click.tab')
            });

          return this;
        }
      },
      menu: {
        _state: {
          loading: true,
          items: []
        },
        $el: null,
        updateItemList: function(newItems) {
          if (newItems) this._state.items = this._state.items.concat(newItems);
          var $listEl = this.$el.find('.item-list');
          var i = 0;
          var l = this._state.items.length;

          $listEl.empty();
          for (i; i < l; i++) {
            this._state.items[i].appendTo($listEl);
          }

          return this.showListState();
        },
        showLoadingState: function() {},
        hideLoadingState: function(callback) {
          this._state.loading = false;
          this.$el.find('.loading-wrapper').fadeOut('fast');
          this.$el.find('.loader').removeClass('loading');

          this.$el.find('.loading-message').fadeOut('fast', callback);

          return this;
        },
        showEmptyState: function() {
          var self = this;
          var callback = function() {
                self.$el.find('.default-message').fadeIn();
              };

          this.hideLoadingState(callback);

          return this;
        },
        showListState: function() {
          var self = this;
          var callback = function() {
                self.$el.find('.item-list').fadeIn();
              };

          this.hideLoadingState(callback);

          return this;
        },
        bindClickHandlers: function(context) {},
        unbindClickHandlers: function() {}
      },
      tooltip: {
        _state: {},
        $el: null,
        template: null,
        reRender: function() {},
        show: function() {},
        hide: function() {},
        updateContent: function() {}
      },
      _captureEls: function() {
        this._$el = $('.user-history-tab.scratchpad');
        this.navAnchor.$el = this._$el.find('.nav-tab');
        this.badge.$el = this._$el.find('.sp-badge');
        this.menu.$el = $('.menu');
        this.tooltip.$el = $('');

        return this;
      },
      _captureStrings: function() {
        this.strings = JSON.parse(this._$el.attr('data-localized-content'));
        this.navAnchor.strings = this.strings.link;
        this.badge.strings = this.strings.badge;
        this.menu.strings = this.strings.menu;
        this.tooltip.strings = this.strings.tooltip;
        return this;
      },
      _captureTemplates: function() {
        this.menu.template = $('').html();
        this.tooltip.template = $('').html();

        return this;
      },
      _bindClickHandlers: function() {
        this.navAnchor.bindClickHandlers(this);
        return this;
      }
    }
  });

  require(['gc/scratchpadtraycontroller', 'gc/scratchpadtrayview', 'jquery'], function(spTray, view, $) {
    if(document.readyState == 'complete') {
      window.scratchpadTray = spTray.init(view.init());
    } else {
      $(window).on('load', function() {
        window.scratchpadTray = spTray.init(view.init());
      });
    }
  });

  require(['gc/abTest', 'jquery', 'gc/errorLogging', 'gc/headerMessages'], function(abTest, $, errorLogging, messages) {
      $(function(){
        if ($('.user-history-tab.scratchpad').length > 0) {
          if($('.user-history-tab.scratchpad').attr('data-localized-content')) {
            try {
              var parsedLocMessages = JSON.parse($('.user-history-tab').attr('data-localized-content'));

              if ($('.view-all-history.item-link').length > 0) {
                var viewScratchpadLink = $('.view-all-history.item-link');
                viewScratchpadLink.text(messages['spViewscratchpadlink']);
              }

              if ($('.greeting-message.loading-message').length > 0) {
                var loadingScratchpadElement = $('.greeting-message.loading-message');
                loadingScratchpadElement.text(messages['spLoadingGreeting']);
              }

              if ($('.sp-name').length > 0) {
                var scratchpadTray = $('.sp-name');
                // Have a control (My Lists) and three variant (Heart Lists, Lists, Heart My Lists) under test 15174
                var myListABValue = abTest.get(15174, null, true).value;
                var myListKey = "spHeaderLink";
                if (myListABValue > 0) {
                  if(myListABValue == 1 || myListABValue == 2) {
                    myListKey = "spHeaderVariantLink";
                  }
                  if(myListABValue == 1 || myListABValue == 3) {
                    scratchpadTray.before('<span class="icon icon-heart"></span>&nbsp;');
                  }
                }
                scratchpadTray.text(messages[myListKey]);
              }

            }
            catch (e) {
              errorLogging.logError(e, 'header', 'gc/scratchpadBranding', 'getScratchpadBranding');
            }
          }
        }
      });
      
  });

})(window);

(function() {

  var strings = {};

  require('jquery', function($) {
    
    if ($('.user-history-tab.scratchpad').length > 0) {
      if ($('.user-history-tab.scratchpad').attr('data-localized-content')) {
        strings = JSON.parse($('.user-history-tab.scratchpad').attr('data-localized-content'));
        define('gc/sp-tray-strings',[], function() { return strings; });
      }
    } 
  });

})();




(function() {
  var consts = {
    currentPath: window.location,
    defaultId: '-1',
    jsonpSuffix: '&format=jsonp&callback=?',
    prodCountEndpoint: '/userHistory/count?',
    labCountEndpoint: '/userHistory/count?',
    prodHistoryEndpoint: '/api/userhistory?',
    labHistoryEndpoint: '/api/userhistory?',
    lobQuery: function(carDetailsABTest) {
      if(carDetailsABTest === 1)
        return '&lobs=HOTEL_DETAIL&lobs=HOTEL_SEARCH&lobs=AIR_SEARCH&lobs=AIR_DETAIL&lobs=CAR_SEARCH&lobs=CAR_DETAIL&lobs=PACKAGE_SEARCH&lobs=CRUISE_SEARCH&lobs=ACTIVITY_SEARCH&lobs=ACTIVITY_DETAIL';

      return '&lobs=HOTEL_DETAIL&lobs=HOTEL_SEARCH&lobs=AIR_SEARCH&lobs=AIR_DETAIL&lobs=CAR_SEARCH&lobs=PACKAGE_SEARCH&lobs=CRUISE_SEARCH&lobs=ACTIVITY_SEARCH&lobs=ACTIVITY_DETAIL';
    }
  };


  // ///////////////////////////////////////////////////////////////////////////
  // TODO: Each unit function should have a unit test!
  // ///////////////////////////////////////////////////////////////////////////
  var units = {

    //isLab does not work well with multiple environments (int, trunk, prod, stress)
    isLab: function(url) {
      return /trunk/.test(url.hostname);
    },
    formatGuid: function(guid) {
      if (guid.split('-').length === 5) { return guid; }
      else {
        return [
          guid.substring(0, 8),
          guid.substring(8, 12),
          guid.substring(12, 16),
          guid.substring(16, 20),
          guid.substring(20)
        ].join('-')
      }
    },
    userIsAnon: function(user) {
      return user.userStatus === 'ANONYMOUS';
    },
    userHasGuid: function(user) {
      return user.hasOwnProperty('guid');
    },
    userHasTuid: function(user) {
      return user.hasOwnProperty('tuid') && user.tuid > 0;
    },
    userHasExpuid: function(user) {
      return user.hasOwnProperty('expUserId');
    },
    envCountEndpoint: function(isLab) {
      return (isLab)
        ? consts.labCountEndpoint
        : consts.prodCountEndpoint;
    },
    envHistoryEndpoint: function(isLab) {
      return (isLab)
        ? consts.labHistoryEndpoint
        : consts.prodHistoryEndpoint;
    },
    makeGuidParamString: function(guid, isLoggedin) {
      return (isLoggedin) ? '' : '&guid=' + guid;
    },
    makeTuidParamString: function(tuid) {
      return '&tuid=' + tuid;
    },
    makeExpuidParamString: function(expuid) {
      return '&expuserid=' + expuid;
    },
    makeLimitParamString: function(limit) {
      return 'l=' + (limit || 5);
    },
    makeSiteIdParamString: function(siteId) {
      return '&siteid=' + siteId;
    },
    extendRequestObjWithDefaults: function(url) {
      return {
        url: url,
        timeout: 5000
      }
    },
    extendRequestObjWithJSONP: function(url) {
      return {
        url: url + consts.jsonpSuffix,
        dataType: 'jsonp',
        timeout: 5000
      }
    }
  };


  // ///////////////////////////////////////////////////////////////////////////
  // Compositions exerice > 1 unit, prevent units from calling eachother
  // ///////////////////////////////////////////////////////////////////////////
  var compositions = {
    getUserExpuid: function(pageModel) {
      return (units.userHasExpuid(pageModel.user))
        ? pageModel.user.expUserId
        : consts.defaultId;
    },
    getUserTuid: function(pageModel) {
      return (units.userHasTuid(pageModel.user))
        ? pageModel.user.tuid
        : consts.defaultId;
    },
    getUserGuid: function(pageModel) {
      return (units.userHasGuid(pageModel.user))
        ? units.formatGuid(pageModel.user.guid)
        : consts.defaultId;
    },
    buildCountEndpoint: function(pageModel, env, carDetailsABTest) {
      return [
        units.envCountEndpoint(units.isLab(consts.currentPath)),
        units.makeGuidParamString(this.getUserGuid(pageModel), units.userHasTuid(pageModel.user)),
        units.makeTuidParamString(this.getUserTuid(pageModel)),
        units.makeExpuidParamString(this.getUserExpuid(pageModel)),
        units.makeSiteIdParamString(env.siteId),
        consts.lobQuery(carDetailsABTest)
      ].join('');
    },
    buildHistoryEndpoint: function(limit, pageModel, env, carDetailsABTest) {
      return [
        units.envHistoryEndpoint(units.isLab(consts.currentPath)),
        units.makeLimitParamString(limit),
        units.makeGuidParamString(this.getUserGuid(pageModel), units.userHasTuid(pageModel.user)),
        units.makeTuidParamString(this.getUserTuid(pageModel)),
        units.makeExpuidParamString(this.getUserExpuid(pageModel)),
        units.makeSiteIdParamString(env.siteId),
        consts.lobQuery(carDetailsABTest)
      ].join('');
    }
  };




  // /////////////////////////////////////////////////////////////////////////
  // API MODULE
  // Interface Methods:
  //  - getHistoryCount() => API (chainable)
  // -- TODO: unit test to verify interface methods are there
  // /////////////////////////////////////////////////////////////////////////
  define('gc/userhistoryapi', ['uitk', 'jquery', 'gc/pageModel', 'env', 'gc/abTest'], function(uitk, $, pageModel, env, abTest) {
    return {
      getHistoryCount: function() {
        this._makeNormalRequest(compositions.buildCountEndpoint(pageModel, env, abTest.get(10044).value))
          .done(function(data) {
            uitk.publish('sp:count:newCount', { src: this, response: data });
          })
          .fail(function(data) {
            uitk.publish('sp:count:fail', { src: this, response: data });
          });

        return this;
      },
      _makeNormalRequest: function(url) {
        // NOT chainable
        return $.ajax(units.extendRequestObjWithDefaults(url));
      },
      _makeJSONPRequest: function(url) {
        // NOT chainable
        return $.ajax(units.extendRequestObjWithJSONP(url));
      }
    };
  });

})();

(function() {

  define('gc/alertmenu-templates', ['handlebars', 'gc/alertmenu-strings'], function(handlebars, strings) {
    return {
      /* ================ Start Scratchpad/Nudge price change alerts ===========*/
      SPHCONEUPONLYV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up'><img src='/static/default/default/images/scratchpad/alerts-up-2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.upOne + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCUPONLYV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up'><img src='/static/default/default/images/scratchpad/alerts-up-2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.upMany + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCONEDOWNONLYV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon down'><img src='/static/default/default/images/scratchpad/alerts-down-2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downOne + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCDOWNONLYV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon down'><img src='/static/default/default/images/scratchpad/alerts-down-2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downMany + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCBOTHONEV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up-and-down'><img src='/static/default/default/images/scratchpad/alerts-up-down.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downOneUpOne + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCONEUPV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up-and-down'><img src='/static/default/default/images/scratchpad/alerts-up-down.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downManyUpOne + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCONEDOWNV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up-and-down'><img src='/static/default/default/images/scratchpad/alerts-up-down.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downOneUpMany + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      SPHCV2: strings.scratchpadPriceChanges !== undefined ? handlebars.compile("<div class='alert-icon up-and-down'><img src='/static/default/default/images/scratchpad/alerts-up-down.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.scratchpadPriceChanges.changes + " " + strings.scratchpadPriceChanges.downManyUpMany + " <a href='/scratchpad?rfrr=Header.Notif.SPNews' data-action='spDetailedNews'>" + strings.scratchpadPriceChanges.details + "</a></div></div>") : null,
      /* ================ End Scratchpad/Nudge price change alerts =============*/
      /* ================ Start Scratchpad default alerts  =====================*/
      spSignIn: strings.defaultAlerts !== undefined ? handlebars.compile("<div class='alert-body centered'><div class='alert-message'>" + strings.defaultAlerts.greeting + "<br><a href='/user/login?&ckoflag=0' data-action='spSignIn'>" + strings.defaultAlerts.signIn + "</a></div></div>") : null,
      spNudgeEnroll: strings.nudgeEnrollment !== undefined ? handlebars.compile("<div class='alert-icon'><img src='/static/default/default/images/scratchpad/alerts-mail-72.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.nudgeEnrollment.title + " " + strings.nudgeEnrollment.subtitle + " <a class='spAccessibleButtonLink' href='javascript:void(0)' data-action='spNudgeEnroll' data-trigger-delete='false'>" + strings.nudgeEnrollment.action + "</a></div></div>") : null,
      spBasicNews: strings.defaultAlerts !== undefined ? handlebars.compile("<div class='alert-icon updown'><img src='/static/default/default/images/scratchpad/alerts-up-down.png' alt=''></div><div class='alert-body'><div class='alert-message'><b>" + strings.defaultAlerts.somethingChanged + "</b> " + strings.defaultAlerts.foundUpdates + " <a href='/scratchpad?rfrr=Header.Notif.SP' data-action='spBasicNews'>" + strings.defaultAlerts.whatChanged + "</a></div></div>") : null,
      /* ================ End Scratchpad default alerts  =======================*/
      /* ================ Start Itin alerts  ===================================*/
      itinBouncedEmail: strings.itin !== undefined ? handlebars.compile("<div class='alert-icon'><img src='/static/default/default/images/scratchpad/alerts-yellowalert-2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.itin.bouncedEmail + " <a href='/trips'>" + strings.itin.bouncedEmailLink + "</a></div></div>") : null,
      /* ================ End Itin alerts  =====================================*/
      /* ================ Start Rewards alerts  ================================*/
      HOTELCOUPONAVAILABILITYV1: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/PBU_e5sdHr1e_a6ohXyMC7EmG2c=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-pluses.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.hotelCouponAvailability + " <a href='/Hotels?rfrr=Header.Notif.Rewards.ShopHotels'>" + strings.rewards.hotelCouponAvailabilityLink + "</a></div></div>") : null,
      HOTELCOUPONAVAILABILITYV2: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/PBU_e5sdHr1e_a6ohXyMC7EmG2c=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-pluses.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.hotelCouponAvailability + " <a href='/Hotels?rfrr=Header.Notif.Rewards.ShopHotels' target='_blank'>" + strings.rewards.hotelCouponAvailabilityLink + "</a></div></div>") : null,
      VIPCOUPONAVAILABILITYV1: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/PBU_e5sdHr1e_a6ohXyMC7EmG2c=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-pluses.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.VIPCouponAvailability + " <a href='/rewards/vipaccess?rfrr=Header.Notif.Rewards.ShopVIPHotels'>" + strings.rewards.VIPCouponAvailabilityLink + "</a></div></div>") : null,
      VIPCOUPONAVAILABILITYV2: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/PBU_e5sdHr1e_a6ohXyMC7EmG2c=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-pluses.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.VIPCouponAvailability + " <a href='/rewards/vipaccess?rfrr=Header.Notif.Rewards.ShopVIPHotels' target='_blank'>" + strings.rewards.VIPCouponAvailabilityLink + "</a></div></div>") : null,
      HOTELCOUPONEXPIRATIONV1: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/5I06PHhATI0lXQEOx2vVAuafZFs=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-warning.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.hotelCouponExpirationV1 + " <a href='/Hotels?rfrr=Header.Notif.Rewards.ShopHotelsExpiring'>" + strings.rewards.hotelCouponAvailabilityLink + "</a></div></div>") : null,
      HOTELCOUPONEXPIRATIONV2: strings.rewards !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/5I06PHhATI0lXQEOx2vVAuafZFs=/images.trvl-media.com/media/content/expus/graphics/other/rewards/icons/rewards-notification-warning.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>" + strings.rewards.hotelCouponExpirationV2 + " <a href='/user/account?selc=coupons&rfrr=Header.Notif.Rewards.VisitAcct'>" + strings.rewards.hotelCouponExpirationLinkV2 + "</a></div></div>") : null,
      /* ================ End Rewards alerts  ==================================*/

      /* ================ Start Expedia Extension alerts  =====================*/
      CHROMEEXTENSIONNEWS: strings.chromeExtensionNotification !== undefined ? handlebars.compile("<div class='alert-icon'><img src='https://thumbnails.trvl-media.com/0Dbq7G_eeuZEw2EOaZ1-vKCQafs=/images.trvl-media.com/media/content/shared/graphics/icons/chrome-web-store_icon_2x.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.chromeExtensionNotification.message + " <a id='extension-install-launch' href='javascript:void(0)' data-action='addChromeExtension' data-trigger-delete='true'>" + strings.chromeExtensionNotification.link + "</a></div></div>") : null,
      /* ================ End Expedia Extension alerts  =======================*/
      /* ================ Start Member deals messaging  ===================================*/

      /* ================ End Member deals messaging   =====================================*/
      /* ================ Start AARP alerts  ===================================*/
      AARPMEMBERLINK: strings.brandMessages !== undefined ? handlebars.compile("<div class='alert-icon' style='color:green'><span class='icon icon-infoalt' aria-hidden='true'></span></div><div class='alert-body'><div class='alert-message'>" + strings.brandMessages.switchToAarp + "</div></div>") : null,
      /* ================ End AARP alerts  =====================================*/

      /* ================ Start TAAP alerts ====================================*/
      TAAPWELCOMEMESSAGE: strings.taapMessages !== undefined ? handlebars.compile("<div class='taap-news-wrapper'><div class='taap-logo-white-icon'><span class='taap-center-helper'></span><img class='taap-logo' src='https://thumbnails.trvl-media.com/UYEB4tK2ze2ZFSagjOgxDuzbdvg=/images.trvl-media.com/media/content/expus/graphics/taap/taap-logo-white_40.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.taapMessages.welcomeMessage + " <a href='/TAAP-LearnMore?rfrr=Header.Notif.TAAPWelcome'>" + strings.taapMessages.welcomeMessageLink + "</a></div></div></div>") : null,
      TAAPGBVREMAININGNEWSSILVER: strings.taapMessages !== undefined ? handlebars.compile("<div class='taap-news-wrapper'><div class='taap-logo-white-icon'><span class='taap-center-helper'></span><img class='taap-logo' src='https://thumbnails.trvl-media.com/UYEB4tK2ze2ZFSagjOgxDuzbdvg=/images.trvl-media.com/media/content/expus/graphics/taap/taap-logo-white_40.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.taapMessages.gbvRemainingMessageSilver + " <a href='/TAAP/IncentivePlan?rfrr=Header.Notif.TAAPGBVNextTier'>" + strings.taapMessages.gbvRemainingLink + "</a></div></div></div>") : null,
      TAAPGBVREMAININGNEWSGOLD: strings.taapMessages !== undefined ? handlebars.compile("<div class='taap-news-wrapper'><div class='taap-logo-white-icon'><span class='taap-center-helper'></span><img class='taap-logo' src='https://thumbnails.trvl-media.com/UYEB4tK2ze2ZFSagjOgxDuzbdvg=/images.trvl-media.com/media/content/expus/graphics/taap/taap-logo-white_40.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.taapMessages.gbvRemainingMessageGold + " <a href='/TAAP/IncentivePlan?rfrr=Header.Notif.TAAPGBVNextTier'>" + strings.taapMessages.gbvRemainingLink + "</a></div></div></div>") : null,
      TAAPGBVREMAININGNEWSPLATINUM: strings.taapMessages !== undefined ? handlebars.compile("<div class='taap-news-wrapper'><div class='taap-logo-white-icon'><span class='taap-center-helper'></span><img class='taap-logo' src='https://thumbnails.trvl-media.com/UYEB4tK2ze2ZFSagjOgxDuzbdvg=/images.trvl-media.com/media/content/expus/graphics/taap/taap-logo-white_40.png' alt=''></div><div class='alert-body'><div class='alert-message'>" + strings.taapMessages.gbvRemainingMessagePlatinum + " <a href='/TAAP/IncentivePlan?rfrr=Header.Notif.TAAPGBVNextTier'>" + strings.taapMessages.gbvRemainingLink + "</a></div></div></div>") : null,
      /* ================ Start TAAP alerts ====================================*/

      /* ================ Start LX MIP alerts  ===================================*/
      FLIGHTMIPACTIVITYELIGIBIITY: strings.lxmip !== undefined ? handlebars.compile("<div class='alert-icon mip-lx'><img src='/static/default/default/images/crossSell/activity_bell.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>"+ strings.lxmip.lxFlightMIPActivityMsg +"<br><a href='/Activities' data-action='flightMIPActivity'>"+ strings.lxmip.lxFlightMIPActivityMsgCTC +"</a></div></div>") : null,
      FLIGHTMIPGTELIGIBIITY: strings.lxmip !== undefined ? handlebars.compile("<div class='alert-icon'><img src='/static/default/default/images/crossSell/busBellImage.png' alt=''></div></div><div class='alert-body'><div class='alert-message'>"+ strings.lxmip.lxFlightMIPGTMsg +"<br><a href='/lx/groundTransfers' data-action='flightMIPGT'>"+ strings.lxmip.lxFlightMIPGTMsgCTC +"</a></div></div>") : null

      /* ================ End LX MIP alerts  =====================================*/
    };
  });

})();

(function() {

  var strings = {};

  require('jquery', function($) {
    
    if ($('#user-alerts-menu').length > 0) {
      if ($('#user-alerts-menu').attr('data-localized-content')) {
        strings = JSON.parse($('#user-alerts-menu').attr('data-localized-content'));
        define('gc/alertmenu-strings',[], function() { return strings; });
      }
    } 
  });

})();

;(function() {

  define('gc/alertmenu-view', ['jquery', 'gc/pageModel', 'uitk'], function($, pageModel, uitk) {
    return {
      state: {
        legacyMode: false
      },
      $els: {
        headerBadge: null,
        menuWrapper: null,
        menuElement: null,
        scrollable: null
      },
      init: function(controller) {
        this.controller = controller;
        this.$els.menuWrapper = $('#user-alerts-menu');
        this.$els.menuElement = this.$els.menuWrapper.find('[data-control="menu"]');

        this.state.legacyMode = !(uitk
          && uitk.version
          && uitk.version.split('.')[0] === "v2");

          this.becomeMenu();

        // TODO: once scratchpad tray greeting is gone, call this.render() here

        return this;
      },
      reRender: function() {
        this.empty();

        var newHtml = '';
        var alertArray = this.controller.getAlerts();
        var i = 0;
        var l = this.controller.count();

        for (i; i < l; i++) {
          newHtml += alertArray[i].toDisplayString();
        }

        this.fill(newHtml);
        this.updateBadge(l);
        this._bindNewAlertLinks(this.state.legacyMode);
        this._bindNewAlertCloseButtons(this.state.legacyMode);
        return this;
      },
      toggle: function() {
        if (this.$els.menuWrapper.find('.menu').parent().hasClass('open')) {
          this.close();
        } else {
          this.open();
        }

        return this;
      },
      open: function(automatic) {
        var right = (this.state.legacyMode) ? "0.5em" : '-171.5px';
        this.$els.menuWrapper.find('.menu')
          .css({ 'right': right })
          .parent() // TODO: Find a way to get a class on this generated node
          .addClass('open');

        if (automatic) {
          this.controller.sendeVar28('Header.Notif.MenuAuto');
        } else {
          this.controller.sendeVar28('Header.Notif.MenuOpen');
        }

        return this;
      },
      close: function() {
        var right = (this.state.legacyMode) ? "0.5em" : '-195.5px';
        this.$els.menuWrapper.find('.menu')
          .css({ 'right': right }) // IDK Why, but this is what the UITK one does
          .parent() // TODO: Find a way to get a class on this generated node
          .removeClass('open');

        this.$els.menuWrapper.find('.bell-trigger-link') //added to ensure proper setting of aria-expanded on close
          .attr('aria-expanded', 'false');

        this.$els.menuWrapper.focus();

        this.controller.sendeVar28('Header.Notif.MenuClose');

        return this;
      },
      empty: function() {
        this.$els.scrollable.find('.alert-item:not(.default-alert-item)').remove();
        this.$els.scrollable.find('.default-alert-item').show();

        return this;
      },
      fill: function(newHtml) {
        var defaultItem = this.$els.scrollable.find('.default-alert-item');
        var i = 0;
        var l = this.controller.count();
        var curAlert = {};

        $(newHtml).insertBefore(defaultItem);

        for (i; i < l; i++) {
          curAlert = this.controller.at(i)
          curAlert.$el = $('#' + curAlert.uniqueId);
        }

        return this;
      },
      becomeMenu: function() {
        var self = this;

        if (this.state.legacyMode) this.$els.menuWrapper.addClass('legacy');
        $('.alerts-display-wrapper').show();
        $('.alerts-display-wrapper').attr('aria-hidden', 'false');

        this.$els.scrollable = this.$els.menuWrapper.find('.scrollable');
        this.$els.headerBadge = this.$els.menuWrapper.find('.badge');
        this.$els.headerBadge
          .click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.shop-nav > li').removeClass('open'); // TODO: Work with renee for real solution
            self.toggle();
          });

        this.$els.menuWrapper.addClass('visible');

        this.$els.menuElement.click(function() {
          if (self.$els.menuElement.parent().hasClass('open')) {
            self.controller.sendeVar28('Header.Notif.MenuClose');
          } else {
            self.controller.sendeVar28('Header.Notif.MenuOpen');
          }
        });

        this.updateBadge(this.controller.count());
        $('.alerts-display-wrapper').show();
        $('.alerts-display-wrapper').attr('aria-hidden', 'false');
        this._bindNewAlertLinks(this.state.legacyMode);

        return this;
      },
      updateBadge: function(count) {
        count = count || this.controller.count();
        if (!count && count !== 0) count = this.controller.count();
        if (count > 0) {
          this.$els.headerBadge
            .html(count)
            .show();
          if (count == 1) {
            $('#accessibleBadge')
            .html(window.accessibleBadgeMessage).attr('aria-hidden','false');
          } else {
            $('#accessibleBadge')
              .html(window.accessibleBadgeMessagePlural.replace('####',count)).attr('aria-hidden','false');
            }
        } else {
          this.$els.headerBadge.hide();
          $('#accessibleBadge')
            .html(window.accessibleBadgeMessagePlural.replace('####',count)).attr('aria-hidden','false');
        }

        return this;
      },
      _bindNewAlertLinks: function(legacy) {
        var self = this;

        if (pageModel.user.userStatus !== 'ANONYMOUS') {
          $('.spAccessibleButtonLink').attr('role', 'button');
          $('.spAccessibleButtonLink').on('keypress', function(e){ // so that role=button behaves like button https://gist.github.com/icaaq/3235454
            if (e.which === 32){
              e.preventDefault();
              $(this).trigger('click')
            }
          });
        }

        this.$els.menuWrapper.find('.alert-message a:not(.bound)') // To be universal we need to pass a class and a window.funcRef
          .addClass('bound')
          .click(function(event) {
            var $el = $(this);
            var func = window.alertMenuClickHandlers[$el.attr('data-action')];
            var uniqueId = $el.closest('.alert-item').attr('id');
            var alert = self.controller.pluckAlertByUniqueId(uniqueId);

            self.controller.sendeVar28('Header.Notif.CTAClick')

            if ($.isFunction(func)) func(event, alert);
            if ($el.attr('data-trigger-delete') !== 'false') {
              alert.deleteSelf(true);
              self.close().updateBadge(self.controller.count());
            }
          });

        return this;
      },
      _bindNewAlertCloseButtons: function(legacy) {
        var self = this;
        var newText = (legacy) ? 'x' : '';

        this.$els.menuWrapper.find('.close-button button:not(.bound)')
          .addClass('bound')
          // .text(newText)
          .click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            var uniqueId = $(this).closest('.alert-item').attr('id');
            var alert = self.controller.pluckAlertByUniqueId(uniqueId);


            self.controller.sendeVar28('Header.Notif.Dismiss.' + alert.raw.msgid);
            alert.deleteSelf(true);
            self.close().updateBadge(self.controller.count());
          });

        return this;
      },
      _bindTempNewAlertButtons: function(legacy) {
        var self = this;

        this.$els.menuWrapper.find('.btn-close:not(.bound)')
          .addClass('bound')
          .click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            var uniqueId = $(this).closest('.alert-item').attr('id');
            var alert = self.controller.pluckAlertByUniqueId(uniqueId);

            self.controller.sendeVar28('Header.Notif.Dismiss.' + alert.raw.msgid);
            alert.deleteSelf(true);
            self.close().updateBadge(self.controller.count());
          });

        this.$els.menuWrapper.find('.alert-message a:not(.bound)') // To be universal we need to pass a class and a window.funcRef
          .addClass('bound')
          .click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            var $el = $(this);
            var func = window.alertMenuClickHandlers[$el.attr('data-action')];
            var uniqueId = $el.closest('.alert-item').attr('id');
            var alert = self.controller.pluckAlertByUniqueId(uniqueId);

            self.controller.sendeVar28('Header.Notif.SP');

            if ($.isFunction(func)) func(event, alert);
            if ($el.attr('data-trigger-delete') !== 'false') {
              alert.deleteSelf(true);
              self.close().updateBadge(self.controller.count());
            }
          });

        return this;
      }
    };

  });

})();

/* global window, dctk  */

;(function() {
  var privateCounter = 50;
  // ===========================================================================
  // ========= ALERTS CORE JS OBJECT ===========================================
  // ===========================================================================
  define('gc/alertmenu', ['jquery', 'uitk', 'gc/pageModel', 'env', 'gc/alertmenu-item-model', 'gc/alertmenu-view', 'gc/abTest'], function($, uitk, pageModel, env, ItemModel, view, abTest) {

    return {
      menuView: view,
      _alerts: [],
      _endpoints: {
        userAlertsService: '/news/v1',
        expwebDelete: '/api/userhistory/clearNews',
        scratchpadOptions: '/api/userhistory/options',
        sendMeNotes: '/sendmenotes',
        loginRedirect: '/user/login?ckoflag=0&hsuc=&fram=&uurl=qscr%3Dredr%26rurl%3D%2Fscratchpad%3FsendMeNotes%3Dtrue'
      },
      omLock: true,
      queuedOmPixels: [],
      init: function() {
        var self = this;

        this.menuView.init(this);
        this.enableListeners();
        setTimeout(function() {
          self.omLock = false;
          self.sendQueuedOmPixels();
        }, 1000);

        this.fetchAndDisplayAlerts(true);

        this.wotifCheck().detectIE11();

        return this;
      },
      enableListeners: function() {
        var self = this;
        uitk.subscribe('alerts:empty', function() {
          self.getUserFlags();
        })
      },
      fetchAndDisplayAlerts: function(shouldClearOldAlerts) {
        var self = this;
        this._getAlerts()
          .then(function(data) {
            self._unpackRawAlertData(data, shouldClearOldAlerts);
            if (self._alerts.length === 0) {
              uitk.publish('alerts:empty');
            }
            self.addLXMipAlertOmniture();
            self.menuView.reRender();
          })
          .fail(function() {
            uitk.publish('alerts:empty');
          });
      },
      getAlerts: function() {
        return this._alerts;
      },
      count: function() {
        return this._alerts.length;
      },
      at: function(index) {
        index = index || 0;

        return this._alerts[index];
      },
      addLXMipAlertOmniture: function() {
        var variant = abTest.get(11405, null, true).value;
        if (window.dctk && window.dctk.onReady && variant) {
          dctk.onReady(function () {
            var pageName = dctk.omtr.pageName;
            if (variant === 1) {
              dctk.omtr.eVar43 = "MIP.LX.Bell." + pageName + ".FLIGHT-MIP";
            }
            else if (variant === 2) {
              dctk.omtr.eVar43 = "MIP.GT.Bell." + pageName + ".FLIGHT-MIP";
            }
            else {
              dctk.omtr.eVar43 = "MIP.LX-GT.Bell." + pageName + ".FLIGHT-MIP";
            }
          })
        }
      },
      removeDuplicateAlerts: function(alerts) {
        var seen = {};
        return alerts.filter(function(item) {
          var k = [item.raw.msgid, item.raw.params];
          return seen.hasOwnProperty(k) ? false : (seen[k] = true);
        });
      },
      wotifCheck: function() {
        if(/wotif/.test(window.location.href)) {
          $('.alerts-display-wrapper').addClass('isWotif');
        }
        return this;
      },
      detectIE11: function() {
        //From http://stackoverflow.com/questions/17447373/how-can-i-target-only-internet-explorer-11-with-javascript
        if(/Trident.*rv[ :]*11\./.test(navigator.userAgent)) {
          $('.alert-menu-wrapper').addClass('ie11');
        }

        return this;
      },
      getUserFlags: function() {
        var self = this;

        return this._request(this._endpoints.scratchpadOptions, 'json')
          .then(function(data) {
            self.determineAdditionalUserMessagingFromOptions(data);
          })
          .fail(function() {

          });
      },

      determineAdditionalUserMessagingFromOptions: function(data) {
        if (data && data.status == 'SUCCESS' && data.scratchpadUserOptions) {
          var prompt = {};
          var declinedNudge = this.getLocalFlag('scratchpadDeclineNotesInTray');
          var declinedSignIn = this.getLocalFlag('scratchpadDeclineSaveInTray');
          var showSave = (pageModel.user.userStatus == "ANONYMOUS")
                && !declinedSignIn && (env.locale !== "en_US");
              // // showDefault = (this.state.currentCount < 1), NEED TO FIGURE OUT THIS
          var showNews = (env.locale === "en_US")
                && data.scratchpadUserOptions.anyNews;
          var showNotes = !declinedNudge
                && (env.locale === "en_US")
                && !showNews
                && !data.scratchpadUserOptions.sendNotes;

          if (showNotes) { prompt.promptType = 'notes' }
          else if (showSave) { prompt.promptType = 'save' }
          else if (showNews) { prompt.promptType = 'news' }
          // else if (showDefault) { prompt.promptType = 'default' }

          if (prompt.promptType && prompt.promptType !== 'default') {
            var alertId = {
              news: 'spBasicNews',
              notes: 'spNudgeEnroll',
              save: 'spSignIn'
            }[prompt.promptType];
            this.addLateAlert({
              newsFeedType: 'scratchpadLegacyAlert',
              msgid: alertId,
              params: []
            });
          } else if (prompt.promptType) {
            // this.state.userPrompts.push(prompt);
          }
        }

        return this;
      },

      addLateAlert: function(config) {
        if (this.count() === 0) {
          this._alerts.push(new ItemModel({
            newsFeedType: config.newsFeedType || 'Bad type',
            _uid: config._uid || ++privateCounter,
            msgid: config.msgid || 'error',
            params: config.params || []
          }));
        }

        this.menuView.reRender();

        return this._alerts;
      },
      pluckAlertByUniqueId: function(uniqueId) {
        var i = 0;
        var l = this._alerts.length;

        for (i; i < l; i++) {
          //                                                  splice wraps return in array
          if (this._alerts[i].uniqueId === uniqueId) return this._alerts.splice(i, 1)[0];
        }

        return false;
      },
      sendeVar28: function(tag) {
        if (this.omLock) {
          this.queuedOmPixels.push(tag);
        } else {
          if (window.dctk && dctk.onReady) {
            dctk.onReady(function () {
              dctk.trackImpression('APE:' + tag);
            });
          } else if (window.s_exp && window.s_exp.tl) {
            s_exp.eVar28 = 'APE:' + tag;
            // s_exp.events = 'event80'; // TODO: Need help from Sam
            s_exp.linkTrackVars = "eVar28,events";
            s_exp.linkTrackEvents = "event80,event81";
            s_exp.tl(true,"o","RFRR Action Link");
          }
        }

        return this;
      },
      sendQueuedOmPixels: function() {
        for (var i = 0; i < this.queuedOmPixels.length; i++) {
          this.sendeVar28(this.queuedOmPixels[i]);
        }

        this.queuedOmPixels = [];

        return this;
      },
      setLocalFlag: function(key, value) {
        try { // We need this extra try for users who block all localstorage use
          if (window.localStorage) {
            try {
              window.localStorage.setItem(key, value)
            } catch(e) {
              return false;
            }
          }
        } catch(e) {
          return false;
        }

        return true;
      },
      getLocalFlag: function(key) {
        var gotten = false;
        try { // We need this extra try for users who block all localstorage use
          if (window.localStorage) {
            try {
              gotten = window.localStorage.getItem(key)
            } catch(e) {
              return false;
            }
          }
        } catch(e) {
          return false;
        }

        return gotten;
      },
      deleteSingle: function(alert, alsoRemote) {
        if (!alert) {
          // window.alert('FAIL FAIL FAIL');
        } else {
          this.sendeVar28('Header.Notif.Delete.' + alert.raw.msgid);

          if (alsoRemote) {
            this._remoteDelete(alert);
          }

          alert = null;
        }

        return this;
      },
      sendeVar28NoAPE: function(tag, event) {
        if (window.dctk && window.dctk.onReady) {
          dctk.onReady(function () {
            if (event) {
              dctk.trackEvent('o', 'RFRR Action Link', {"prop16": tag, "eVar28" : tag}, event);
            }
            else {
              dctk.omtr.eVar28 = tag;
              dctk.omtr.events = 'event80';
              dctk.omtr.linkTrackVars = "eVar28,events";
              dctk.omtr.linkTrackEvents = "event80,event81";
              dctk.omtr.tl(true,"o","RFRR Action Link");
            }
          });
        }
        return this;
      },
      declineNudge: function() {
        // this.state.blockNotesHeader = true;
        this.sendeVar28NoAPE('Scratchpad.NotesLater'); // Legacy
        this.setLocalFlag('scratchpadDeclineNotesInTray', true);

        return this.sendNotes(false);
      },
      declineSignInToSave: function() {
        // this.state.blockSaveHeader = true;
        this.sendeVar28NoAPE('Scratchpad.SaveLater');
        this.setLocalFlag('scratchpadDeclineSaveInTray', true);

        return this;
      },
      enrollInNudge: function() {
        return this.sendNotes(true);
      },
      sendNotes: function(value) {
        var self = this;
        return this._request(this._endpoints.sendMeNotes, 'json', 'POST', { sendMeNotes: value })
          .done(function(loggedIn) {
            if (value && !loggedIn) window.location.href = self._endpoints.loginRedirect;
          });
      },
      _getAlerts: function() {
        return this._request(this._buildAlertQuery(), this._getAlertQueryDataType());
      },
      _isLab: function() {
        return /trunk/.test(window.location.hostname);
      },
      _buildAlertQuery: function() {
        var userIds = window.alertMenuRequestIds;
        var tuid = pageModel.user.tuid || -1;
        var guid = pageModel.user.guid || -1;
        var expid = pageModel.user.expUserId || -1;
        var siteid = env.siteId;


        return this._endpoints.userAlertsService
            + '/expid/' + expid
            + '/siteid/' + siteid
            + '/tuid/' + tuid
            + '/guid/' + guid;
      },
      _getAlertQueryDataType: function() {
        return 'json';
      },
      _request: function(query, dataType, type, data) {

        return $.ajax({
          url: query,
          type: type || 'GET',
          dataType: dataType || 'jsonp',
          data: data || {},
          timeout: 5000
        });
      },
      _unpackRawAlertData: function(data, shouldClearOldAlerts) {
        if (!data
            || !data.responsestatus
            || !data.responsestatus.status
            || data.responsestatus.status !== 'SUCCESS'
            || !data.newsItems
            || !data.newsItems.length) return [];

        if(shouldClearOldAlerts) {
          this._alerts = [];
        }

        var i = 0;
        var l = data.newsItems.length;
        var alert;

        for (i; i < l; i++) {
          if (this._isTaapSkipGbvMsgAndLogExperiment(data, i)) {
            continue;
          }
          alert = new ItemModel(data.newsItems[i]);

          if (typeof alert.contentString != 'undefined') {
            if (this._isNotRewardsAlert(alert.contentString)) {
              this._alerts.push(alert);
            }
          }
        }

        if(!shouldClearOldAlerts) {
          this._alerts = this.removeDuplicateAlerts(this._alerts);
        }

        return this._alerts;
      },
      _isTaapSkipGbvMsgAndLogExperiment: function(data, index) {
        var experimentId = 11714;
        var alertMsgIds = ["TAAPGBVREMAININGNEWSSILVER", "TAAPGBVREMAININGNEWSGOLD", "TAAPGBVREMAININGNEWSPLATINUM"];
        if ($.inArray(data.newsItems[index].msgid, alertMsgIds) === -1) {
          return false;
        }
        return abTest.get(experimentId, null, true).value === 0;
      },
      _isNotRewardsAlert: function(string) {
        if(/TODO/.test(string)) {
          return false;
        }
        return true;
      },
      _remoteDelete: function(alert) {
        return $.ajax({
          url: this._endpoints.expwebDelete,
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            type: alert.raw.type || '',
            msgid: alert.raw.msgid || ''
          })
        });
      }
    };
  });



  // ===========================================================================
  // ========= ALERT OBJECT  ===================================================
  // ===========================================================================
  define('gc/alertmenu-item-model', ['jquery', 'gc/alertmenu-templates', 'gc/alertmenu-click-handlers'], function($, templates, placeholder) {

    var Module = function(rawAlert) {
      this.raw = rawAlert;
      this.contentString = this._buildContentString();
      this.uniqueId = [this.raw.msgid, ++privateCounter].join('');
      this.$el = $(this.toDisplayString());

      return this;
    };

    Module.prototype = {
      deleteSelf: function(alsoRemote) {
        this.$el.remove();
        if (this.raw.newsFeedType === "scratchpadLegacyAlert") { // DEPRECATE ME!
          if (this.raw.msgid == 'spNudgeEnroll') {
            if (AlertsMenu) AlertsMenu.declineNudge();
          } else if (this.raw.msgid == 'spSignIn') {
            if (AlertsMenu) AlertsMenu.declineSignInToSave();
          }

          AlertsMenu.deleteSingle(this, false);
        } else {
          AlertsMenu.deleteSingle(this, alsoRemote);
        }

        return null;
      },

      toDisplayString: function() {
        var displayString = '<li id=' + this.uniqueId + ' class="alert-item">'
              + this.contentString
              + '<div class="close-button">'
                + '<button id="'
                  + this.uniqueId
                  + '-delete" btnType="close" targetId="'
                  + this.uniqueId
                + '"><span class="icon icon-close" aria-hidden="true">'
                + '</span><span class="visuallyhidden">'
                + accessibleNotifClose
                + '</span></button>'
              +'</div>'
            + '</li>';


        return displayString;
      },
      _buildContentString: function() {
        if (templates[this.raw.msgid]) {
          return templates[this.raw.msgid]({ params: this.raw.params });
        } else {
          return undefined;
        }
      }
    };

    return Module;
  });

  define('gc/alertmenu-click-handlers', ['jquery', 'gc/pageModel', 'gc/alertmenu-strings'], function($, pageModel, strings) {
    window.alertMenuClickHandlers = {
      spSignIn: function(e, alertItemRef) {
          if (window.AlertsMenu) {
              AlertsMenu.sendeVar28('Header.Notif.SP.SignIn');
          }
      },
      spNudgeEnroll: function(e, alertItemRef) {
          e.preventDefault();
          e.stopPropagation();

          var $target = $(e.target).closest('.alert-item');

          $target
              .find('.close-button')
              .remove();

          $target
              .find('.alert-message')
              .html(strings.nudgeEnrollment.success);

          if (pageModel.user.userStatus !== "ANONYMOUS") {
              uitk.utils.liveAnnounce(strings.nudgeEnrollment.success);
          }

          if (uitk
          && uitk.utils
          && uitk.utils.focusElement) {
              uitk.utils.focusElement($target);
          }
          if (window.AlertsMenu) AlertsMenu.sendeVar28('Header.Notif.SP.OptIn');
          if (window.AlertsMenu) AlertsMenu.enrollInNudge();
      },
      spBasicNews: function(e, alertItemRef) {
          if (window.AlertsMenu) {
              AlertsMenu.sendeVar28('Header.Notif.SP.News');
          }
      },
      spDetailedNews: function(e, alertItemRef) {
          if (window.AlertsMenu) {
              AlertsMenu.sendeVar28('Header.Notif.SP.LiveAlerts');
          }
      },
      flightMIPGT: function(){
        if (window.AlertsMenu) {
          AlertsMenu.sendeVar28NoAPE('MIP.GT.Bell.' + dctk.omtr.pageName + '.FLIGHT-MIP', "event158");
        }
      },

      flightMIPActivity: function(){
        if (window.AlertsMenu) {
          AlertsMenu.sendeVar28NoAPE('MIP.LX.Bell.' + dctk.omtr.pageName + '.FLIGHT-MIP', "event158");
        }
      },
      addChromeExtension: function(e, alertItemRef) {
          function successCallback () {
              if (dctk) {
                dctk.loggingAdapter.logMessage("ChromeExtensionSuccessful");
              }
              if (localStorage) {
                var date = new Date($.now());
                var month = date.getUTCMonth() + 1;
                var day = date.getUTCDate();
                var year = date.getUTCFullYear();
                var hours = date.getUTCHours();
                var minutes = date.getUTCMinutes();
                var seconds = date.getUTCSeconds();

                var logDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
                localStorage.setItem("chromeExtensionInstallCTA", logDate);
              }
          }

          function failureCallback (error) {
            if(dctk) {
              dctk.loggingAdapter.logError("ChromeExtensionFailed", error);
            }
          }

          if (window.AlertsMenu) {
              AlertsMenu.sendeVar28('HP.notbell');
          }

          if (chrome) {
            chrome.webstore.install("https://chrome.google.com/webstore/detail/cfbpcgmafclgfmpoelldpmiolgblgbel", successCallback, failureCallback);
          }
      }
    };
    /*===========Accessible Strings============*/
    window.accessibleBadgeMessage = strings.a11y.badgeOne;
    window.accessibleBadgeMessagePlural = strings.a11y.badgePlural;
    window.accessibleNotifClose = strings.a11y.notifClose;

  });

  require('gc/alertmenu', function(menuController) { window.AlertsMenu = menuController.init(); });

})();

define('gc/errorLogging', [], function() {
  // Internal Properties and Functions
  var isLoggingEnabled = function() {
    if (window.dctk && dctk.enabled) {
      return (dctk.logging && dctk.logging.logError)
    } else {
      return false;
    }
  }

  var logToConsole = function(e) {
    if (console) {
      if (console.error) {
        console.error(e);
      } else if (console.log) {
        console.log("Error occurred in Wizard: " + e);
      }
    }
  }

  var module = {
    logError : function(error, control, module, method, comments) {
      // error: Javascript error object (required)
      // control: The Global Controls control the error originates in: wizard, header, footer, pageModel, etc (optional, highly encouraged)
      // module: The amd module the error came from (optional)
      // method: The method the error was generated from (optional, highly encouraged for quick searches)
      // comments: A string containing any other indentifying or important information (optional)

      if (isLoggingEnabled()) {
        dctk.logging.logError("globalcontrols", error, {"control":control, "module":module, "method":method, "comments":comments})
      } else {
        // Allow for AMD compliant deferred loading.
        // This may hang on this requirement forever if dctk client logging is never loaded on this page.
        require('dctk/clientLogging', function(cl) {
          cl.logError("globalcontrols", error, {"control":control, "module":module, "method":method, "comments":comments})
        })
        logToConsole(error); // If cl.logError never appears, we'll need some way of seeing what happened. Log the error to console.
      }
      // logToConsole(error);  // We don't really need to do this, because clientLogging already does it. Bring it back if they stop.
    }
  }
  
  return module;
});
require(['gc/errorLogging', 'gc/abTest', 'gc/pageModel', 'dctk/dctk'], function(errorLogging, abTest, pageModel, dctk) {
  try {
    /* define the 'expedia' namespace */
    if (typeof window.xp === "undefined") {
        window.xp = {};
    }

    /*
     define the 'expedia.namespace' api that returns the namespace specified and creates it if it doesn't exist
     @param  arguments 1-n namespaces to create
     @return a reference to the last namespace object created
     */
    if (typeof xp.namespace === "undefined") {
        xp.namespace = function () {
            var args = arguments
            var root = null;
            var pkg;
            for (var i = 0; i < args.length; i = i + 1) {
                pkg = args[i].split('.');
                root = window;

                for (var j = 0; j
                    < pkg.length; j = j + 1) {
                    root[pkg[j]] = root[pkg[j]] || {};
                    root = root[pkg[j]];
                }
            }
            return root;
        };
    }

    /* define the 'xp.nav' namespace */
    xp.namespace("xp.nav");
    /*
     capture the analytics information and send it to Omniture when the click is fired
     @param obj the object that is to be tracked
     @param type the link type of the obj
     @param id the analytics id for the specified object
     */
    xp.nav.trackAnalytics = function (obj, type, id) {
        if ('undefined' != typeof(s_exp_trackClick) && s_exp_trackClick) {
            s_exp_trackClick(obj, type, id);
        }
        return true;
    }

    xp.nav.trackAnalyticsLanguageLinkWithLangID = function (referrerId, langID) {
        dctk.trackAction(referrerId, null, {prop30: langID, eVar54: langID});
    };

    /* define the 'xp.nav.event' namespace */
    xp.namespace("xp.nav.event");
    /*
     executes the supplied callback when the DOM is first usable.
     @param callback the callback to exectued when the DOM is ready.
     */
    xp.nav.event.onDOMReady = function (callback) {
        if (window.addEventListener) {
            window.addEventListener('load', callback, false);
        } else if (window.attachEvent) {
            window.attachEvent('onload', callback);
        } else {
            if (window.onload != null) {
                var _onload = window.onload;
                window.onload = function (e) {
                    _onload(e);
                    window[callback]();
                };
            } else
                window.onload = callback;
        }
    }

    window.langRedirectionUrl = function(element) {
      try {
        var emainChLang = "/pub/agent.dll?qscr=chlg&lang={langID}&ovrd=3&rurl=";
        var currentPath = window.location.pathname;
        var langId = element.href.split("?langid=")[1];
        var search = window.location.search;
        var hash = window.location.hash;
        var newPath = element.href;
        var isEMain = (currentPath.indexOf("agent.dll") > -1) || (currentPath.indexOf("/daily/") > -1);
        var isFeed = window["header_feedDomain"];
        emainChLang = emainChLang.replace("{langID}", langId);
        // for emain redirect to the change language link and back to the current page
        if (isEMain) {
            newPath = emainChLang + encodeURIComponent(window.location);
        // for the feed redirect to change language link and back to the homepage of the site
        } if (isFeed) {
            newPath = "http:" + window["header_feedDomain"] + emainChLang + encodeURIComponent("http:" + window["header_feedDomain"] + "/");
        } else {
            if (search === "") {
                search = "?";
            }
            if (search.indexOf("langid=") > -1) {
                search = search.replace(/langid=\d+/, "langid=" + langId);
            } else {
                search = search + "&langid=" + langId;
            }
            newPath = currentPath + search + hash;
        }
        window.location.href = newPath;
      } catch (e) {
        errorLogging.logError(e, 'header', 'header.js', 'langRedirectionUrl');
      }
    };

    window.currencyRedirectionUrl = function(element) {

      var currentPath = window.location.pathname;
      var search = window.location.search;
      var hash = window.location.hash;
      var newPath = window.location.pathname;
      var currencyValue = element.href.split("?currency=")[1];

      var isFeed = window["header_feedDomain"];

      // for the feed redirect to change currency link and back to the homepage of the site
      if (isFeed) {
          newPath = "http:" + window["header_feedDomain"] + "/?currency=" + currencyValue;
      } else {
          if (search === "") {
              search = "?";
          }
          if (search.indexOf("currency=") > -1) {
              search = search.replace(/currency=[A-Z]{3}/, "currency=" + currencyValue);
          } else {
              search = search + "&currency=" + currencyValue;
          }
          newPath = currentPath + search + hash;
      }
      window.location.href = newPath;
    };

      window.appendRedirectionUrl = function(element) {
      try {
        var currentPath = window.location.pathname;
        var uurl = (/uurl=([^&]+)/.exec(window.location.search) || [])[1];
        var targetPath;
        var returnUrl;
        var queryParams;
        var isFeed = window["header_feedDomain"];



        if (element.href.indexOf("/user/signin") != -1) {
            targetPath = "/user/signin?ckoflag=0";
        } else if (element.href.indexOf("/user/login") != -1) {
            targetPath = "/user/login?ckoflag=0";
        }
        else if (element.href.indexOf("/user/createaccount") != -1) {
            targetPath = "/user/createaccount?fromheader=true";
        }
        else {
            targetPath = "/user/logout?";
        }

        if (isFeed) {
            targetPath = "http:" + window["header_feedDomain"] + targetPath + '&uurl=http:' + window["header_feedDomain"];
        }
        // if redirection parameter already exists use it
        else if (uurl && uurl.indexOf("e3id") !== -1) {
            targetPath = targetPath + '&uurl=' + uurl;
        }
        // append hash parameters to url as if they were query parameters
        else if (currentPath === '/Hotel-Search') {
            returnUrl = currentPath + window.location.search + window.location.hash.replace('#', (window.location.search === '' ? '?' : '&'));
            queryParams = "&uurl=" + encodeURIComponent("e3id=redr&rurl=" + returnUrl);
            targetPath = targetPath + queryParams;
        }
        // don't append anything if user is coming from home
        else if (currentPath !== '/') {
            returnUrl = currentPath.concat(window.location.search, window.location.hash);
            queryParams = "&uurl=" + encodeURIComponent("e3id=redr&rurl=" + returnUrl);
            targetPath = targetPath + queryParams;
        }
        // replace single and double quotes to spaces for XSS attacks vulnerability
        window.location.href = targetPath.replace(/\'/g,"").replace(/\"/g,"");
      } catch (e) {
        errorLogging.logError(e, 'header', 'header.js', 'appendRedirectionUrl');
      }
    };

  } catch (e) {
    errorLogging.logError(e, 'header', 'header.js', 'main');
  }

    if (pageModel && pageModel.site) {
        if (pageModel.site.id === 1) {
            var awsUSTestAA = abTest.get(12963, null, true).value;
        } else if (pageModel.site.id === 25) {
            var awsAUTestAA = abTest.get(12978, null, true).value;
        }
    }
});

// Publish a UITK PubSub event when the nav is clicked, including all attributes on the <a> that was clicked
require('uitk', function(uitk) {
    $('.utility-nav a').on ('click', function(e) {
        var id = $(this).attr('id');
        var href = $(this).attr('href');
        var target = $(this).attr('target');
        var route = $(this).data('route');
        var omnitureId = $(this).data('omniture-id');

        uitk.publish('gc_nav_click', {
            id: id,
            href: href,
            target: target,
            route: route,
            omnitureId: omnitureId
        });
    });
});

require(['gc/abTest', 'gss-modal', 'env', 'gc/pageModel'], function(abTest, modal, env, pageModel) {
  var isIdentified = pageModel && pageModel.user.userStatus === 'Identified' ;
  var isAuthenticated = pageModel && pageModel.user.userStatus === 'AUTHENTICATED';
  var isAnonymous = pageModel && ((pageModel.user.userStatus === 'Identified' && pageModel.user.expUserId < 0) ||  pageModel.user.userStatus === 'ANONYMOUS');
  var isMobile = window.innerWidth <= 725;
  var isGssExpAlreadyLogged = false;
  var returnUrl;
  var gssVariant;
  var enableMyAccountGSS=false;
  var evaluateRecaptchaGCFlag = gssVariant != undefined ? ((gssVariant == 3) ? true:false) : undefined;

  evaluateExperiment(false);

  if ((isAuthenticated || isIdentified)&&(enableMyAccountGSS)){
    var myAccount;
    if(isMobile){
      myAccount = elemById("account-menu-myaccount");
    }else{
      myAccount = elemById("account-myaccount");
    }
    if(isAuthenticated){
      myAccount.addEventListener('click', function (e) {
        e.preventDefault();
        $.ajax({
              url: '/gc/getUserState.json',
              type: 'GET',
              async: false,
              timeout: env.pageModelTimeout,
              success: function(response){
                isAuthenticated = (response.authenticated);
              }
            });

        if(!isAuthenticated){
          GssOnMyAccount(myAccount,e);
        }else{
          $(this).trigger('click');
        }
      });
    }else if (isIdentified){
      myAccount.addEventListener('click', function (e) {
          GssOnMyAccount(myAccount,e);
      });
    }
  }else{
      var signInIdElem;
      var signUpIdElem;
    if(isMobile){
      signInIdElem = elemById("header-accountMenu-signin");
      signUpIdElem = elemById("header-account-signup");

      setupGSS(signInIdElem, signUpIdElem, "onclick","data-onclick");
      } else {
          signInIdElem = elemById("account-signin");
          signUpIdElem = elemById("account-register");
          var signInButton = elemById("header-account-signin-button");

          if(signInButton !== null && signInButton !== 'undefined'){
            signInIdElem = elemById("header-account-signin");
            signUpIdElem = elemById("header-account-register");
          }
          setupGSS(signInIdElem, signUpIdElem, "data-onclick", "data-onclick");
      }
  }

  function setReturnUrl(elemId){
    returnUrl = elemId.pathname;
  }
  function RemoveDefault(elemId,attribute){
    var DataOnclick = elemId.getAttribute(attribute);
    elemId.removeAttribute(attribute);
    return DataOnclick;
  }

  function elemById(id){
    return document.getElementById(id);
  }

  function GssOnMyAccount(myAccount,e){
    setReturnUrl(myAccount);
    var myAccountDataOnclick = RemoveDefault(myAccount,"data-onclick");
    openModal(null, myAccount, "page.Account.GSS.SignIn", null, myAccountDataOnclick, e);
  }

  function ifAccountMenuExists(sInElem, sUpElem){
    return (typeof(sInElem) != 'undefined' && typeof(sUpElem) != 'undefined' && sInElem != null && sUpElem != null);
  }

  function evaluateExperiment(isToBeLogged){
    if(window.location.pathname === '/'){
      if(gssVariant === undefined || (isToBeLogged && !isGssExpAlreadyLogged)){
        gssVariant = abTest.get(14261, null, isToBeLogged).value;
        if(isToBeLogged){
          isGssExpAlreadyLogged = true;
        }
      }
    }else{
      gssVariant=0;
    }
  }

  function initGSSModal(e){
    var gssParams = {
      showLoyaltyCheckBox : ( gssVariant < 4 ) ? true : false
    };
    gssParams.siteid = env.siteId;
    gssParams.langid = env.langId;
    gssParams.locale = env.locale;
    gssParams.rurl = returnUrl;
    gssParams.evaluateRecaptchaGCFlag = evaluateRecaptchaGCFlag;

    e.preventDefault();
    modal.initDomEmbedded( gssParams );
  }

  function openModal(signUpIdElem, signInIdElem, pageName, signUpDataOnclick, signInDataOnclick, e){
    evaluateExperiment(true);

    if (gssVariant > 1 ) {
      initGSSModal(e);
      dctk.onReady(function () {
        dctk.omtr.pageName = pageName;
        dctk.omtr.t();
      });

      if(pageName === "page.Account.GSS.CreateAccount"){
        modal.openSignUp();
      } else {
        modal.openSignIn();
      }
    } else {
        signInIdElem.setAttribute("data-onclick", signInDataOnclick);
        if (signUpIdElem !== null){
          signUpIdElem.setAttribute("data-onclick", signUpDataOnclick);
        }
      }
    }

  function setupGSS(signInIdElem, signUpIdElem, signInAttribute, signUpAttribute){
    if(ifAccountMenuExists(signInIdElem, signUpIdElem)){
      var signUpDataOnclick = RemoveDefault(signUpIdElem,signUpAttribute);
      var signInDataOnclick = RemoveDefault(signInIdElem,signInAttribute);

      if(signInAttribute === "onclick"){
        signInIdElem.removeAttribute("data-onclick");
      }

      signUpIdElem.addEventListener('click', function (e) {
         xp.nav.trackAnalytics(this, 'a', 'page.Account.GSS.CreateAccount');
        openModal(signUpIdElem, signInIdElem, "page.Account.GSS.CreateAccount", signUpDataOnclick, signInDataOnclick, e);
      });

      signInIdElem.addEventListener('click', function (e) {
        xp.nav.trackAnalytics(this, 'a', 'page.Account.GSS.SignIn');
        openModal(signUpIdElem, signInIdElem, "page.Account.GSS.SignIn", signUpDataOnclick, signInDataOnclick, e);
      });
    }
  }
});
require('gc/errorLogging', function(errorLogging) {
// Handlebars AMD is dependant on some features built into requirejs
// that aren't in modulizr. This file adds those features.

// module is not defined in modulizr, it is safe to just
// return a generic object
// define('jquery', function() { return $});
  try {
    define('module', function() {return {}});
    define('exports', function() {return {}});

    // For mudles still using site_id
    require('env', function(env) {
        window.site_id = env.siteId;
    });

      // requirejs handles paths to files while modulizr does not
      // we point the paths handlebars expects at the objects
      define('./utils', ['Handlebars.Utils'], function(utils) { return utils});
      define('./handlebars/utils', ['Handlebars.Utils'], function(utils) { return utils});
      define('./exception', ['Handlebars.Exception'], function(exception) { return exception});
      define('./handlebars/exception', ['Handlebars.Exception'], function(exception) { return exception});
      define('./safe-string', ['Handlebars.Safe-String'], function(safeString) { return safeString});
      define('./handlebars/safe-string', ['Handlebars.Safe-String'], function(safeString) { return safeString});
      define('./no-conflict', ['Handlebars.noConflict'], function(noConflict) { return noConflict});
      define('./handlebars/no-conflict', ['Handlebars.noConflict'], function(noConflict) { return noConflict});
      define('./runtime', ['Handlebars'], function(runtime) { return runtime});
      define('./handlebars/runtime', ['Handlebars'], function(runtime) { return runtime});

  } catch (e) {
    errorLogging.logError(e, 'header', 'handlebars-amd-bootstrap.js', 'main');
  }
});

define('gc/script-loader', ['jquery'], function($) {

  function loader(url, callback) {
    var scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', url);
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.addEventListener('load', callback);
    $("head")[0].appendChild(scriptTag);
  }

  return loader;
});

/*
Testing the marketing header can use the sessionStorage value.

in the console, set the value it should be. eg, for TAAP use the following JSON string after updating
"currentTime" to a valid number by using Date.now():

(function() {
 var myJsonString =  '{"currentTime":1489350755679,"response":{"siteid":1,"tpid":116715,"eapid":1,"id":"taap","model":{"brandOverride":"Expedia","isTaapUser":true,"isRedirectNeeded":false,"supportEmailAddress":"support@expedia-agents.com","supportPhone":"1 866 925 7718","countryCode":"US","isBooker":false,"taapUserTrackingCode":"WS09713","taapAgencyName":"Kelly\'s Travel agency"}}}';
 var myObj = JSON.parse(myJsonString);
 myObj.currentTime = Date.now();
 sessionStorage.setItem('marketing.header.key', JSON.stringify(myObj));
})();

add the below in util/page-model-publisher to set window.__pageModel

window.__pageModel = JSON.parse(''); //TODO: put a model.json output here
 */
require(['uitk', 'gc/pageModel', 'gc/script-loader', 'env', 'jquery', 'dctk/dctk'], function (uitk, pageModel, loader, env, $, dctk) {
    var hasGroup = pageModel.user.hasGroups;

    var locale = env.locale || pageModel.site.locale;
    var siteId = env.siteId || pageModel.site.id;
    var taapHeaderBundleUrl = env.taapHeaderBundleUrl || "https://d4rb83r2tty9a.cloudfront.net";
    // HACK! Why is the version empty??
    var contentVersion = env.version || 'e4128bc5b740c3a51be00492446cfc400d08b587';
    var prefix = (env.prefix || "//a.travel-assets.com/globalcontrols-service").replace("http:", "");


    var taapHeaderLoaded = false;
    var loadTaapHeader = function() {
      if (!taapHeaderLoaded) {
          loader(taapHeaderBundleUrl + '/taapHeaderBundle.js');
          loader(taapHeaderBundleUrl + '/loc/taapHeader.' + locale + '.js');
          taapHeaderLoaded = true;
      }
    }


    if (location.search.indexOf('hasGroup=true') >= 0) {
        hasGroup = true;
    }

    var loadMarketingHeader = function () {
        var marketingHeaderEndpoint = "/marketingHeader/branding";

        var result = getSessionData(sessionKey);

        if (result && isValidSessionData(result, Date.now())) {
            handleMarketingContent(result.response);
        }
        else {
            $.get(marketingHeaderEndpoint, function (data) {
                setSessionData(sessionKey, {
                    currentTime: Date.now(),
                    response: data,
                    tuid: pageModel.user.tuid
                });
                handleMarketingContent(data);
            });
        }
    };

    var handleMarketingContent = function (obj) {
        if (!obj || !obj.model || !obj.id)
          return;
        if (obj.model && obj.model.programName && obj.model.programName == "npp") {
            dctk.onReady(function () {
                dctk.clearOmnitureObj();
                dctk.trackEvent('o', 'Use Different Account', {'eVar40': obj.model.partnerProgramMetadata.companyID});
            });
        }
        if (obj.id) { // Check we have a valid branding response
            obj.id = obj.id.toLowerCase();
            if (obj.id == "pugs") {
                if (obj.model && obj.model.programName) {
                    obj.id = obj.model.programName;
                }
            }
            var name = "header/cobrand/" + obj.id + "/brandingheader";
            if (obj.id == "taap") {
                loadTaapHeader()
                var interval = setInterval(function () {
                    if ($("#all-in-rewards-header-link").length && $("#sub-menu-header-shop-rewards").length) {
                        clearInterval(interval);
                        $("#all-in-rewards-header-link").hide();
                        $("#sub-menu-header-shop-rewards").hide();
                    }
		    if($("#header-account-rewards-more-menu").length){
			$("#header-account-rewards-more-menu").hide();
		    }
                }, 10);
                return;
            }

            var loadHeaderTemplateAndRender = function() {
              // sample link: https://b.travel-assets.com/globalcontrols-service/content/60717d41468964b232e3dd8c427db4b7f4fabf33/templates/1/en_US/taap.js

              // sample link: https://b.travel-assets.com/globalcontrols-service/content/60717d41468964b232e3dd8c427db4b7f4fabf33/templates/1/en_US/taap.js
              var tmplUrl = prefix + '/content/' + contentVersion + '/templates/' + siteId + '/' + locale + '/' + obj.id + '.js';
              loader(tmplUrl, function () {
                  // merge the model returned by /marketingHeader/brand with the CUG model returned by the hbs template JS
                  // then use it to render the CUG header
                  for (var prop in obj.model) {
                      if (obj.model.hasOwnProperty(prop)) {
                          cugModel[prop] = obj.model[prop];
                      }
                  }
                  require('handlebars', function (Handlebars) {
                      var divElement = document.createElement('div');
                      divElement.innerHTML = Handlebars.templates[name](cugModel); // uses the merged cugModel
                      $("#cobranded-header").html(divElement).show();
                  });
              });
            };

            // load handlebars3 dependency.
              loadHeaderTemplateAndRender();
        }
    };

    var sessionKey = 'marketing.header.key';
    var getSessionData = function (key) {
        if (sessionStorage)
        {
          try {
            return JSON.parse(sessionStorage.getItem(key));
          }
          catch(e) {
            console.error(e);
          }
        }
        return null;
    };
    var setSessionData = function (key, data) {
        if (sessionStorage)
        {
          try {
            sessionStorage.setItem(key, JSON.stringify(data));
          }
          catch(e) {
            console.error(e);
          }
        }
    };

    var isValidSessionData = function (cacheData, nowTimeMs) {
        if (env.skipMarketingHeaderValidation) return true; // test environment.
        if (pageModel.isUserAuthenticated() && pageModel.user.tuid == cacheData.tuid && cacheData.currentTime) {
            var diffSeconds = (nowTimeMs - cacheData.currentTime) / 1000;
            return diffSeconds < 2 * 60 * 60; // 2 hours to cache for header content
        }
        return false;
    };

    if (sessionStorage && sessionStorage.getItem('taapContext')) {
      loadTaapHeader(); // shortcut for TAAP header
    } else if (hasGroup) {
        try {
            loadMarketingHeader();
        }
        catch (e) {
            console.error(e);
        }
    }

});

function createMarketingCookie(name, value, expires, path, domain) {
    var cookie = name + "=" + value + ";";
    if (expires) {
        // If it's a date
        if(expires instanceof Date) {
            // If it isn't a valid date
            if (isNaN(expires.getTime()))
                expires = new Date();
        }
        else
            expires = new Date(new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24);
        cookie += "expires=" + expires.toGMTString() + ";";
    }
    if (path)
        cookie += "path=" + path + ";";
    if (domain)
        cookie += "domain=" + domain + ";";
    document.cookie = cookie;
}


//WARNING:  This function doesn't always work as expected due to a bug outside the scope of this function, since "document.cookie"
//      doesn't always return all the cookie for the current domains if it's set incorrectly. Expedia.es sometimes has this problem
function getMarketingCookie_unreliable(name) {
    var regexp = new RegExp("(?:^" + name + "|;\\s*"+ name + ")=(.*?)(?:;|$)", "g");
    var result = regexp.exec(document.cookie);
    return (result === null) ? null : result[1];
}

function deleteMarketingCookie(name, path, domain) {
    createMarketingCookie(name, "", -1, path, domain);
}

function setMarketingEAPID(eapid)
{
    var helper = function(newEAPID, tries) {
        if (getMarketingCookie_unreliable("iEAPID") != newEAPID) {
            var domain = getMarketingDomain();

            deleteMarketingCookie("iEAPID", "/", domain);
            createMarketingCookie("iEAPID", newEAPID, null, "/", domain);

            /* only retry if we're updating the cookie to make sure it sticks.*/
            if (tries < 5) /* max 5 tries */
                setTimeout(function() {helper(eapid, tries++);}, 1500); /* try again 1.5s later */
        }
    };

    if (typeof (jQuery) !== 'undefined') /* jQuery is preferred over $LAB because Cars tab disables $LAB. see headerV2wrapper.ftl */
    {
        jQuery(document).ready(function() {
            helper(eapid, 0);
        });
    }
    else
    {
        helper(eapid, 0);
    }
}

function getMarketingDomain()
{
    var domain = location.href.match( /:\/\/(www\.)?([^\/:]+)/ );
    if (domain > "") {
        domain = domain[2]?domain[2]:'';
        domain = "." + domain;
    }

    return domain;
}

function logoutMarketingUser()
{
    var domain = getMarketingDomain();

    deleteMarketingCookie("linfo", "/", domain);
    deleteMarketingCookie("user", "/", domain);
    deleteMarketingCookie("minfo", "/", domain);
    deleteMarketingCookie("accttype", "/", domain);
    deleteMarketingCookie("iEAPID", "/", domain);
}


function buildTaapMdpcidValue(posCode, eapidVal, tpidVal)
{
    var cidValue = "WPK." + posCode + "." + eapidVal + "-" + tpidVal;
    return cidValue;
}


function buildDateYYYYMMDD(addDays)
{
    var expires = new Date(new Date().setTime(new Date().getTime() + addDays * 24 * 60 * 60 * 1000));
    var expYear = expires.getFullYear().toString();
    var expMonth = (expires.getMonth() + 1).toString();
    if (expMonth.length < 2)
        expMonth = "0" + expMonth;
    var expDay = expires.getDate().toString();
    if (expDay.length < 2)
        expDay = "0" + expDay;

    return expYear + expMonth + expDay;
}


function setMarketingCidInASPP(marketingCidType, marketingCidValue)
{
    var channelExpiry = buildDateYYYYMMDD(30);
    var cookieVal = "v.1,0|" + marketingCidValue + "|||||||||" + marketingCidType + "|" + channelExpiry + "|";
    createMarketingCookie("aspp", cookieVal, null, "/", getMarketingDomain());
}



// if user is authenticated/identified, show signed-in account menu instead

require(['uitk', 'gc/pageModel', 'jquery', 'gc/errorLogging', 'gc/abTest', 'dctk/dctk'], function (uitk, pageModel, $, errorLogging, abTest, dctk) {
    try {
        var isAnonymous = pageModel && ((pageModel.user.userStatus === 'Identified' && pageModel.user.expUserId < 0) || pageModel.user.userStatus === 'ANONYMOUS');
        var isIdentified = pageModel && pageModel.user.userStatus === 'Identified';
        var isAthenticated = pageModel && pageModel.user.userStatus === 'AUTHENTICATED';
        var isSUAIdentified = pageModel && pageModel.user.sua && pageModel.user.userStatus === 'Identified';
        var isMobile = function () { return window.innerWidth <= 725; };
        var showAccountHeaderWithLoyalty = pageModel.site.id === 1 && isMobile();
        var shouldAccountShowIcon = (pageModel.site.id === 80001 && isMobile()) || showAccountHeaderWithLoyalty;
        var showNotificationBell = !(abTest.get(15190, null, true).value);

        var showAccountIcon = function () {
            $("#account-menu-header").removeClass("hidden");
            $("#account-menu").addClass("hide");
            $("#utility-link").addClass("hide");

            var $headerAccountSignup = $("#header-account-signup");
            var createAccountInAccountIconText = $headerAccountSignup.text();
            var brand = pageModel.site.brandName ? pageModel.site.brandName.toLowerCase() : "";
            brand = capitalizeFirstLetter(brand);
            createAccountInAccountIconText = createAccountInAccountIconText.replace("{{0}}", brand);
            $headerAccountSignup.text(createAccountInAccountIconText);
        };

        var showLoyaltyOnAccountIcon = function () {
            var tier = (pageModel.user.loyalty && pageModel.user.loyalty.tier) ? pageModel.user.loyalty.tier : "";
            var $signInIcon = $('.signedInIcon');
            var $rewardsInHeader = $('.rewardsInHeader');
            $signInIcon.addClass(tier);
            $rewardsInHeader.addClass('hide');
            $('.account-menu-rewards').removeClass("hidden");

            if (!(pageModel.user.loyalty && pageModel.user.loyalty.tier)) {
                var $joinExpediaRewards = $('.joinExpediaRewards');
                $joinExpediaRewards.removeClass('hidden');
            }
        };



        var capitalizeFirstLetter = function (string) {
            if (typeof string === "undefined" || !string) {
                return "";
            }
            return string[0].toUpperCase() + string.slice(1);
        };

        if (isAthenticated || !isAnonymous) {
            $('#header-account-menu').addClass('hidden');
            $('#account-signin').addClass('hidden');

            var $accountSignedIn = $('#header-account-menu-signed-in');
            var userGreetingEmail = pageModel.user.emailAddress || "";
            var displayGreetingName;

            userGreetingEmail = userGreetingEmail.trim();
            if (userGreetingEmail.length > 20) {
                userGreetingEmail = userGreetingEmail.substring(0, 17).concat("...");
            } else {
                var userGreetingEmailArray = userGreetingEmail.split('@');
                // Handle the long email wrapping issue.
                if (userGreetingEmailArray[0].length > 8) {
                    userGreetingEmailArray[0] = userGreetingEmailArray[0].substring(0, 7).concat("...");
                    userGreetingEmail = userGreetingEmailArray.join('@');
                }
            }


            if (!pageModel.user.firstName || pageModel.user.firstName == "") {
                displayGreetingName = (!pageModel.user.emailAddress || pageModel.user.emailAddress == "") ? "Guest" : userGreetingEmail;
            } else {
                displayGreetingName = pageModel.user.firstName;
            }
            if (shouldAccountShowIcon) {
                $("#account-menu-header .userDetails span").text(displayGreetingName);
            }

            if (pageModel.user.arranged) {
                $accountSignedIn.find('#arrangedUserGreetingName').text(displayGreetingName);
                $accountSignedIn.find('.arrangedUser').removeClass('hidden');
            } else {
                $accountSignedIn.find('#userGreetingName').text(displayGreetingName);
                $accountSignedIn.find('.nonArrangedUser').removeClass('hidden');
                $('#account-menu-signed-in').find('#userGreetingName').text(displayGreetingName);
                $('#account-menu-signed-in').find('.nonArrangedUser').removeClass('hidden');
            }
            // change SignOut text on the basis of guestGreeting experiment
            if (isIdentified) {
                $('#account-signout').addClass('hidden');
                $('#identified-account-signout').addClass('hidden');
                $('#identified-account-signout-v2').removeClass('hidden');
                $('#userGreetingNameSignOut-v2').text(displayGreetingName);
            } else {
                $('#account-signout').removeClass('hidden');
                $('#identified-account-signout').addClass('hidden');
                $('#identified-account-signout-v2').addClass('hidden');
            }

            $accountSignedIn.removeClass('hidden');
            $(".notSignedIn").css("display", "none");

            if (isSUAIdentified) {
                $('#account-myaccount').addClass('hidden');
            }

        } else {
            $(".signedIn").css("display", "none");
        }

        if (showNotificationBell) {
            $('.alerts-display-wrapper ul').removeClass('hideBell');
        }
        if (isMobile()) {
            showAccountIcon();
        }

        if (showAccountHeaderWithLoyalty) {
            showLoyaltyOnAccountIcon();
            $('.fav-hotels-link').removeClass('hidden');
        }

        // Adding RFRR ID for the Account Icon in the header
        $(document).on(uitk.clickEvent, '#account-menu-icon', function (e) {
            dctk.trackEvent({name: 'AccountIconButtonClicked', rfrr: 'HP.ACCOUNT.HEADER.ENG'});
        });

        $(window).on('resize', function () {
            if (isAthenticated || !isAnonymous) {
                $(".notSignedIn").css("display", "none");
                $("#account-menu-header .userDetails span").text(displayGreetingName);
            } else {
                $(".signedIn").css("display", "none");
            }

            if (isMobile()) {
                showAccountIcon();
            }
            if (showAccountHeaderWithLoyalty) {
                showLoyaltyOnAccountIcon();
            }
        });

    } catch (e) {
        errorLogging.logError(e, 'header', 'account-menu.js', 'main');
    }

});

require(['jquery', 'gc/errorLogging', 'gc/redirect-banner/model'], function($, errorLogging, model) {

  var url;

  function setReturnUrl($redirectBanner) {
    $redirectBanner.find('a').attr('href', url);
  }

  function showRedirectBanner($redirectBanner) {
    $redirectBanner.find('.btn-close').on('click', function() { $redirectBanner.addClass('hidden');});
    $redirectBanner.removeClass('hidden');
  }

  function setUrlAndShow() {
    var $redirectBanner = $('#redirectBanner');
    setReturnUrl($redirectBanner);
    showRedirectBanner($redirectBanner);
  }

  try {
    if (model.isRedirected(window.location)) {
      var url = model.createReturnUrl(window.location);
      $(document).ready(setUrlAndShow);
    }
  } catch(e) {
      errorLogging.logError(e, 'header', 'redirect-banner/ui.js', 'main');
  }
});

define('gc/redirect-banner/model', ['env'], function(env) {
  "use strict";
  var rfrrID = "rfrr=Redirect.From";

  function isRedirected(location) {
    return location.search.indexOf(rfrrID) >= 0;
  }

  function createReturnUrl(location) {
    var rfrrLocationObject = getRfrrLocationObject(location.search);
    var returnUrl = location.protocol + '//' +
      rfrrLocationObject.host +
      '/IpSniffRedir?forceNoRedir=1&userTpid=1' +
      '&targetUrl=' + createTargetUrl(location, rfrrLocationObject);
    return returnUrl;
  }

  function createTargetUrl(location, rfrrLocation) {
    var newSearchStr = cleanSearch(location.search);
    if(newSearchStr.length > 0) {
      newSearchStr = '/' + newSearchStr + '&';
    } else {
      newSearchStr += '/?';
    }
    newSearchStr += 'rfrr=Header.POSRedirect.' + location.hostname;
    newSearchStr += location.pathname === '/' ? '' : location.pathname;
    return encodeURIComponent(location.protocol + '//' + rfrrLocation.hostname + (rfrrLocation.pathname === '/' ? '' : rfrrLocation.pathname) + newSearchStr)
  }

  function getRfrrLocationObject(searchString) {
    var startIndex = searchString.indexOf(rfrrID) + rfrrID.length + 1;
    var ampPosition = searchString.indexOf('&', startIndex);
    var endIndex = (ampPosition === -1) ? searchString.length : ampPosition;
    var rfrrUrl = 'https://' + searchString.substring(startIndex, endIndex);
    var rfrrLocation = document.createElement('a');
    while(rfrrUrl.indexOf('%') !== -1) {
      rfrrUrl = decodeURIComponent(rfrrUrl);
    }
    rfrrLocation.href = rfrrUrl;
    return rfrrLocation;
  }

  function cleanSearch(searchStr) {
    var params = searchStr.split('&');
    for(var i in params) {
      if(params[i].indexOf(rfrrID) !== -1) {
        params.splice(i, 1);
        break;
      }
    }
    return params.join('&');
  }

  return {
    isRedirected: isRedirected,
    createReturnUrl: createReturnUrl,
    createTargetUrl: createTargetUrl,
    cleanSearch: cleanSearch,
    getRfrrLocationObject: getRfrrLocationObject
  };
});

require(['gc/pageModel', 'jquery', 'gc/errorLogging'], function(pageModel, $, errorLogging) {
    var tier = undefined;
    var tierid = undefined;
    var points = undefined;
    var $rewardsHeader = undefined;
    var processPointsAndTiers = false;
    var loyaltyProgram = "rewards";
    var showRewardsHeader = false;
    var rewardsEnabled = false;
    var isUserIdentified = false;
    var isRewardsMember = false;
    var rewardsConfig = {};

      rewardsConfig.enabled = {}; // are any rewards features enabled?
      rewardsConfig.processPointsAndTiers = {}; // some of these sites don't process points or tiers
      rewardsConfig.showRewardsHeaderAlways = {};// some sites always show whether the user is authenticated or is a rewards member
      rewardsConfig.program = {};// program for differentiation if needed instead of using siteids

      rewardsConfig.program[1178] = "td";
      rewardsConfig.program[1236] = "barclays";
      rewardsConfig.program[1] = "rewards";
      rewardsConfig.program[3] = "rewards";
      rewardsConfig.program[4] = "rewards";
      rewardsConfig.program[8] = "rewards";
      rewardsConfig.program[9] = "rewards";
      rewardsConfig.program[11] = "rewards";
      rewardsConfig.program[14] = "rewards";
      rewardsConfig.program[16] = "rewards";
      rewardsConfig.program[17] = "rewards";
      rewardsConfig.program[18] = "rewards";
      rewardsConfig.program[20] = "rewards";
      rewardsConfig.program[27] = "rewards";
      rewardsConfig.program[28] = "rewards";
      rewardsConfig.program[29] = "rewards";
      rewardsConfig.program[61] = "rewards";
      rewardsConfig.program[62] = "rewards";
      rewardsConfig.program[63] = "rewards";
      rewardsConfig.program[64] = "rewards";
      rewardsConfig.program[65] = "rewards";
      rewardsConfig.program[66] = "rewards";
      rewardsConfig.program[67] = "rewards";
      rewardsConfig.program[69] = "rewards";
      rewardsConfig.program[70] = "rewards";
      rewardsConfig.program[71] = "rewards";
      rewardsConfig.program[72] = "rewards";
      rewardsConfig.program[73] = "rewards";
      rewardsConfig.program[70301] = "rewards";
      rewardsConfig.program[70201] = "rewards";
      rewardsConfig.program[70403] = "rewards";
      rewardsConfig.program[70406] = "rewards";
      rewardsConfig.program[70420] = "rewards";
      rewardsConfig.program[70463] = "rewards";
      rewardsConfig.program[70473] = "rewards";
      rewardsConfig.program[70472] = "rewards";
      rewardsConfig.program[70465] = "rewards";

      rewardsConfig.processPointsAndTiers[1178] = true;
      rewardsConfig.processPointsAndTiers[1236] = true;
      rewardsConfig.processPointsAndTiers[1] = true;
      rewardsConfig.processPointsAndTiers[3] = true;
      rewardsConfig.processPointsAndTiers[4] = true;
      rewardsConfig.processPointsAndTiers[8] = true;
      rewardsConfig.processPointsAndTiers[9] = true;
      rewardsConfig.processPointsAndTiers[11] = true;
      rewardsConfig.processPointsAndTiers[14] = true;
      rewardsConfig.processPointsAndTiers[16] = true;
      rewardsConfig.processPointsAndTiers[17] = true;
      rewardsConfig.processPointsAndTiers[18] = true;
      rewardsConfig.processPointsAndTiers[20] = true;
      rewardsConfig.processPointsAndTiers[27] = true;
      rewardsConfig.processPointsAndTiers[28] = true;
      rewardsConfig.processPointsAndTiers[29] = true;
      rewardsConfig.processPointsAndTiers[61] = true;
      rewardsConfig.processPointsAndTiers[62] = true;
      rewardsConfig.processPointsAndTiers[63] = true;
      rewardsConfig.processPointsAndTiers[64] = true;
      rewardsConfig.processPointsAndTiers[65] = true;
      rewardsConfig.processPointsAndTiers[66] = true;
      rewardsConfig.processPointsAndTiers[67] = true;
      rewardsConfig.processPointsAndTiers[69] = true;
      rewardsConfig.processPointsAndTiers[70] = true;
      rewardsConfig.processPointsAndTiers[71] = true;
      rewardsConfig.processPointsAndTiers[72] = true;
      rewardsConfig.processPointsAndTiers[73] = true;
      rewardsConfig.processPointsAndTiers[70301] = false;
      rewardsConfig.processPointsAndTiers[70201] = false;
      rewardsConfig.processPointsAndTiers[70403] = false;
      rewardsConfig.processPointsAndTiers[70406] = false;
      rewardsConfig.processPointsAndTiers[70420] = false;
      rewardsConfig.processPointsAndTiers[70463] = false;
      rewardsConfig.processPointsAndTiers[70473] = false;
      rewardsConfig.processPointsAndTiers[70472] = false;
      rewardsConfig.processPointsAndTiers[70465] = false;

      rewardsConfig.enabled[1] = true;
      rewardsConfig.enabled[3] = true;
      rewardsConfig.enabled[4] = true;
      rewardsConfig.enabled[8] = true;
      rewardsConfig.enabled[9] = true;
      rewardsConfig.enabled[11] = true;
      rewardsConfig.enabled[14] = true;
      rewardsConfig.enabled[16] = true;
      rewardsConfig.enabled[17] = true;
      rewardsConfig.enabled[18] = true;
      rewardsConfig.enabled[20] = true;
      rewardsConfig.enabled[27] = true;
      rewardsConfig.enabled[28] = true;
      rewardsConfig.enabled[29] = true;
      rewardsConfig.enabled[61] = true;
      rewardsConfig.enabled[62] = true;
      rewardsConfig.enabled[63] = true;
      rewardsConfig.enabled[64] = true;
      rewardsConfig.enabled[65] = true;
      rewardsConfig.enabled[66] = true;
      rewardsConfig.enabled[67] = true;
      rewardsConfig.enabled[69] = true;
      rewardsConfig.enabled[70] = true;
      rewardsConfig.enabled[71] = true;
      rewardsConfig.enabled[72] = true;
      rewardsConfig.enabled[73] = true;
      rewardsConfig.enabled[1236] = true;
      rewardsConfig.enabled[1178] = true;
      rewardsConfig.enabled[70301] = true;
      rewardsConfig.enabled[70201] = true;
      rewardsConfig.enabled[70403] = true;
      rewardsConfig.enabled[70406] = true;
      rewardsConfig.enabled[70420] = true;
      rewardsConfig.enabled[70463] = true;
      rewardsConfig.enabled[70473] = true;
      rewardsConfig.enabled[70472] = true;
      rewardsConfig.enabled[70465] = true;

      rewardsConfig.showRewardsHeaderAlways[1178] = true;
      rewardsConfig.showRewardsHeaderAlways[70301] = true;
      rewardsConfig.showRewardsHeaderAlways[70201] = true;
      rewardsConfig.showRewardsHeaderAlways[70403] = true;
      rewardsConfig.showRewardsHeaderAlways[70406] = true;
      rewardsConfig.showRewardsHeaderAlways[70420] = true;
      rewardsConfig.showRewardsHeaderAlways[70463] = true;
      rewardsConfig.showRewardsHeaderAlways[70473] = true;
      rewardsConfig.showRewardsHeaderAlways[70472] = true;
      rewardsConfig.showRewardsHeaderAlways[70465] = true;

  try {

      if (pageModel) // interpret the pageModel into reliable defined variables based on siteid
      {
          rewardsEnabled = rewardsConfig.enabled[pageModel.site.id] === true;
          showRewardsHeader = rewardsEnabled && (rewardsConfig.showRewardsHeaderAlways[pageModel.site.id] === true); // show always even if no points/no auth/ as long as rewards enabled
          processPointsAndTiers = rewardsEnabled && rewardsConfig.processPointsAndTiers[pageModel.site.id] === true
          loyaltyProgram = rewardsConfig.program[pageModel.site.id] !== undefined ? rewardsConfig.program[pageModel.site.id] : loyaltyProgram;//leave set to rewards by default

          if (loyaltyProgram === "rewards")
          {
            $rewardsHeader = $('.rewardsHeader');
          }
          else if (loyaltyProgram.match(/td|barclays/))
          {
            $rewardsHeader = $('#header-award-module-info');
          }
          isUserIdentified = pageModel.isUserIdentified();
          isRewardsMember = rewardsEnabled && pageModel.user.loyalty && pageModel.user.loyalty.rewardsMember;
      }

     if(isUserIdentified && isRewardsMember && processPointsAndTiers) //User authenticated or identified and is a rewards member and rewards is enabled and processPointsAndTiers is true
     {
         tier = pageModel.user.loyalty.tier;
         tierid = pageModel.user.loyalty.tierId;
         points = parseInt(pageModel.user.loyalty.confirmedPoints);


         // HANDLE TIERS
         if (loyaltyProgram === "td") {
             if (/^([6789]|10|11)$/.test(tierid)) {
                 var howitworksObject = document.createElement("img");
                 howitworksObject.src = "//{{domain}}/_dms/group/header/1178/howitworks/logo.png?locale={{locale}}&tierid={{tierid}}"
                     .replace("{{locale}}", pageModel.site.locale)
                     .replace("{{tierid}}", tierid)
                     .replace("{{domain}}", "www.expediafortd.com");
                 $('#header-howitworks').append(howitworksObject).removeClass("hidden");
                 if (/^(6|[89])$/.test(tierid)) {
                     $rewardsHeader.find('#header-pointBalDescRewards').removeClass("hidden");
                 }
             }
        }
        else if (loyaltyProgram === "rewards")
        {
             var $tierBadgeAnchor = $rewardsHeader.find('.benefits_link');
             var $tierBadgeDiv = $tierBadgeAnchor.find('.tierBadge');

             var tierBadgeHref = $tierBadgeAnchor.attr('href');
             tierBadgeHref = tierBadgeHref.replace('color', tier);
             $tierBadgeAnchor.attr('href', tierBadgeHref);
             $tierBadgeDiv.addClass(tier).text('+' + tier);
        }

        // HANDLE TIERS

        // HANDLE POINTS
        if (points > 0) //If points confirmed are greater than 0
        {
            var pointsFormatted;// TODO: this can be removed later replace with // var pointsFormatted = pageModel.user.loyalty.confirmedPointsFormatted;
            if (pageModel.user.loyalty.confirmedPointsFormatted)
            {
                pointsFormatted = pageModel.user.loyalty.confirmedPointsFormatted;
            }
            else
            {
                pointsFormatted = points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            var $pointsDisplayDiv;
            if (loyaltyProgram === "td")
            {
                $pointsDisplayDiv = $rewardsHeader.find('.point-balance');
                $pointsDisplayDiv.text(pointsFormatted);
                var $headercysymbol = $('#header-cySymbol');
                $headercysymbol.removeClass('hidden');
            }
            if (loyaltyProgram.match(/td|barclays/))
            {
                var cashValueDisplayDivValue = loyaltyProgram == "td" ? pageModel.user.loyalty.redeemableDollarValue : pageModel.user.loyalty.cashBalanceFormatted;
                $('#header-cashValue').text(cashValueDisplayDivValue);
            }
            else
            {
                $pointsDisplayDiv = $rewardsHeader.find('.pointsDisplay');
                $pointsDisplayDiv.text(pointsFormatted + ' points');
            }
            if ($pointsDisplayDiv) { // no points display for barclays
                $pointsDisplayDiv.removeClass('hidden');
            }
            showRewardsHeader = true; // if we are here we always show points
        }
        else if(loyaltyProgram === "td")
        {
            showRewardsHeader = false;
        }
        // HANDLE POINTS
     }
     else if(loyaltyProgram === "td")
     {
         showRewardsHeader = false;
     }

   } catch (e) {
     errorLogging.logError(e, 'header', 'rewards-badge.js', 'main');
   }
   finally
  {
      if (showRewardsHeader && $rewardsHeader)
      {
          $rewardsHeader.removeClass('hidden').attr("style","");// always show to give an error message when points not available
      }
  }

});

require(['jquery'], function($) {
    $('#header-container').on('click', 'a[data-omniture-id]', function(eventObject) {
	var link = eventObject.target;
	var type = 'a';
	if(eventObject.target !== this){
		link = eventObject.target.closest('a');
	}
	var omnitureId = link.getAttribute('data-omniture-id');
	try {
	    s_exp_trackClick(link, type, omnitureId);
	} catch (e) {
	    // ignore errors
	}
    });
});

	

require(['gc/errorLogging'], function(errorLogging) {
  window.headerFeedback = function(e) {
    "use strict";
    try {
      var screenWidth = screen.width;
      var screenHeight = screen.height;
      var isNewHomePage = (document.getElementById("home-page") !== null);
      var opinionLabReferrer = OpinionLab_FB.O_HT();
      var popUpUrl;
      var popUpName = "ModalPopUp";
      var popUpParameters;
      var feedbackUrl = ($('#support-feedback').attr('href').length > 0)?$('#support-feedback').attr('href') : "/p/info-other/feedback.htm";

      var top = ((screenHeight - 192) / 2);
      var left = ((screenWidth - 535) / 2);

      if (isNewHomePage) {
        opinionLabReferrer = opinionLabReferrer.replace("Homepage.html", "Homepage-new.html");
      }

      if (window["header_feedBackUrl"] !== undefined) {
        feedbackUrl = header_feedBackUrl;
      }

      popUpUrl =  feedbackUrl +
                  "?referer=" + opinionLabReferrer +
                  "&customvar=" + OpinionLab_FB.O_CV() +
                  "&prev=" + OpinionLab_FB.O_PRV();

      popUpParameters = ["toolbar=no",
                        "scrollbars=no",
                        "location=no",
                        "statusbar=no",
                        "menubar=no",
                        "resizable=no",
                        "width=635px",
                        "height=280px",
                        "screenX=" + left,
                        "screenY=" + top,
                        "left=" + left,
                        "top=" + top].join(",");

      var popUpObj = window.open(popUpUrl, popUpName, popUpParameters);
      popUpObj.focus();
    } catch (e) {
      errorLogging.logError(e, 'header', 'header-feedback.js', 'headerFeedback');
    }
  }
});

/*
 *  Project: Global Header
 *  Description: Add WCAG 2.0 compliant behavior to responsive menu toggle.
 *  Author: v-bnordwall@
 */

// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.

;(function () {
  require(['uitk', 'jquery'], function(uitk, $) {
    $("#header-container").on(uitk.clickEvent, "#mobile-toggle-header-link", function(e) {
      var hamburgerButtonShowMenuText = $('#show-menu');
      var hamburgerButtonHideMenuText = $('#hide-menu');
      hamburgerButtonShowMenuText.toggleClass("hidden");
      hamburgerButtonHideMenuText.toggleClass("hidden");

      $('#globalSiteNavigation').toggleClass('responsive-menu-shown');
    });
  });
}());

var OpinionLab_FB = (function(){
  var custom_var;
  var _sp='%3A\\/\\/';
  var _rp='%3A//';
  var _poE=0.0;
  var _poX=0.0;
  var _sH=screen.height;
  var _d=document;
  var _w=window;
  var _ht=escape(_w.location.href);
  var _hr=_d.referrer;
  var _tm=(new Date()).getTime();
  var _kp=0;
  var _sW=screen.width;

  function _fC(_u){
    var _aT=_sp+',\\/,\\.,-,_,'+_rp+',%2F,%2E,%2D,%5F';
    var _aA=_aT.split(',');
    for(var i=0;i<5;i++){
      eval('_u=_u.replace(/'+_aA[i]+'/g,_aA[i+5])')
    }
    return _u
  };

  function _fPe(){
    if(Math.random()>=1.0-_poE){
      O_LC();
      _poX=0.0
    }
  };

  function _fPx(){
    if(Math.random()>=1.0-_poX)
      O_LC()
  };

  function _populateCustomVar(){
    var t = '';
    var g = '';

    if ((typeof(dctk) !== 'undefined') && (typeof(dctk.omtr) !== 'undefined')){
        t = (typeof(dctk.omtr.prop11) !== 'undefined') ? dctk.omtr.prop11 : '';
        g = (typeof(dctk.omtr.prop12) !== 'undefined') ? dctk.omtr.prop12 : '';
    } else if (typeof(s_exp) !== 'undefined'){
        t = (typeof(s_exp.prop11) !== 'undefined') ? s_exp.prop11 : '';
        g = (typeof(s_exp.prop12) !== 'undefined') ? s_exp.prop12 : '';
    } else{
        t = (typeof(s_prop11) !== 'undefined') ? s_prop11 : '';
        g = (typeof(s_prop12) !== 'undefined') ? s_prop12 : '';
    }

    custom_var = g + '|' + t;
  }

  function _replacePageName(){
    var page_name = null;

    page_name =
        ((typeof(dctk) !== 'undefined') && (typeof(dctk.omtr) !== 'undefined')) ? escape(dctk.omtr.pageName) + '.html' :
        ((typeof(s_exp) !== 'undefined') && (typeof(s_exp.pageName) !== 'undefined') ) ? escape(s_exp.pageName) + '.html' :
        (typeof(s_pageName) !== 'undefined') ? escape(s_pageName) + '.html' :
        null;


    if(page_name){
       var l_page_name = page_name.toLowerCase();
       if (l_page_name.search('infosite') >= 0)
         {
         page_name = null;
         }
       }

    if(page_name){
      var _domain=_ht.replace('https%3A//', '').replace('http%3A//','');
      _ht=_ht.substr(0,_ht.indexOf('%3A//'))+'%3A//'+_domain.substr(0,_domain.indexOf('/'))+'\/'+page_name;

    }
        if (typeof(bIsCAFR) != 'undefined') {
        if (bIsCAFR == true) {
          var _lG='fr-CA.';
          _rp='%3A//'+_lG
        }
                }
            if (typeof(bIsMSMY) != 'undefined') {
        if (bIsMSMY == true) {
          var _lG='ms-my.';
          _rp='%3A//'+_lG
        }
      }
      if (typeof(OlAltLang) != 'undefined') {
        if (OlAltLang != null) {
          var _lG=OlAltLang;
          _rp='%3A//'+_lG
        }
      }
  };

  return {
    O_HT:function(){
      _replacePageName();
      return _ht;
    },
    O_CV:function(){
      _populateCustomVar();
      return custom_var;
    },
    O_PRV:function(){
      if (_hr == null || _hr.length < 1)
      {
        return "null";
      }
      return escape(_hr);
    },
    O_LC:function(target,referer,customvar,prev){
      _replacePageName();
      _populateCustomVar();
      if (target == null || target.length < 1)
      {
        target = 'comments';
      }
      if (referer == null || referer.length < 1)
      {
        referer = _ht;
      }
      if (customvar == null || customvar.length < 1)
      {
        customvar = custom_var;
      }
      if (prev == null || prev.length < 1)
      {
        prev = _fC(escape(_hr));
      }
      else if (prev == "null")
      {
        prev = "";
      }
      else
      {
        prev = _fC(escape(prev));
      }
      _w.open('https://secure.opinionlab.com/ccc01/comment_card.asp?time1='+_tm+'&time2='+(new Date()).getTime()+'&prev='+prev+'&referer='+_fC(referer)+'&height='+_sH+'&width='+_sW+'&custom_var='+customvar, target,'width=535,height=192,screenX='+((_sW-535)/2)+',screenY='+((_sH-192)/2)+',top='+((_sH-192)/2)+',left='+((_sW-535)/2)+',resizable=yes,copyhistory=yes,scrollbars=no');

    }
  ,    O_GoT:function(_p){
      _d.write('<a href=\'javascript:O_LC()\'>'+_p+'</a>');
    }
  };
})();

require(['uitk', 'gc/pageModel', 'jquery', 'gc/errorLogging'], function(uitk, pageModel, $, errorLogging) {
  try {
   var activateAlertBanner = function ($headerAlertBanner) {
       return $headerAlertBanner
           .removeClass('hidden')
           .addClass('active');
   }

    var setupTravelArranger = function ($headerAlertBanner) {
        // setup arrangee name
        $headerAlertBanner.find('#arrangee-first-name').text(pageModel.user.firstName);
        $headerAlertBanner.find('#arrangee-last-name').text(pageModel.user.lastName);
    }

   if(pageModel && pageModel.user && pageModel.user.arranged && !pageModel.user.agent) {
       var $headerAlertBanner = $('#header-alert-banner');

       setupTravelArranger($headerAlertBanner);
       activateAlertBanner($headerAlertBanner);
   }
 } catch (e) {
   errorLogging.logError(e, 'wizard', 'travel-arranger.js', 'main');
 }
});

require(['uitk', 'gc/pageModel', 'jquery', 'gc/errorLogging'], function(uitk, pageModel, $, errorLogging) {
    try {
        var agentBarUrl = "/agent/expe/agentbar";

        var loadAgentBar = function () {
            $( "#agent-arranger-bar-container" ).load(agentBarUrl);
        }

        if(pageModel && pageModel.user && pageModel.user.agent) {
            loadAgentBar();
        }
    } catch (e) {
        errorLogging.logError(e, 'wizard', 'agent-bar.js', 'main');
    }
});
(function() {

  define('gc/sp-car-details-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
    var template = function(data, strings) {

        var pricePeriod = "";
        if(data.pricePeriod === "daily"){
            pricePeriod = strings.daily;
        }else if(data.pricePeriod === "weekly"){
            pricePeriod = strings.weekly;
        }else if(data.pricePeriod === "total"){
            pricePeriod = strings.total;
        }

      var templateString = '<li class="scratchpad-item">'
          + '<a href="' + data.deepLink + '" class="item-link" data-onclick="">'
          + '<div class="item-data">'
              + '<span class="item-img-icon">'
                + '<img src="//images.trvl-media.com/cars' + data.thumbnailUrl + '" alt="' + data.carName + '" class="image" aspectRatio="1-1" onerror="this.onerror=null;this.src=\'/static/default/default/images/car/no_photo.png\';">'
              + '</span>'
              + '<h4 class="item-title">'+data.carName+'</h4>'
              + '<p class="item-date">' + data.pickupDate + ' - ' + data.dropOffDate + '</p>'
              + '<p class="item-dummy item-nested">'+data.pickupLocation+'</p>'
              + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>' + pricePeriod
              + '<p class="item-nested">' + data.lastSeen + '</p></div>'
          + '</div>'
          + '</a>'
          + '</li>';


      return templateString;
    };

    var module = function(data) {
      var prefix = '';
      var locStrings = scratchpadTray.view.strings.item;

      this.trayIndex = data.trayIndex;
      this.template = template;

      var locStrings = STRINGS.item;

      if (!data.product) return; // TODO: HANDLE THIS CASE

      this.type = 'carDetail';
      this.attributes = data.carDetail;

        // price module
        if (!this.get('price')) {
            this.set('price', '');
            this.set('lastSeen', 'See price');
        } else {
            var priceFromString = locStrings.from.replace('{{itemPrice}}', this.get('price'));
            this.set('price', priceFromString);

            if (this.get('dateTimeFormatType') === "SHORT_TIME") {
                this.set('lastSeen', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
            } else {
                this.set('lastSeen', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
            }
        }

      // generating html using template
      this.$el = $($.trim(this.template(this.attributes, locStrings)));
    };

    module.prototype = PROTO;


    return module;
  });

})();

(function() {

    define('gc/sp-activity-search-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
        var template = function(data, strings) {

            var ticketType = '';
            if(data.price) {
                ticketType = strings.perTraveler;
            }

            var templateString =   '<li class="scratchpad-item">'
                + '<a href="' + data.deepLink + '" class="item-link" data-onclick="">'
                + '<div class="item-data">'
                + '<span class="item-img-icon">'
                + '<span class="icon icon-activitiesalt"></span>'
                + '</span>'
                + '<h4 class="item-title">' + data.destination + '</h4>'
                + '<p class="item-watches item-nested">&nbsp;</p>'
                + '<div class="item-price-urgency lx"><strong class="price">' + data.price + '</strong>'
                + '<p class="item-package-message">' + ticketType + '</p>'
                + '<p class="item-nested">' + data.lastSeenDate + '</p></div>'
                + '</div>'
                + '</a>'
                + '</li>';

            return templateString;
        };

        var module = function(data) {
            var prefix = '';
            var locStrings = STRINGS.item;

            this.trayIndex = data.trayIndex;
            this.template = template;

            if (!data.product) return; // TODO: HANDLE THIS CASE

            this.type = 'activitySearch';
            this.attributes = data.activitySearch;

            if (!this.get('price')) {
                this.set('price', '');
                this.set('lastSeenDate', locStrings.seePrice);
            } else {
                if (this.get('dateTimeFormatType') === "SHORT_TIME") {
                    this.set('lastSeenDate', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
                } else {
                    this.set('lastSeenDate', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
                }
            }

            prefix = /\?/.test(this.get('deepLink')) ? '&' : '?';

            this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'ACS'));
            this.set('deepLink', (this.get('deepLink') + this.get('rfrrString')));

            this.$el = $($.trim(this.template(this.attributes, locStrings)));

            // TODO: make this data that the template uses to assign classes
            if (!this.get('startDate') || !this.get('endDate')) {
                this.$el.addClass('dateless');
            } else if (this.get('price') === '') {
                this.$el.addClass('priceless');
            }
        };

        module.prototype = PROTO;

        return module;
    });

})();

(function() {

    define('gc/sp-activity-details-item', ['jquery', 'gc/sp-tray-item-prototype', 'gc/sp-tray-strings'], function($, PROTO, STRINGS) {
        var template = function(data, strings) {
            var ticketType = '';
            if(data.price) {
                ticketType = strings.perTraveler;
            }

            var templateString =   '<li class="scratchpad-item">'
                + '<a href="' + data.deepLink + '" class="item-link" data-onclick="">'
                + '<div class="item-data">'
                + '<span class="item-img-icon">'
                + '<img src="' + data.thumbnail + '" alt="' + data.title + '" class="image lx" aspectRatio="1-1">'
                + '</span>'
                + '<h4 class="item-title">' + data.title + '</h4>'
                + '<p class="item-date">' + '<span class="icon icon-time"></span> ' + data.duration + '</p>' // LOC (-)
                + '<p class="item-watches item-nested">&nbsp;</p>'
                + '<div class="item-price-urgency"><strong class="price">' + data.price + '</strong>'
                + '<p class="item-package-message">' + ticketType + '</p>'
                + '<p class="item-nested">' + data.lastSeenDate + '</p></div>'
                + '</div>'
                + '</a>'
                + '</li>';

            return templateString;
        };

        var module = function(data) {
            var prefix = '';
            var locStrings = STRINGS.item;

            this.trayIndex = data.trayIndex;
            this.template = template;

            if (!data.product) return; // TODO: HANDLE THIS CASE

            this.type = 'activityDetail';
            this.attributes = data.activityDetail;

            if (!this.get('price')) {
                this.set('price', '');
                this.set('lastSeenDate', locStrings.seePrice);
            } else {
                if (this.get('dateTimeFormatType') === "SHORT_TIME") {
                    this.set('lastSeenDate', locStrings.asOfTime.replace('{{lastSeenTime}}', this.get('lastSeenDate')));
                } else {
                    this.set('lastSeenDate', locStrings.asOfDate.replace('{{lastSeenDate}}', this.get('lastSeenDate')));
                }
            }

            prefix = /\?/.test(this.get('deepLink')) ? '&' : '?';

            this.set('rfrrString', (prefix + 'rfrr=SP.Tray.' + this.trayIndex + '.' + 'ACD'));
            this.set('deepLink', (this.get('deepLink') + this.get('rfrrString')));

            if (this.get('thumbnail')) {
                this.set('thumbnail', (this.get('thumbnail')));
            }


            this.$el = $($.trim(this.template(this.attributes, locStrings)));

            // TODO: make this data that the template uses to assign classes
            if (!this.get('startDate') || !this.get('endDate')) {
                this.$el.addClass('dateless');
            } else if (this.get('price') === '') {
                this.$el.addClass('priceless');
            }
        };

        module.prototype = PROTO;

        return module;
    });

})();


define('gc/mobileAppBanner', ['jquery','env','dctk/dctk'], function ($,env,dctk) {

    var mobileAppBanner = mobileAppBanner || {};
    var prefix = (env.prefix);
    var contentVersion = env.version;
    var locale = env.locale;
    var siteId = env.siteId;

    if (contentVersion === 'local') { // don't set the prefix if this is a local version
        prefix = "";
    }
    else if (typeof prefix == "undefined" || prefix == null || prefix.length === 0) {
        var min = 'a'.charCodeAt();
        var max = 'c'.charCodeAt();
        var bucket = String.fromCharCode(Math.floor(Math.random() * (max - min + 1)) + min);
        prefix = ["//", bucket, ".travel-assets.com/globalcontrols-service"].join("");
    }

    mobileAppBanner.el = $('#mobile-app-banner-container');
    // var mobileAppBannerWrapper = $('#mobile-app-banner-wrapper');
    mobileAppBanner.init = function () {
      require('gc/abTest', function (abTest) {
        if (abTest.get(15805, null, true).value == 1 && mobileAppBanner.isMobile()) {
          mobileAppBanner.renderMadService();
        }
        else {
          mobileAppBanner.render(abTest);
        }
      });
    };

    mobileAppBanner.renderMadService  = function (){
      var mad_script = document.createElement('script');
      var os = 'desktop';
      if (Modernizr.appleios) {
        os = 'iOS';
      } else if (Modernizr.android) {
        os = 'Android';
      }
      var url = ['/mad-service/globalControls/gcHeader?containerId=mad-header-container'];
      url.push('&siteid=');
      url.push(siteId);
      url.push('&locale=');
      url.push(locale);
      url.push('&pageName=gc.header-from-content');
      url.push('&os=');
      url.push(os);
      // url.push('&brand=');
      // url.push(pageModel.site.brandName);
      mad_script.setAttribute('src', url.join(''));

      document.head.appendChild(mad_script);
    };

    mobileAppBanner.isMobile = function () {
       return window.innerWidth <= 491;
    };

    mobileAppBanner.render = function (abTest) {

        var loadHeaderTemplateAndRender = function () {

          require('gc/script-loader', function(loader){

            var tmplUrl = prefix + '/content/' + contentVersion + '/templates/' + siteId + '/' + locale + '/' + 'mobile-download-banner.js';
            loader(tmplUrl, function () {
              if (!$.isEmptyObject(cugModel)) {
                cugModel.delayBanner = true;

                var delayBannerTest = abTest.get(15081,null, true ).value;

                if(delayBannerTest){
                  cugModel.delayBanner = false;
                }


                if (Modernizr.appleios){
                  if(delayBannerTest && cugModel.iosAppBannerUrlDelayTest)
                    cugModel.appUrl = cugModel.iosAppBannerUrlDelayTest;
                  else
                    cugModel.appUrl = cugModel.iosAppBannerUrl;
                }

                else if (Modernizr.android){
                  if(delayBannerTest && cugModel.androidAppBannerUrlDelayTest)
                    cugModel.appUrl = cugModel.androidAppBannerUrlDelayTest;
                  else
                    cugModel.appUrl = cugModel.androidAppBannerUrl;
                }

                else{
                  cugModel.appUrl = "";
                }

                if(siteId == 70201){
                  cugModel.downloadBannerBottomText = cugModel.downloadBannerBottomText.replace("{{brand}}", "Orbitz");
                }
                else{
                  cugModel.downloadBannerBottomText = cugModel.downloadBannerBottomText.replace("{{brand}}", "Expedia+");
                }

                require('handlebars', function (Handlebars) {
                  mobileAppBanner.el.html(Handlebars.templates['header/cobrand/mobile-download-banner/brandingheader'](cugModel));

                });
              }
              else{
                dctk.logging.logError("Mobile Download Banner - HBS CugModel Empty", new Error("Mobile Download Banner - HBS Model Empty"), []);
              }

            });
          });
        };

        var setCloseCookie = function(){
            var expire=new Date();
            expire.setTime(expire.getTime()+(10*24*60*60*1000));
            document.cookie="MDBClose=yes; expires="+expire.toGMTString();
        };
        var loadTrackingAndClick = function() {
          if ( dctk && dctk.onReady && dctk.trackEvent && (Modernizr.appleios || Modernizr.android)) {
              dctk.onReady(function () {
                  dctk.trackEvent({
                      trackEvents : "event267"
                  });
                  $(document).on('click', '#mobile-app-banner-link', function (e) {
                      dctk.trackEvent({
                          trackEvents: "event268",
                          trackVars : {
                              prop16: 'GH.Banner.App.GCHEADERMWEB',
                              eVar28: 'GH.Banner.App.GCHEADERMWEB'
                          }
                      });
                  });
                  $('#close-banner-anime').live("click",function (e) {
                      document.getElementById('mobile-app-banner-wrapper').style.setProperty("display", "none", "important");
                      setCloseCookie();
                      if (dctk && dctk.trackEvent) {
                          dctk.trackEvent({
                              trackVars : {
                                  prop16: 'GH.Banner.App.Close',
                                  eVar28: 'GH.Banner.App.Close'
                              }
                          });
                        }
                  });
              });
          }
        }

        var isWebViewDevice = navigator.userAgent.indexOf("app.webview") >-1;
        var mobileDownloadBannerTest = abTest.get(14592,null, true ).value;
        var cometBrandDownloadBannerTest = abTest.get(14763,null, true ).value;
        var orbitzBrandDownloadBannerTest = abTest.get(15714,null, true ).value;
        var travelocityBrandDownloadBannerTest = abTest.get(15715,null, true ).value;
        if (document.cookie.indexOf("MDBClose=") < 0 && (mobileDownloadBannerTest || cometBrandDownloadBannerTest || orbitzBrandDownloadBannerTest || travelocityBrandDownloadBannerTest) && !isWebViewDevice){
            $.when(loadHeaderTemplateAndRender()).then(loadTrackingAndClick());
           }
          else {
             if(document.getElementById('mobile-app-banner-wrapper')) {
               loadTrackingAndClick();
             }
          }
        };
    return mobileAppBanner;
});

require(['gc/mobileAppBanner','env'], function (mobileAppBanner,env) {
  if(env.siteId == "29" && mobileAppBanner.isMobile()){
    mobileAppBanner.renderMadService();
  }
  else{
    mobileAppBanner.init();
  }
});

if((document.cookie.indexOf("MDBClose") >= 0 || navigator.userAgent.indexOf("app.webview") >-1) && document.getElementById('mobile-app-banner-wrapper')) {
  document.getElementById('mobile-app-banner-wrapper').style.setProperty("display", "none", "important");
}

require(['jquery', 'uitk', 'gc/abTest', 'gc/pageModel'], function ($, uitk, abTest, pageModel) {

  var $searchIcon = $('.open-search-icon-search');
  var $closeIcon = $('.open-search-icon-close');
  var $openSearchMobile = $('.open-search-search-bar-mobile');
  var $primarySiteHeaderBanner = $('.site-header-primary-banner');
  var $searchBarLabel = $('.search-query-label');
  var $searchBarInput = $('.open-search-query');
  var $searchButton = $('.open-search-search-button');
  var $openSearchBarWrapper = $('.open-search-wrapper');
  var $desktopSearchBarQueryWrapper = $('.open-search-search-bar-desktop').find('.search-query-wrapper');
  var hiddenClass = 'hidden';
  var visuallyHiddenClass = 'visuallyhidden';
  var searchBarFocusClass = 'open-search-bar-focus';
  var types = { 'desktop':0,'mobile':1 };
  var assetLinkPrefix = $('#assetLinkPrefix').text();
  var urlConfig = {
    url: '/search-results',
    params: {
      q: '',
      rfrr: 'globalcontrols-header'
    }
  };

  var mqDesktopMax = 1176;
  var mqDesktopMin = 960;
  var desktopSearchBarWidthDifference = 770;
  var searchButtonWidth = 96;
  var searchButtonMargin = 8;
  var experimentNumber = '12087';

  $searchButton.hide();

  var abBucket = abTest.get(experimentNumber);

  var isLang = false;

  var buttonClicked = false;

  switch(pageModel.site.id){
    case 1: if(pageModel.site.langId === 1033){
              isLang=true;
            }
            break;
    case 3: if(pageModel.site.langId === 2057){
              isLang=true;
            }
            break;
  }

  if (abBucket && abBucket.value === 1 && isLang && typeof window.turnOnHeaderOpenSearch ===  "function") {
    var url = assetLinkPrefix + "/config/js/jquery-ui-1.11.4.js";

    loadJqueryUIScript(url, function () {
      initializeOpenSearchBar();
    });
  }

  function initializeOpenSearchBar() {
    $searchIcon.removeClass(hiddenClass);
    $openSearchBarWrapper.removeClass(hiddenClass);

    var windowWidth = $(window).width();
    setSearchBarDesktopWidth(windowWidth, false);

    setListeners();
  }

  function loadJqueryUIScript(url, callback) {

    var script = document.createElement("script")
    script.type = "text/javascript";
    if (script.readyState) { //ie
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else { //Others
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }


  function setListeners() {

    // Show mobile search bar
    $searchIcon.on('click', function () {
      $primarySiteHeaderBanner.addClass(visuallyHiddenClass);
      $openSearchMobile.removeClass(visuallyHiddenClass);
      uitk.utils.focusElement($searchBarInput);
    });

    // Hide mobile search bar
    $closeIcon.on('click', function () {
      $openSearchMobile.addClass(visuallyHiddenClass);
      $primarySiteHeaderBanner.removeClass(visuallyHiddenClass);
    });

    $searchButton.mousedown(function () {
      buttonClicked = true;
      if($(window).width() >= mqDesktopMin) {
          performSearch(types.desktop);
      }
      else{
          performSearch(types.mobile);
      }
    });

    // Listen for 'enter' keypress on the search bar
    $searchBarInput.keypress(function (e) {
      if (e.which == 13) {
          if($(window).width() >= mqDesktopMin) {
              performSearch(types.desktop);
          }
          else{
              performSearch(types.mobile);
          }
      }
    });

    $searchBarInput.focusin(function () {
      $searchBarInput.addClass(searchBarFocusClass);
      $searchBarLabel.addClass(searchBarFocusClass);
      $searchButton.show();
      var windowWidth = $(window).width();
      setSearchBarDesktopWidth(windowWidth, true);
    });

    $searchBarInput.focusout(function () {
      if(!(buttonClicked)) {
        $searchButton.hide();
        $searchBarInput.removeClass(searchBarFocusClass);
        $searchBarLabel.removeClass(searchBarFocusClass);
        var windowWidth = $(window).width();
        setSearchBarDesktopWidth(windowWidth, false);
      }
      else{
        buttonClicked = false;
      }
    });

    // Using js to resize the search bar since the current header layout does not allow for an
    // auto-margin, 100% width container in between the logo and left link with the current main-header
    $(window).resize(function() {
      var windowWidth = $(window).width();
      $searchBarInput.blur();
      setSearchBarDesktopWidth(windowWidth, false);
    });
  }

  /**
   * Set the width of the search bar for the dektop view
   * @param {Number} windowWidth
   * @param {Boolean} isSearchBarFocus
   */
  function setSearchBarDesktopWidth(windowWidth, isSearchBarFocus) {

    // If we are in desktop width
    if (windowWidth >= mqDesktopMin) {

      $openSearchMobile.addClass(visuallyHiddenClass);

      var windowWithToCalculate = windowWidth;

      // On really large screens only calculate to the max width of the content
      if (windowWidth > mqDesktopMax) {
        windowWithToCalculate = mqDesktopMax;
      }

      var newWidth = windowWithToCalculate - desktopSearchBarWidthDifference;

      // If the search bar is in focus, we display the search button so we need to subtract that width
      if (isSearchBarFocus) {
        newWidth = newWidth - searchButtonWidth - searchButtonMargin;
      }

      $desktopSearchBarQueryWrapper.width(newWidth);
    }
  }

  /**
   * Redirect the user to the Open Search page
   * @param {String} query - user query
   */
  function performSearch(type,query) {
    var q = query || getQuery(type);
    var url = getOpenSearchUrl(q);

    $($searchBarInput).val('');

    uitk.redirect(url);
  }

  /**
   * Get the user query from the search bar
   *
   * @return {string}
   */
  function getQuery(type) {
    var queries = $searchBarInput
      .map(function(i, el) {
        return $(el).val();
      })
    return queries[type];
  }

  /**
   * Get a url given an user query
   * @param {String} query - user query
   * @return {String}
   */
  function getOpenSearchUrl(query) {
    var params = urlConfig.params;
    params.q = query;
    var paramString = $.param(params);
    return urlConfig.url + '?' + paramString;
  }
});

require(['uitk', 'jquery'], function(uitk, $) {
  $('.skip-nav a[href^=#]').on('click', function(e) {
    e.preventDefault();
    var focusId = e.currentTarget.getAttribute('href');
    uitk.utils.focusElement($(focusId));
  });
});
require(['uitk', 'gc/pageModel', 'jquery', 'gc/errorLogging'], function(uitk, pageModel, $, errorLogging) {
    try {
        // remove all HCOM nav headers except Packege&Flights
        if (pageModel && pageModel.site && pageModel.site.id === 1170 && pageModel.user && pageModel.user.agent) {

            var packageFlightsTab = $("#hdr-packages").parent();
            $("#menu-bar ul:first").children().remove();
            $("#menu-bar ul:first").append(packageFlightsTab);

            $("ul.nav-secondary").remove();
        }

    } catch (e) {
        errorLogging.logError(e, 'wizard', 'gco-agent.js', 'main');
    }
});

 var GSS_MODAL_VERSION = '1.0.65'; define('gss-modal', ['uitk', 'gss-view-handler', 'gss-forms'], 
    function(uitk, gssView, gssForms) { 
    'use strict';

    var cmF = gssForms.common;
    var uitkModal = {};
    var deferrerActions = [];
    var deferredParams = {};
    var FB_AUTH_ENDPOINT = "/user/third-party-login";
    var successURL = window.location.pathname + window.location.search;
    var referrerURL = window.location.pathname + window.location.search;
    var modalAppendToken;
    var modalCloseToken;
    var recaptchaUrl = "https://www.google.com/recaptcha/api.js?render=explicit";

    function setupDeferred (deferredHtml) {
        $('#gss-deferred-content').ready(function (modal) {
            if ( (typeof dctk) !== 'undefined' && dctk.ewePerformance ) {
                dctk.ewePerformance.mark('gss-modal_deferred_end_uitk_modal');
            } else {
                window.performance.mark('gss-modal_deferred_end_uitk_modal');
            }
            $('#gss-deferred-content').html(deferredHtml);
            
            require(['gss-omniture-tracker'], function (omniture) {
                omniture.initDeferred(deferrerActions);
            });    
        });
    }

    function gotoSignUp(event) {
        deferrerActions.push('switchToSignUp');
        gssView.transitToSignUp();
    } 
    
    function gotoSignIn(event) {
        deferrerActions.push('switchToSignIn');
        gssView.transitToSignIn();
    }

    function loadJS(url){
        var scriptElement = document.createElement("script");
        scriptElement.type = "application/javascript";
        scriptElement.src = url;
        scriptElement.async = true;
        document.getElementsByTagName('head')[0].appendChild(scriptElement);
    }

    function mapLocaleToGoogleLocale(expediaLocale) {
        var localeMap = {
            "da_DK": "da", "de_CH": "de-CH",
            "de_DE": "de", "en_GB": "en-GB",
            "en_US": "en", "en_SG": "en",
            "en_MY": "en", "en_AU": "en",
            "en_PH": "en", "id_ID": "en",
            "zh_TW": "en", "en_IE": "en",
            "ru_RU": "en", "en_CA": "en",
            "es_AR": "es", "es-ES": "es",
            "es_MX": "es-419", "fi_FI": "fi",
            "fr_CA": "fr-CA", "fr_FR": "fr",
            "it_IT": "it", "ja_JP": "ja",
            "ko_KR": "ko", "nb_NO": "no",
            "nl_NL": "nl", "nl_BE": "nl",
            "pt_BR": "pt-BR", "sv_SE": "sv",
            "th_TH": "th", "vi_VN": "vi",
            "zh_CN": "zh-CN", "zh_HK": "zh-HK"
        };
        if (localeMap.hasOwnProperty(expediaLocale)) {
            return localeMap[expediaLocale];
        } else {
            return null;
        }
    }

    function facebookAuthWindow() {
        var width = 475;
        var height = 315;
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var screenWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var screenHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = ((screenWidth / 2) - (width / 2)) + dualScreenLeft;
        var top = ((screenHeight / 2) - (height / 2)) + dualScreenTop;
        var fbAuthWindow = window.open(FB_AUTH_ENDPOINT , "fb-auth-window" , 'channelmode=yes,width=' + width + ',height=' + height + ',top=' + top + ', left=' + left,'resizable=no,toolbar=no,menubar=no,location=no,status=no');
        return fbAuthWindow;
    }

    function facebookSignInSignUp(id) {
        $(id).attr("disabled",true);
        window.tpLoginSuccess = undefined;
        var fbAuthWindow = facebookAuthWindow();
        var timer = setInterval(function () {
            if(fbAuthWindow.closed){
                $(id).attr("disabled",false);
                clearInterval(timer)
                if(window.tpLoginSuccess != undefined && window.tpLoginSuccess) {
                    initFb();
                }
            }
        },100);

    }

    function initFb()
    {
        var options = {
            provider: "Facebook",
            referrerUrl: referrerURL,
            successUrl: successURL,
            modal: 'modal'
        };
        executeWithDelay(50, function(){
            if (((typeof authtk) !== 'undefined') && ((typeof $LAB) !== 'undefined')) {
                return true;
            }
            return false;
        }, function() {
            if ( uitkModal.open ) {
                uitkModal.close();
            }
            authtk.showConnectModal(options);
        });
    }

    function executeWithDelay(repeatAfter, shouldExecute, onComplete) {
        var waitDuration = repeatAfter || 50;
        if (shouldExecute()) {
            if(onComplete){
                onComplete();
            }
        } else {
            setTimeout(function() { executeWithDelay(waitDuration, shouldExecute, onComplete) }, waitDuration);
        }
    }

    function notifyErrorDependencyNotLoaded (dependencyId) {
    if ( (typeof dctk) !== 'undefined' && dctk.logging) {
        dctk.logging.logError("GSS_MODAL_ERROR"
            , new Error(dependencyId + " not loaded due to network error. Modal won't work.")
            , ['topic=GSS', 'experimentId=d/a']);
    }
    }

    function sendOmnitureDataForFb(id, pageName, element) {
        if((typeof dctk) !== 'undefined' && dctk.trackAction){
            dctk.onReady(function () {
                dctk.trackAction(id, element, {pageName: pageName, prop16: id, eVar28: id});
            });
        }
    }

    function loadRecaptchaIfApplicable() {
        if(gssModal.evaluateRecaptchaModalFlag){
            gssModal.loadRecaptchaJs(deferredParams.locale,null);
        }
    }

    var gssModal = {
        
        deferredLoaded : false,
        evaluateRecaptchaModalFlag : undefined,
        
        initDomEmbedded : function (params) {

            deferredParams = params;
            cmF.redirectionUrl= params.rurl;

            if ( uitkModal.open ) {
                /* already initialized */
                return;
            }

            /* pick content up from DOM */
            var modalOrigContainer = $('#' + gssForms.common.mdlCntId);

            uitkModal = uitk.modal.create({
                'content': modalOrigContainer[0].outerHTML,
                'modalId': gssForms.common.modalId,
                'background': true,
                'dismiss': true,
                'manual': 'both',
                'classes' : 'gss-elem-4-cols'
            });

            modalOrigContainer.remove();
        },
        
        init : function (modalHtmlContent, params) {

            if ( uitkModal.open ) {
                /* already initialized */
                return;
            }

            deferredParams = params;
            cmF.redirectionUrl= params.rurl;

            uitkModal = uitk.modal.create({
                'content': modalHtmlContent,
                'modalId': gssForms.common.modalId,
                'background': true,
                'dismiss': true,
                'manual': 'both',
                'classes' : 'gss-elem-4-cols'
            });
        },

        clearForms : function () {},
        
        getUitkModal : function () {
            return uitkModal;
        },
        
        openSignIn : function () {
            $('body').addClass('body-fixed');
            if(modalAppendToken !== undefined) {
                uitk.unsubscribe('modal.appended',modalAppendToken);
            }
            if(modalCloseToken !== undefined){
                uitk.unsubscribe('modal.beforeClose',modalCloseToken);
            }
            this.preSetup();
            uitkModal.open();
            this.setupModalEventtHandlers();
            this.setupFbLoginEventtHandlers();
            this.clearForms();
            gssView.transitToSignIn();
        },
        
        openSignUp : function () {
            $('body').addClass('body-fixed');
            if(modalAppendToken !== undefined) {
                uitk.unsubscribe('modal.appended',modalAppendToken);
            }
            if(modalCloseToken !== undefined){
                uitk.unsubscribe('modal.beforeClose',modalCloseToken);
            }
            this.preSetup();
            uitkModal.open();
            this.clearForms();
            this.setupModalEventtHandlers();
            this.setupFbLoginEventtHandlers();
            gssView.transitToSignUp();
        },

        preSetup : function () {
            modalCloseToken = uitk.subscribe('modal.beforeClose', function(topic, $modal) {
                if ($modal.options.modalId === gssForms.common.modalId) {
                    var activeView = gssView.presentView();

                    require(['gss-omniture-tracker'], function (omniture) {
                        if(activeView !== null) {
                            $('body').removeClass('body-fixed');
                            if (activeView.toUpperCase() === "GSS-SIGNIN-VIEW") {
                                omniture.signIn.closeView();
                            } else if (activeView.toUpperCase() === "GSS-SIGNUP-VIEW") {
                                omniture.signUp.closeView();
                            } else if (activeView.toUpperCase() === 'GSS-FORGOT-PASSWORD-VIEW') {
                                omniture.resetPassword.closeView();
                            }
                        }
                    });


                    gssView.deactivateViews();
                    $modal.close();
                }
            });

            modalAppendToken = uitk.subscribe('modal.appended', function(topic, $modal) {
                if ($modal.options.modalId === gssForms.common.modalId) {
                    if ( ! gssModal.deferredLoaded ) {

                        if ( (typeof dctk) !== 'undefined' && dctk.ewePerformance) {
                            dctk.ewePerformance.mark('gss-modal_deferred_start_uitk_modal');
                        } else {
                            window.performance.mark('gss-modal_deferred_start_uitk_modal');
                        }

                        if(gssModal.evaluateRecaptchaModalFlag == undefined) {
                            if(deferredParams.evaluateRecaptchaGCFlag !== undefined){
                                gssModal.evaluateRecaptchaModalFlag = deferredParams.evaluateRecaptchaGCFlag;
                                loadRecaptchaIfApplicable();
                            }else{
                                if ((typeof dctk) !== 'undefined' && dctk.evaluateExperiment) {
                                    dctk.evaluateExperiment({
                                        id: 14261, callback: function (experiment) {
                                            if (!experiment.error && experiment.value === 3) {
                                                gssModal.evaluateRecaptchaModalFlag = true;
                                            } else {
                                                gssModal.evaluateRecaptchaModalFlag = false;
                                            }
                                            loadRecaptchaIfApplicable();
                                        }
                                    });
                                }
                            }
                        }
                        
                        loadJS("https://a.travel-assets.com/gss-loader/user/gss/common/authtk-gss-min.js");
                        loadJS("https://a.travel-assets.com/gss-loader/user/gss/common/LAB-gss-min.js");

                        $.ajax({
                            url: '/user/global-login',
                            type: 'GET',
                            data: deferredParams,
                            headers: {
                                'isDeferred' : true
                            },
                            success : function(result){
                                setupDeferred(result);
                            },
                            error : function () {
                                notifyErrorDependencyNotLoaded('gss-modal-deferred-content');
                            }
                        });
                    }
                }
            });
        },
        
        setupModalEventtHandlers : function () {
            gssForms.init();
            $(gssForms.signUp.gotoSignInButton).click(gotoSignIn);
            $(gssForms.signIn.gotoSignUpButton).click(gotoSignUp);
            $(gssForms.common.uitkModalContainer).bind('transitionend', function(event) {
                if (gssForms.common.isDesktop) {
                    gssView.focus();
                }
            });

            if (gssForms.common.isDesktop) {
                gssForms.signUp.password.setAttribute('type', 'password');
                gssForms.signIn.password.setAttribute('type', 'password');
            }

            if(deferredParams.showLoyaltyCheckBox){
                $(gssForms.signUp.joinProgramDiv).removeClass("hidden");
                if(deferredParams.preCheckLoyalyBox) {
                    gssForms.signUp.joinProgram.setAttribute('checked', 'true');
                }
            }
        },

        setupFbLoginEventtHandlers : function () {
            $(gssForms.signUp.facebookSignupButton).click(function (e) {
                var  target = e.target || e.srcElement;
                facebookSignInSignUp(gssForms.signUp.facebookSignupButton);
                sendOmnitureDataForFb('GSS.CreateAccount.FB.Connect', 'page.Account.GSS.CreateAccount', target);
            });
            $(gssForms.signIn.facebookSigninButton).click(function (e) {
                var  target = e.target || e.srcElement;
                facebookSignInSignUp(gssForms.signIn.facebookSigninButton);
                sendOmnitureDataForFb('GSS.Login.FB.Connect', 'page.Account.GSS.SignIn', target);
            });
        },

        loadRecaptchaJs : function(locale,onloadCallBack) {
            var hl = mapLocaleToGoogleLocale(locale);
            var scriptElement = document.createElement("script");
            scriptElement.type = "application/javascript";
            scriptElement.src = recaptchaUrl;

            scriptElement.src += hl!=null ? ("&hl="+hl) : "" ;
            scriptElement.src +=  onloadCallBack!=null ? ("&onload="+onloadCallBack) : "" ;

            scriptElement.async = true;
            scriptElement.defer = true;
            document.getElementsByTagName('head')[0].appendChild(scriptElement);
        }
    };
    
    return gssModal;
});

define('gss-forms', function () {
    
    var gssForms = {
        common: {
            mdlCntId: 'gss-modal-main-container',
            modalId: 'gss-modal-01',
            activeView: null
        },
        init : function () {
            initCommonForm();
            initSignInForm();
            initSignUpForm();
        }
    };

    var cmnF = gssForms.common;
    var suF = gssForms.signUp = {};
    var siF = gssForms.signIn = {};
    
    function initCommonForm () {
        cmnF.modalContainer= $('#' + cmnF.mdlCntId)[0];
        cmnF.uitkModalContainer= $('#' + cmnF.modalId)[0];
        cmnF.uitkModalBody = cmnF.uitkModalContainer.getElementsByClassName("modal-body")[0];
        cmnF.interstitialAriaMsg= $('#gss-interstitial-aria-msg')[0].value;
        cmnF.isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
        cmnF.isDesktop = !cmnF.isMobile;
    }
    
    function initSignUpForm () {
        suF.container= $('#gss-signup-view')[0];
        suF.firstName= $('#gss-signup-first-name')[0];
        suF.lastName= $('#gss-signup-last-name')[0];
        suF.email= $('#gss-signup-email')[0];
        suF.password= $('#gss-signup-password')[0];
        suF.passwordIcon = $('#gss-signup-password-icon')[0];
        suF.passwordIconButton = $('#gss-signup-password-icon-button')[0];
        suF.joinProgram= $('#gss-join-program-check')[0];
        suF.submitButton= $('#gss-signup-submit')[0];
        suF.gotoSignInButton= $('#gss-goto-signin')[0];
        suF.facebookSignupButton= $('#gss-signup-login-facebook-button')[0];
        suF.interstitial= $('#gss-signup-interstitial')[0];
        suF.genericErrorMessage= $('#gss-signup-error-message')[0];
        suF.duplicateEmail= $('#gss-signup-duplicate-email')[0];
        suF.unregisteredAccount= $('#gss-signup-unregistered-account-exists')[0];
        suF.joinProgramDiv= $('#gss-join-program')[0];
        
        if ( ! suF.joinProgram ) {
            suF.joinProgram = {
                checked : true
            };
        }
    }

    function initSignInForm () {
        siF.container = $('#gss-signin-view')[0];
        siF.email = $('#gss-signin-email')[0];
        siF.password = $('#gss-signin-password')[0];
        siF.passwordIcon = $('#gss-signin-password-icon')[0];
        siF.keepMeSignIn = $('#gss-keep-signin-check')[0];
        siF.submitButton = $('#gss-signin-submit')[0];
        siF.gotoSignUpButton = $('#gss-goto-signup')[0];
        siF.gotoForgotPasswordButton = $('#gss-go-to-forgot-password')[0];
        siF.facebookSigninButton= $('#gss-signin-login-facebook-button')[0];
        siF.captchaForm = document.forms['gss-signin-captcha'];
    }
    
    return gssForms;
});
define('gss-view-handler', ['gss-forms'], function(gssForms) {
    'use strict';

    var UITK_HIDDEN_CLASS = 'visuallyhidden';
    var UITK_OVERRIDE_GSS_STYLE = 'gss-uitk-default';
    var GSS_NO_HERO_BANNER_CLASS = 'non-hero-img-container';

    var cmF = gssForms.common;
    var suF = gssForms.signUp;
    var siF = gssForms.signIn;
    var isModalOpen = false;

    return {
        transitToSignIn : function () {
            this.activateView(siF.container);
        },
        
        transitToSignUp : function () {
            this.activateView(suF.container);
        },
        focus : function () {
            if (cmF.isDesktop && isModalOpen) {
                $(cmF.activeView).find('input[type=email],input[type=text]').filter(':visible:first').focus();
            }
        },
        deactivateViews : function () {
            if ( cmF.activeView && cmF.activeView.classList ) {
                cmF.activeView.classList.add(UITK_HIDDEN_CLASS);
                cmF.uitkModalContainer.classList.remove(cmF.activeView.id);
                cmF.activeView = null;
                isModalOpen = false;
            }
        },
        activateView : function (domView) {
            var containerClassList = cmF.uitkModalContainer.classList;

            this.deactivateViews();

            if ( domView && domView.classList ) {
                domView.classList.remove(UITK_HIDDEN_CLASS);
                containerClassList.remove(UITK_OVERRIDE_GSS_STYLE);
                containerClassList.add(domView.id);
                cmF.activeView = domView;

                if ( containerClassList ) {
                    if ( domView.dataset.heroImgEnabled == 'true' ) {
                        containerClassList.remove(GSS_NO_HERO_BANNER_CLASS);
                    } else {
                        containerClassList.add(GSS_NO_HERO_BANNER_CLASS);
                    }
                }
                
                this.focus();
                isModalOpen = true;
            }
        },
        presentView : function () {
            if (  cmF.activeView && cmF.activeView.classList ) {
                return cmF.activeView.id;
            }
            return null;
        }
    };
});
require(['gc/abTest', 'gc/pageModel', 'jquery'], function(abTest, pageModel, $) {
  var testEvaluation = abTest.get(16316, null, true);
  var secondaryBannerContainerElement = $('.cols-row.secondary-branding-container');

  if ($(secondaryBannerContainerElement).length > 0 && testEvaluation.value === 1) {
    $(secondaryBannerContainerElement).hide();
  }
});

require(['jquery', 'dctk/dctk', 'cookies'], function($, dctk, Cookies) {
  //dctk is required because dctk defines the variable utag_data which is needed to exclude some pageNames from the test
  var storefront_2017_B2P_experimentId = 15939;
  var storefront_2017_B2P_cookieKey = 'Storefront_2017_B2P';
  var storefront_2017_B2P_variantClassPrefix = 'Storefront_2017_B2P_variant_';
  var storefront_2017_B2P_cookieValue = Cookies.get(storefront_2017_B2P_cookieKey) || 0;
  var isExcludedPage = [
    'page.TravelGuides.Hotels.Metro',
    'page.TravelGuides.Hotels.Train',
    'page.TravelGuides.Hotels.MultiCity'
  ].indexOf(
    window.utag_data !== undefined && $.type(window.utag_data) === 'object' &&
    window.utag_data.pageInfo !== undefined && $.type(window.utag_data.pageInfo) === 'object' &&
    window.utag_data.pageInfo.pageName !== undefined ?
    window.utag_data.pageInfo.pageName :
    ''
  ) > -1;

  var isDesignVariant = function (variantValue) {
    return [1, 2].indexOf(parseInt(variantValue)) > -1;
  }
  var isControlVariant = function(variantValue) {
    return [0, 3].indexOf(parseInt(variantValue)) > -1;
  }
  var newVariantAndOldVariantAreDiff = function (newVariantValue, oldVariantValue) {
    return parseInt(newVariantValue) !== parseInt(oldVariantValue);
  }
  var storefront_2017_B2P_setVariant = function (newVariantName, oldVariantName) {
    var headerContainerElement = $("#header-container div[role='banner']");
    var headerImageElement = $('#header-logo > img', headerContainerElement);

    if($.type(oldVariantName) === 'string') {
      headerContainerElement.removeClass(oldVariantName);
      headerContainerElement.addClass(newVariantName);
      // logic for update the image with a new request to DMS
      var imageUrl = headerImageElement.attr('src');
      var imageUrlQueryParamsArray = imageUrl.substr(imageUrl.indexOf('?') + 1).split('&');
      var oldVariantQueryParamIndex = imageUrlQueryParamsArray.indexOf('test=' + oldVariantName);
      oldVariantQueryParamIndex > -1 && (imageUrlQueryParamsArray.splice(oldVariantQueryParamIndex, 1));
      imageUrlQueryParamsArray.push('test=' + newVariantName);
      headerImageElement.attr('src', imageUrl.substr(0, imageUrl.indexOf('?') + 1) + imageUrlQueryParamsArray.join('&'));
    } else {
      headerContainerElement.addClass(newVariantName);
      // logic for update the image with a new request to DMS
      headerImageElement.attr('src', headerImageElement.attr('src') + '&test=' + newVariantName);
    }
  }
  var storefront_2017_B2P_removeVariant = function(variantName) {
    var headerContainerElement = $("#header-container div[role='banner']");
    var headerImageElement = $('#header-logo > img', headerContainerElement);
    headerContainerElement.removeClass(variantName);
    // logic for update the image with a new request to DMS
    var imageUrl = headerImageElement.attr('src');
    var imageUrlQueryParamsArray = imageUrl.substr(imageUrl.indexOf('?') + 1).split('&');
    var oldVariantQueryParamIndex = imageUrlQueryParamsArray.indexOf('test=' + variantName);
    oldVariantQueryParamIndex > -1 && (imageUrlQueryParamsArray.splice(oldVariantQueryParamIndex, 1));
    headerImageElement.attr('src', imageUrl.substr(0, imageUrl.indexOf('?') + 1) + imageUrlQueryParamsArray.join('&'));
  }

  if(!isExcludedPage && isDesignVariant(storefront_2017_B2P_cookieValue)) {
    storefront_2017_B2P_setVariant(storefront_2017_B2P_variantClassPrefix + storefront_2017_B2P_cookieValue);
  }

  require(['gc/abTest'], function(abTest) {

    var storefront_2017_B2P_evaluateExperiment = function(experimentId) {
      var deferred = $.Deferred();

        //in order to test this experiment in local i encapsulated the abTest call in a deferred object, if you want to test this uncomment the below line of code and comment the abTest.get line
        //setTimeout(function() { deferred.resolve({ value: Math.floor(0 + Math.random() * 4) }); }, 1000);

      deferred.resolve(abTest.get(experimentId, null, true));
      return deferred.promise();
    }

    if(!isExcludedPage) {
      storefront_2017_B2P_evaluateExperiment(storefront_2017_B2P_experimentId)
      .then(function(testEvaluation) {
        Cookies.set(storefront_2017_B2P_cookieKey, testEvaluation.value);
        if (isDesignVariant(testEvaluation.value) && isDesignVariant(storefront_2017_B2P_cookieValue) && newVariantAndOldVariantAreDiff(testEvaluation.value, storefront_2017_B2P_cookieValue)) {
          storefront_2017_B2P_setVariant(storefront_2017_B2P_variantClassPrefix + testEvaluation.value, storefront_2017_B2P_variantClassPrefix + storefront_2017_B2P_cookieValue);
        } else if (isDesignVariant(testEvaluation.value) && isControlVariant(storefront_2017_B2P_cookieValue)) {
          storefront_2017_B2P_setVariant(storefront_2017_B2P_variantClassPrefix + testEvaluation.value);
        } else if (isControlVariant(testEvaluation.value) && isDesignVariant(storefront_2017_B2P_cookieValue)) {
          storefront_2017_B2P_removeVariant(storefront_2017_B2P_variantClassPrefix + storefront_2017_B2P_cookieValue);
        }
      });
    }

  });

});

define('gc/abTestRegistryOverride', function() {
    'use strict';
    // NOTE: Adding any tests to this list must also be added here:
    // https://ewegithub.sb.karmalab.net/EWE/globalcontrols-service/blob/master/web/src/main/java/com/expedia/www/globalcontrols/controllers/RenderHtmlController.java
    return [
        6892, // Hotel HSR SingleRoom drop-down
        9016, // Cruise search additional filter options
        8691, // gyeung: RV on/off switch
        9257, // gsobotka: AWS home page alert
        9874, //rnarang: LX Mingle 925 cars wizard
        9875, //rnarang: LX Mingle 925 things to do wizard,
        13582, //dg: Mingle #9943 -  Hide paywith points banner on home page behind an experiment.
        16160, //Alternate mad service header banner text
        15939 // savazquez: Yellow GC Header
    ];
});

define("gc/headerMessages", [], function(){ 
              return {
  "closeButtonLabel": "Close",
  "supportMenuLink": "Support",
  "customerSupportLink": "Customer Support",
  "feedbackLink": "Feedback",
  "accountMenuLink": "Account",
  "signInLink": "Sign In",
  "createAccountLink": "Create an Account",
  "accountLink": "My Account",
  "moreMenuLink": "More",
  "rbcRewardsHome": "RBC Rewards Home",
  "travelRewards": "Travel Rewards",
  "availablePoints": "Available Points",
  "signOutLink": "Sign Out",
  "identifiedSignOutLink": "Not <span id='userGreetingNameSignOut'></span> ?",
  "identifiedSignOutLink-v2": "Not <span id='userGreetingNameSignOut-v2'></span> ? </br> <span class='type-200'>Log in to your account</span>",
  "scratchpadLink": "My Lists",
  "tripsLink": "My Trips",
  "taapTrackingCode": "Tracking Code",
  "travelAgentTitle": "TRAVEL AGENT AFFILIATE PROGRAM",
  "userGreeting": "<span class='nonArrangedUser hidden'>Hello, <span id='userGreetingName'></span></span> <span class='arrangedUser hidden'><span id='arrangedUserGreetingName'></span>'s Account</span>",
  "arrangeeMessage": "Booking travel on behalf of <strong><span id='arrangee-first-name'></span> <span id='arrangee-last-name'></span></strong>",
  "doneArrangingText": "Done",
  "beginMainContent": "Beginning of main content",
  "skipNavContent": "Skip to main content",
  "shopTravel": "Shop Travel",
  "getLowRatesOnHotelsLink": "Get lower rates on thousands of hotels.",
  "rewardsLink": "My Rewards",
  "zeroPointsLink": "0 points",
  "joinExpediaRewardsLink": "Join Expedia+ rewards",
  "createAccountInAccountIconLink": "or <a id='header-account-signup' href='/user/createaccount' data-onclick='xp.nav.trackAnalytics(this, &quot;a&quot;, &quot;Header.CreateAccount&quot;)'>create an {{0}} Account</a>",
  "sessionExpiredButton": "Sign In",
  "sessionExpiredPara": "Please sign back in.",
  "sessionExpiredTitle": "You have been logged out due to inactivity.",
  "sessionLoading": "Loading",
  "sessionWarningButton": "Extend Session",
  "sessionWarningPara": "It's been a while since you were active on the site. Please extend your session below to continue shopping.",
  "sessionWarningTitle": "Session Timeout Warning",
  "spHeaderLink": "My Lists",
  "spHeaderLink_1": "My Favorites",
  "spHeaderLink_2": "My Lists",
  "spHeaderLink_3": "My Shortlist",
  "spHeaderLink_4": "Recently Viewed",
  "spHeaderLink_5": "My Notes",
  "spHeaderVariantLink": "Lists",
  "spSpTrayBadgeOne": "You have 1 recently viewed item",
  "spSpTrayBadgePlural": "You have {{count}} recently viewed items",
  "spViewallitems": "View all {{count}} items",
  "spViewscratchpadlink": "View your lists",
  "spViewscratchpadlink_1": "View Favorites",
  "spViewscratchpadlink_2": "View Lists",
  "spViewscratchpadlink_3": "View Shortlist",
  "spViewscratchpadlink_4": "View Recently Viewed",
  "spViewscratchpadlink_5": "View Notes",
  "savedHotels": "Saved Hotels",
  "showAccountIconMenu": "Show Account Menu",
  "spEmailaskstring": "Get price updates by email for your saved and recently viewed items.",
  "spPageupdatesoffer": "Get price updates by email for your saved and recently viewed items.",
  "spToolTipOff": "Get price updates by email for your saved and recently viewed items.",
  "spTrackChanges": "Track changes",
  "spSaveScratchpad": "Sign In or Create an Account to Keep",
  "spEmailconfirmationstring": "You are receiving price updates for your saved and recently viewed items. Watch your inbox!",
  "spToolTipOnJS": "You are receiving price updates for your saved and recently viewed items. Watch your inbox at {{userEmail}}.",
  "spSavesuccessstring": "This search has been added to your recently viewed items.",
  "spStandardGreeting": "Things you view while shopping are saved here.",
  "spLoadingGreeting": "Loading your lists...",
  "spLoadingGreeting_1": "loading your Favorites...",
  "spLoadingGreeting_2": "loading your Lists...",
  "spLoadingGreeting_3": "loading your Shortlist...",
  "spLoadingGreeting_4": "loading your Recently Viewed...",
  "spLoadingGreeting_5": "loading your Notes...",
  "spSaveconfirmationstring": "Things you view while shopping are saved here. Pick up where you left off.",
  "spOriginAirportToDestinationAirport": "{{departureAirportCode}} to {{arrivalAirportCode}}",
  "spTimeRange": "{{startTime}} - {{endTime}}",
  "spDateRange": "{{startDate}} - {{endDate}}",
  "spAsOfDate": "as of {{lastSeenDate}}",
  "spAsOfTime": "as of {{lastSeenTime}}",
  "spPerPerson": "per person",
  "spHotelSearchAvgPerNight": "avg per night",
  "spHotelSearchAvgTotalRate": "avg total rate",
  "spHotels": "{{destination}} hotels",
  "spDaily": "daily",
  "spWeekly": "weekly",
  "spTotal": "total",
  "spPerTraveler": "per traveler",
  "spCruiseSearchPerNight": "per night",
  "spCruiseSearchCruises": "Cruises",
  "spCruiseSearchAllMonths": "All Months",
  "spCruiseSearchAllDestinations": "All Cruise Destinations",
  "spPricefrom": "from {{itemPrice}}",
  "spSeePrice": "See price",
  "spOneWay": "One way",
  "spRoundtrip": "Round trip",
  "spAirlineLogoAltText": "logo",
  "spMultipleAirlinesLogoAltText": "Multiple Airlines logo",
  "spPackageTitle": "{{packageDestination}} Packages",
  "spPackageIncludes": "Flight and hotel included",
  "spThing1PlusThing2": "{{item1}} + {{item2}}",
  "spCarPackageItem": "car",
  "spCarsAt": "Cars at {{destination}}",
  "spCarsNear": "Cars near {{destination}}",
  "nudgeEnrollmentTitle": "Get price and availability changes for hotels you view.",
  "nudgeEnrollmentSubtitle": "We'll watch prices on your saved and recently viewed items for you.",
  "nudgeEnrollmentAction": "Track Changes",
  "nudgeEnrollmentSuccess": "You are receiving price updates for your recently saved and viewed items. Watch your inbox!",
  "spPriceDownOne": "1 price dropped.",
  "spPriceDownMany": "{{params.[0]}} prices dropped.",
  "spPriceUpOne": "1 price increased.",
  "spPriceUpMany": "{{params.[0]}} prices increased.",
  "spPriceDownManyUpMany": "{{params.[0]}} prices dropped, {{params.[1]}} prices increased.",
  "spPriceDownManyUpOne": "{{params.[0]}} prices dropped, {{params.[1]}} price increased.",
  "spPriceDownOneUpMany": "{{params.[0]}} price dropped, {{params.[1]}} prices increased.",
  "spPriceDownOneUpOne": "1 price dropped, 1 price increased.",
  "seeWhatChanged": "See what’s changed",
  "signInToSee": "Sign in to see your notifications.",
  "scratchpadFoundUpdates": "There's a price update for at least one item you viewed recently.",
  "somethingHasChanged": "Something’s changed!",
  "welcome": "Welcome!",
  "itinBouncedEmail": "We weren’t able to deliver your purchase confirmation email.",
  "itinBouncedEmailLink": "View your itinerary online or resend",
  "seeDetails": "See details",
  "itemsChanged": "Items you viewed have changed!",
  "noNotifications": "All caught up!",
  "noNotificationsPartTwo": "No new notifications right now.",
  "spMemberDealsSignUp": "Sign Up Now",
  "spMemberRewardsSignUp": "Join Now",
  "rewardsHotelCouponAvailability": "You have a {{params.[0]}} coupon available. Use it on your next hotel booking and save!",
  "rewardsVIPCouponAvailability": "You have a {{params.[0]}} +VIP Access coupon available. Use it on your next hotel booking and save!",
  "rewardsHotelCouponAvailabilityLink": "Shop hotels",
  "rewardsVIPCouponAvailabilityLink": "Shop +VIP Access hotels",
  "rewardsHotelCouponExpirationLinkV2": "Visit your account",
  "rewardsHotelCouponExpirationV1": "Your {{params.[0]}} coupon expires on {{params.[1]}}!&lt;br&gt;Book now to make sure you get your rewards.",
  "rewardsHotelCouponExpirationV2": "You have a coupon that’s expiring soon. Check your account for more details.",
  "rewardsTierLink": "See&lt;br&gt;your new benefits",
  "rewardsOneAwayLink": "See all the perks",
  "rewardsGoldUpgradeLink": "See your new benefits",
  "rewardsPointExpirationLink": "Redeem now",
  "rewardsPayWithPointsLearnMoreLink": "Learn More",
  "rewardsNewBadge": "NEW!",
  "spAccessibleBellIcon": "Your notifications",
  "spAccessibleBadgeOne": "You have 1 notification",
  "spAccessibleBadgePlural": "You have #### notifications",
  "spAccessibleNotifClose": "Close",
  "addChromeExtensionNotificationMessage": "The official Expedia Member Only Deals extension is here! Stay connected and get your 10% off with member pricing.",
  "addChromeExtensionNotificationLink": "Add to Chrome",
  "spSwitchToAarp": "Get AARP Member discounts on AARP Travel Center",
  "exclusiveDealsMsg": "Sign in to see exclusive Member Pricing.",
  "newCreateAccountLink": "New? <span>Create an Account</span>",
  "TAAPWelcomeMessage": "Welcome to Expedia Travel Agent Affiliate Program. You’re eligible to earn commission on your purchases!",
  "TAAPWelcomeMessageLeanMoreLink": "Learn more about our incentives.",
  "flightMIPGTMsg": "Exclusive offer: Your flight booking just unlocked up to 20% off ground transportation!",
  "flightMIPActivityMsg": "Exclusive offer: Your flight booking just unlocked up to 20% off activities!",
  "flightMIPActivityMsgCTC": "See Things to Do",
  "flightMIPGTMsgCTC": "See Transportation",
  "TAAPGBVRemainingMessageSilver": "You’re <b>{{params.[0]}}</b> away from reaching the Silver level - higher commission on hotels, car rentals and activities.",
  "TAAPGBVRemainingMessageGold": "You’re <b>{{params.[0]}}</b> away from reaching the Gold level - higher commission on hotels, car rentals and activities.",
  "TAAPGBVRemainingMessagePlatinum": "You’re <b>{{params.[0]}}</b> away from reaching the Platinum level - higher commission on hotels, car rentals and activities.",
  "TAAPGBVRemainingLink": "See our incentive plans",
  "promisingText": "Price Guarantee",
  "downloadText": "Download the free app",
  "pointsText": "Earn 2x {{brand}} points on all bookings",
  "DEpointsText": "Book on the go.",
  "TravelocitydownloadText": "Get 15% off hotels in app",
  "TravelocitypointsText": "Download the app & use code <b>MOB15</b> to save 15% on select hotels",
  "OrbitzdownloadText": "Download the free app",
  "OrbitzpointsText": "Earn 5% back in app + save 15% on select hotels with code <b>APP15</b>",
  "CheapTicketsdownloadText": "Become a travel ninja",
  "CheapTicketspointsText": "Book on the go and stay connected with real-time trip updates on the app",
  "eBookersdownloadText": "Download the free app",
  "eBookerspointsText": "Earn 5% BONUS+ back in app & save 10% on hotels with code APP10",
  "WotifdownloadText": "Take a shortcut to your next trip",
  "WotifpointsText": "Get the Wotif App and book on the go",
  "speedbumpTitle": "You're continuing to another website",
  "speedbumpMessage": "You're continuing to another website that we do not own or operate. Its owner is solely responsible for the website's content, offerings and level of security, so please refer to the website's posted privacy policy and terms of use.",
  "speedbumpButtonContinue": "Continue",
  "speedbumpButtonReturn": "Return"
}; 
            });
            
if(window.location.hostname.indexOf("travelocity") > -1 )
{
    var channelTrackingAlreadyLoaded = true;
}
if(typeof channelTrackingAlreadyLoaded == "undefined")     {
    var channelTrackingAlreadyLoaded = true;
    var emptyAsppCookie = "v.1,0|||||||||||||";
//begin configuration  --- can be put into separate file
//first flag indicates clear SEOID
//second flag - null indicates check for SEMCID, true is to clear the cookie, false is don't clear the cookie
    var SEO_SOURCES = {
        "www.google.":[true,null],
        "search.yahoo.com": [true, null],
        "wrs.yahoo.com":[true,null],
        "rc12.overture.com":[true,false],
        "bing.com/search":[true,null],
        "terra.es":[true,null],
        "ya.com":[true,null],
        "ricerca.virgilio.it":[true,null],
        "iltrovatore.it":[true,null],
        "213.215.201.230":[true,null], //IP address that iltrovatore search results come up on
        "orange.fr":[true,null],
        "lycos.":[true,null],
        "ask.com":[true,null],
        "search.aol.":[true,null],
        "askjeeves.":[true,null],
        "myway.com":[true,null],
        "altavista":[true,null],
        "baidu":[true, null],
        "daum.net":[true, null],
        "mywebsearch.com":[true, null],
        "naver.com":[true, null],
        "suche.web.de":[true, null],
        "mvirgilio.it":[true, null],
        "yandex":[true, null]
    };

    var CHANNEL_TYPES = "(AFF|OLA|EML|MDP|SEM|OFF|MSN|ICM|SEO|AFM)";
//end configuration

// QUNIT TEST CODE
// qUnitTestRun defined in channelTrackingTests.html
    if (typeof qUnitTestRun !== 'undefined' && qUnitTestRun != null) {
        var stub = sinon.stub(this, 'getDomainLegacy', function() {
            return ['://www.testDomain.com',
                'www.',
                'testDomain.com'];
        });
    }

    var tracking_array_contains = function (_array, obj) {
        var i = _array.length;
        while (i--) {
            if (_array[i] === obj) {
                return true;
            }
        }
        return false;
    }

    var ClearMediaCookieIfItIsTickSeparated = function () {
        var cookieName = "p1=";
        var start = document.cookie.indexOf(cookieName);

        if (start == -1) {
            var mediaCookie = "MediaCookie=";
            var exist = document.cookie.indexOf(mediaCookie);

            if (exist >= 0) {
                var len = exist + mediaCookie.length + 1;
                var end = document.cookie.indexOf(";", len);
                if (end == -1) {
                    end = document.cookie.length;
                }

                var positionOfSeparator = len + 1;
                if (positionOfSeparator < end) {
                    var separator = document.cookie.substring(len, positionOfSeparator);
                    if (separator == '`') {
                        var expires = new Date(new Date().setTime(new Date().getTime())); // now!!!
                        var domain = getDomainLegacy(location.href);
                        if (domain > "") {
                            domain = domain[2] ? domain[2] : '';
                            document.cookie = mediaCookie + "; expires=" + expires.toUTCString() + "; domain=." + domain + "; path=/";
                        }
                    }
                }
            }
        }
    }

    var GetChannelSpecificCode = function (channelId, original) {
        var regex = /(?:cuid|tduid)=([^&]*)/i;
        var code = original;

        if (regex.test(location.search)) {
            code = regex.exec(location.search)[1];
        }

        return code;
    }

    var getChannelSpecificConversionID = function (originalConversionId) {
        var regex = /(?:mdpdtl|oladtl|afflid|icmdtl)=([^&]*)/i;
        var id = "";

        if (regex.test(location.search)) {
            id = regex.exec(location.search)[1];
        } else {
            id = originalConversionId;
        }

        return id;
    }

    var IsLockedCode = function (prevType, prevId, currentType, currentId) {
        // Only wpk for now
        return prevId && prevId != "" && prevId.slice(0, 3) == "wpk" && currentId.slice(0, 3) != "wpk";
    }

    var GetASPPersistentCookie = function () {
        var start = document.cookie.indexOf("aspp=");
        var len = start + 5;

        if (!start && ("aspp" != document.cookie.substring(0, 4))) {
            return null;
        }

        if (start == -1) {
            return null;
        }

        var end = document.cookie.indexOf(";", len);
        if (end == -1) {
            end = document.cookie.length;
        }

        return document.cookie.substring(len, end);
    }

    var SetASPPersistentCookie = function (value) {
        ExpireASPPCookieInParentDomain();

        var expires = new Date(new Date().setTime(new Date().getTime()+5*365*24*60*60*1000)); // 5 years

        var domain = getDomainLegacy(location.href);
        if (domain > "") {
            domain = domain[2] ? domain[2] : '';
            document.cookie = "aspp=" + value + "; expires=" + expires.toUTCString() + "; domain=." + domain + "; path=/";
        } else {
            document.cookie = "aspp=" + value + "; expires=" + expires.toUTCString() + "; path=/";
        }

        if (domain == null || domain == "") {
            if (typeof dctk !== 'undefined') { // Home Page, Launch Pages, Hotel Search, Hotel Infosite, Flights Search
                dctk.loggingAdapter.logMessage('channelTrackingCookieDomainEmpty', ['url=' + encodeURIComponent(location.href), 'cookies=' + encodeURIComponent(document.cookie)]);
            } else if (typeof expClientLogging !== 'undefined') { // Hotel Payment, Flight UDP, Package Search, Package Infosite
                expClientLogging.logMessage('channelTrackingCookieDomainEmpty', ['url=' + encodeURIComponent(location.href), 'cookies=' + encodeURIComponent(document.cookie)]);
            }
        }
    }

    var getCookie = function (cookieName) {
        var regexCookie = RegExp("(?:^| |;)" + cookieName + "=([^ ;]*)", "i");
        var cookie = regexCookie.exec(document.cookie);

        if (cookie == null || cookie.length <= 1) {
            return null;
        }

        return cookie[1];
    }

// Sets an ASP cookie. There are two ASP cookies: Persistent and Session.
// ASPP cookie expires 5 years after being set
// ASPS cookie is a session cookie
    var setAspCookie = function (value, isPersistent) {
        if (isPersistent == null || value == null) {
            return;
        }

        var name = isPersistent ? "aspp" : "asps";
        var domain = getDomain(location.href);
        var expires = isPersistent ? new Date(new Date().setTime(new Date().getTime()+5*365*24*60*60*1000)) : null;
        var path = "/";

        if (isPersistent) {
            ExpireASPPCookieInParentDomain();
        }

        var cookie = name + "=" + value + "; ";

        if (expires != null) {
            cookie += "expires=" + expires.toUTCString() + "; ";
        }

        if (domain > "" && domain != "localhost") {
            cookie += "domain=." + domain + "; ";
        }

        cookie += "path=" + path;

        document.cookie = cookie;

        if (domain == null || domain == "") {
            if (typeof dctk !== 'undefined') { // Home Page, Launch Pages, Hotel Search, Hotel Infosite, Flights Search
                dctk.loggingAdapter.logMessage('channelTrackingCookieDomainEmpty', ['url=' + encodeURIComponent(location.href), 'cookies=' + encodeURIComponent(document.cookie)]);
            } else if (typeof expClientLogging !== 'undefined') { // Hotel Payment, Flight UDP, Package Search, Package Infosite
                expClientLogging.logMessage('channelTrackingCookieDomainEmpty', ['url=' + encodeURIComponent(location.href), 'cookies=' + encodeURIComponent(document.cookie)]);
            }
        }
    }

// Added due to duplicate ASPP cookie setting bug, which is persisting on user browsers...
    var ExpireASPPCookieInParentDomain = function () {
        var expires = new Date(new Date().setTime(new Date().getTime()-(5*365*24*60*60*1000))); // 5 years (ago)
        var domain = getDomainLegacy(location.href);
        domain = domain[2] ? domain[2] : '';

        if (domain > "") {
            document.cookie = "aspp=; expires=" + expires.toUTCString() + "; path=/";
        }
    }

// Retrieve specific cookie values
    var GetCookieValue = function (cookieName, index, splitter) {
        if (splitter == null) {
            splitter = ",";
        }

        cookieName = cookieName + "=";
        var start = document.cookie.indexOf(cookieName);
        var len = start + cookieName.length;

        if (!start && (cookieName != document.cookie.substring(0, cookieName.length))) {
            return "";
        }

        if (start == -1) {
            return "";
        }

        var end = document.cookie.indexOf(";", len);
        if (end == -1) {
            end = document.cookie.length;
        }

        var cookieValue = document.cookie.substring(len, end);
        var valueArray = cookieValue.split(splitter);

        if (valueArray[index] != null) {
            return valueArray[index];
        } else {
            return null;
        }
    }

// Parse P1 cookie to get TPID
    var GetP1CookieTpid = function () {
        var cookieName = "p1=";
        var start = document.cookie.indexOf(cookieName);
        var len = start + cookieName.length;

        if (start == -1) {
            return GetCookieValue("tpid", 1);
        }

        var end = document.cookie.indexOf(";", len);
        if (end == -1) {
            end = document.cookie.length;
        }

        var valueArray = (document.cookie.substring(len, end)).split("`");

        for (var val = 0; val < valueArray.length; val++) {
            if (valueArray[val].indexOf("tpid") != -1) {
                return valueArray[val].split(",")[1];
            }
        }
    }

    var isValidASPPCookie = function (asppCookie) {
        var regexAspp = /v\..*\|.*\|.*\|.*\|.*\|.*\|.*\|.*\|.*\|.*\|.*\|.*/i;
        var match = regexAspp.exec(asppCookie);

        if (!match) {
            return false;
        }

        return true;
    }

// Capture Zanox Partner ID from query string and store in ASPS cookie
    var captureZanpid = function (queryString) {
        var zanpids = getZanpids(queryString);
        var aspsCookie = getCookie("asps");

        if (zanpids.length < 1) {
            return;
        }

        if (!isValidAspsCookie(aspsCookie)) {
            aspsCookie = "0||||||0|" + zanpids.toString(); // Default is 0 for do_shunt_bypass and display_trace
            setAspCookie(aspsCookie, false);
            return;
        }

        var aspsValues = aspsCookie.split("|");
        aspsValues[7] = zanpids.toString();

        aspsCookie = "";
        for (var i = 0; i < aspsValues.length; i++) {
            aspsCookie += aspsValues[i] + "|";
        }

        setAspCookie(aspsCookie.substring(0, aspsCookie.length - 1), false);
    }

    var getZanpids = function (queryString) {
        var regexZanpid = /zanpid=([^&]*)/gi;
        var matchedZanpid;
        var zanpids = [];

        while (matchedZanpid = regexZanpid.exec(queryString)) {
            if (matchedZanpid.length > 1 && matchedZanpid[1] != "") {
                zanpids.push(matchedZanpid[1]);
            }
        }

        return zanpids;
    }

    var isValidAspsCookie = function (aspsCookie) {
        var regexAsps = /.*\|.*\|.*\|.*\|.*\|.*\|.*\|.*/i;
        return aspsCookie != null && aspsCookie > "" && regexAsps.test(aspsCookie);
    }

    var getDomainLegacy = function (href) {
        var domain = href.match(/:\/\/(www\.)?([^\/:]+)/);
        return domain;
    }

    var getDomain = function (href) {
        var domain = href != null ? href.match(/:\/\/(?:www\.)?([^\/:]+)/) : '';

        if (domain == null || domain.length <= 1) {
            return "";
        }

        return domain[1];
    }

    var checkIfEmailInString = function (text) {
        var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
        return re.test(text);
    }

    var getValueOfCookie = function (cname) {
        var name = cname + "=";
        var allCookies = document.cookie.split(';');
        for(var i=0; i<allCookies.length; i++) {
            var c = allCookies[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            c= c.replace(' ','');
            if (c.indexOf(name) != -1) {
                return c.substring(name.length,c.length);
            }
        }
        return "";
    }
    var deleteCookie = function (cookieNamePrefixList) {
        var allCookies = document.cookie.split(';');
        for(var i=0; i<allCookies.length; i++) {
            var cookies = allCookies[i];
            while (cookies.charAt(0)==' ') cookies = cookies.substring(1);
            cookies= cookies.replace(' ','');
            for (var a = 0; a < cookieNamePrefixList.length; a++) {
                if (cookies.indexOf(cookieNamePrefixList[a]) != -1 && cookies.length > 300) {
                    var expires = new Date(new Date().setTime(new Date().getTime() - (5 * 365 * 24 * 60 * 60 * 1000))); // 5 years (ago)
                    var domain = getDomainLegacy(location.href);
                    domain = domain[2] ? domain[2] : '';

                    if (domain > "") {
                        document.cookie = cookies.split("=")[0] + "= ;expires=" + expires.toUTCString() + "; domain=." + domain + "; path=/";
                    } else {
                        document.cookie = cookies.split("=")[0] + "= ;expires=" + expires.toUTCString() + "; path=/";
                    }
                    return;
                }
            }
        }
    }
// Clearing MediaCookie temporary for a fix INC000000165986
    ClearMediaCookieIfItIsTickSeparated();

    var tpid = GetP1CookieTpid();
    var eapid = GetCookieValue("iEAPID", 0);

    var ChannelType = "";
    var ChannelID = "";
    var ASPPersistentCookie = "";

//if not cookie, create a blank one
    if ( !( GetASPPersistentCookie() > "" && isValidASPPCookie(GetASPPersistentCookie()) ) ) {
        SetASPPersistentCookie("v.1,0|||||||||||||");
    }

//grab previous cookie values of importance
    var previousChannelID = GetCookieValue("aspp", 1, "|");
    var previousChannelType = GetCookieValue("aspp", 10, "|");

    var referrerAddress = document.referrer;

//if not AFF or WPK then if you came from SEO or FR, clear cookie
    if (referrerAddress != "") {
        // only applies to FR, DE and AT POSs
        //if ((tpid == 20) || (tpid == 6) || ((tpid == 6) && (eapid == 10122)))
        if (previousChannelID && previousChannelID != "" && previousChannelID.slice(0,3).toLowerCase() != "wpk"
            && (tpid == 20 || ( previousChannelType && previousChannelType != "" && previousChannelType.toLowerCase() != "aff" ))) {
            // flag for remove SEOCID or not
            // (need to be cleared if referrer is Goggle or Yahoo)
            var clearSeocid = false;
            // flag for clear cookie or not
            // (need to be cleared if referrer is Goggle or Yahoo normal search /not sponsored link/)
            var clearCookie = false;

            //determine if you came from valid SEO source
            for (var site in SEO_SOURCES) {
                if (referrerAddress.toLowerCase().indexOf(site) > -1) {
                    clearSeocid = SEO_SOURCES[site][0];
                    if (SEO_SOURCES[site][1] == null) {
                        clearCookie = (referrerAddress.toLowerCase().indexOf("semcid") == -1);
                    } else {
                        clearCookie = SEO_SOURCES[site][1];
                    }
                }
            }

            if (clearCookie) {
                // clear the cookie value
                SetASPPersistentCookie("v.1,0|||||||||||||");
            }

            if (clearSeocid) {
                var urlAndQueryAttributes = window.location.toString().split("?");

                if (urlAndQueryAttributes.length > 1) {
                    var url = urlAndQueryAttributes[0];
                    var queryAttributes = urlAndQueryAttributes[1].split("&");
                    var relocate = false;

                    for (var index = 0; index < queryAttributes.length; index++) {
                        if (queryAttributes[index].toLowerCase().indexOf("seocid") == -1) {
                            url += (index == 0) ? "?" : "&";
                            url += queryAttributes[index];
                        } else {
                            relocate = true;
                        }
                    }

                    if (relocate == true) {
                        window.location = url;
                    }
                }
            }
        }
    }

    (function () {
        var regexCid = new RegExp(CHANNEL_TYPES + "cid=([^&]*)", "i");
        var match = regexCid.exec(window.location.search);

        if (!match) {
            match = regexCid.exec(window.location.hash);
        }

        if (!match) {
            match = regexCid.exec(document.referrer);
        }

        if (!!match) {
            ChannelType = match[1].toUpperCase();
            ChannelID = escape(match[2]);

            if (ChannelID !== "") {
                ASPPersistentCookie = GetASPPersistentCookie();

                if (!ASPPersistentCookie > "") {
                    SetASPPersistentCookie(emptyAsppCookie);
                    ASPPersistentCookie = GetASPPersistentCookie();
                }

                if (!IsLockedCode(previousChannelType, previousChannelID, ChannelType, ChannelID)) {
                    var expires = new Date(new Date().setTime(new Date().getTime() + 30 * 24 * 60 * 60 * 1000));  //Add 30 Days
                    var expYear = expires.getFullYear().toString();
                    var expMonth = (expires.getMonth() + 1).toString();
                    if (expMonth.length < 2) {
                        expMonth = "0" + expMonth;
                    }
                    var expDay = expires.getDate().toString();
                    if (expDay.length < 2) {
                        expDay = "0" + expDay;
                    }
                    var ChannelExpiry = expYear + expMonth + expDay;

                    var asppValues = ASPPersistentCookie.split("|");
                    asppValues[1] = ChannelID;
                    asppValues[10] = ChannelType;
                    asppValues[11] = ChannelExpiry;
                    asppValues[12] = GetChannelSpecificCode(ChannelID, asppValues[12]);
                    asppValues[13] = getChannelSpecificConversionID(asppValues[13]);

                    ASPPersistentCookie = "";
                    for (var i = 0; i < asppValues.length; i++) {
                        ASPPersistentCookie += asppValues[i] + "|";
                    }
                    ASPPersistentCookie = ASPPersistentCookie.substring(0, ASPPersistentCookie.length - 1);
                    if (checkIfEmailInString(ASPPersistentCookie)) {
                        ASPPersistentCookie = emptyAsppCookie;
                    }
                    SetASPPersistentCookie(ASPPersistentCookie);
                }
            }
        }

        var asppCookie = getValueOfCookie("aspp");
        if (checkIfEmailInString(asppCookie)) {
            asppCookie = emptyAsppCookie;
            SetASPPersistentCookie(asppCookie);
        }

        if (asppCookie != null && asppCookie.length != 0 && asppCookie.split("|").length > 14) {
            // clear the cookie value
            var validCookieValue = asppCookie.substring(0, asppCookie.indexOf(asppCookie.split("|")[14]) - 1);
            SetASPPersistentCookie(validCookieValue);
        }

        //delete cookie list
        var deleteCookieList = ["_tq_ref","mvthistory"];
        //delete if character length is more than 300
        deleteCookie(deleteCookieList)


        if (window.location.search.search(/zanpid/i) > -1) {
            captureZanpid(window.location.search);
        }
    })();

    if (location.search.indexOf("cntrkrdebug") > -1) {
        //show debug values
        if (window.console && window.console.log) {
            console.log("Previous Channel Type: " + previousChannelType + "\n Previous Channel ID: " + previousChannelID
                + "\n Current Channel Type: " + ChannelType + "\n Current Channel ID: "+ ChannelID
                + "\n ASPP Cookie Value: " + getCookie("aspp")
                + "\n ASPS Cookie Value: " + getCookie("asps"));
        }
    }
}
require(['jquery', 'gc/abTest', 'gc/pageModel', 'dctk/dctk'], function($, abTest, pageModel, dctk) {

  function init() {
    if (
      (pageModel.site.id == 1 && pageModel.site.locale === "en_US" && abTest.get(15252, null, true).value == 1) ||
      (abTest.get(16064, null, true).value == 1) || // mad_footer_placement_comet
      (abTest.get(16065, null, true).value == 1)  // mad_footer_placement_bex
    ) {
      loadViaMadService();
    }
    else if (
      $('#t2d-footer-container').length && abTest.get(14135, null, true).value == 1
    ) {
      replaceVariablesInText();
      showOSRelatedElements();
      $('#t2d-footer-form button').click(submitClicked);
      $('#t2d-footer-container').show();
      loadTrackingAndClick();
    }
  }

  function loadViaMadService() {
    var mad_script = document.createElement('script');
    var os = 'desktop';
    if (Modernizr.appleios) {
      os = 'iOS';
    } else if (Modernizr.android) {
      os = 'Android';
    }
    var url = ['/mad-service/globalControls/gcFooter?containerId=mad-footer-container'];
    url.push('&siteid=');
    url.push(pageModel.site.id);
    url.push('&locale=');
    url.push(pageModel.site.locale);
    url.push('&pageName=gc.footer');
    url.push('&os=');
    url.push(os);
    url.push('&brand=');
    url.push(pageModel.site.brandName);
    mad_script.setAttribute('src', url.join(''));
    document.head.appendChild(mad_script);
  }

  function loadTrackingAndClick () {
    console.log('test loadTrackingAndClick');
    if ( dctk && dctk.onReady && dctk.trackEvent) {
      dctk.onReady(function () {
        dctk.trackEvent({
          trackEvents : "event278",
          trackVars : {
            prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.IMP',
            eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.IMP'
          }
        });
        $(document).on('click', '#t2d-footer-app-stores-ios-desktop', function (e) {
          dctk.trackEvent({
            trackEvents: "event268",
            trackVars : {
              prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.IOS',
              eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.IOS'
            }
          });
        });
        $(document).on('click', '#t2d-footer-app-stores-android-desktop', function (e) {
          dctk.trackEvent({
            trackEvents: "event268",
            trackVars : {
              prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.ANDROID',
              eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.ANDROID'
            }
          });
        });
        $(document).on('click', '#t2d-footer-app-stores-ios-mobile', function (e) {
          dctk.trackEvent({
            trackEvents: "event268",
            trackVars : {
              prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.IOS',
              eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.IOS'
            }
          });
        });
        $(document).on('click', '#t2d-footer-app-stores-android-mobile', function (e) {
          dctk.trackEvent({
            trackEvents: "event268",
            trackVars : {
              prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.ANDROID',
              eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.BUTTON.ANDROID'
            }
          });
        });
      });
    }
  }

  function replaceVariablesInText() {
    replaceText('#t2d-footer-error-international', 'countryName', getCountryName());
    replaceText('#t2d-footer-error-international', 'phoneNumberFormat', getPhoneNumberFormat());
    replaceText('#t2d-footer-error-validation', 'phoneNumberFormat', getPhoneNumberFormat());
  }

  function replaceText(selector, replaceName, replaceTo) {
    var text = $(selector).text();
    var regex = new RegExp('\{\{' + replaceName + '\}\}', 'g');
    text = text.replace(regex, replaceTo);
    $(selector).text(text);
  }

  function getPhoneNumberInput() {
    return $('#t2d-footer-form-input').val();
  }

  function getValidPhoneMinLength() {
    return $('#t2d-footer-form').attr('data-valid-phone-min-length');
  }

  function getValidPhoneMaxLength() {
    return $('#t2d-footer-form').attr('data-valid-phone-max-length');
  }

  function getCountryPhonePrefix() {
    return $('#t2d-footer-form').attr('data-country-phone-prefix');
  }

  function getCountryName() {
    return $('#t2d-footer-form').attr('data-country-name');
  }

  function getPhoneNumberFormat() {
    return $('#t2d-footer-form').attr('data-phone-number-format');
  }

  function submitClicked() {
    hideMessages();
    var phoneNumber = getValidPhoneNumber();
    if (phoneNumber) {
      sendRequest(phoneNumber);
    }
  }

  function hideMessages() {
    $('#t2d-footer-success').hide();
    $('#t2d-footer-error').hide();
    $('#t2d-footer-error-duplication').hide();
    $('#t2d-footer-error-service').hide();
    $('#t2d-footer-error-validation').hide();
    $('#t2d-footer-error-international').hide();
  }

  function getValidPhoneNumber() {
    var result = getPhoneNumberInput();
    result = result.replace(/\D/g, ''); // keep only numbers
    result = result.replace(/^0*/, ''); // remove starting zeros
    var minLength = getValidPhoneMinLength();
    var maxLength = getValidPhoneMaxLength();
    if (result.length < minLength) {
      return showError('validation');
    }
    if (result.length > maxLength) {
      var regex = new RegExp('^' + getCountryPhonePrefix());
      result = result.replace(regex, '');
      if (result.length < minLength || result.length > maxLength) {
        return showError('international');
      }
    }
    return result;
  }

  function sendRequest(phoneNumber) {
    var data_app = (pageModel.site.id == 1) ? 'app_61' : 'app_60';
    var data = {
      url: '/T2DGenProxy?serviceID=TXT_MOBILEAPP_LINK',
      type: 'POST',
      dataType: 'json',
      data: {
        mobile_phone: phoneNumber,
        data_app: data_app,
        country_calling_code: getCountryPhonePrefix()
      },
      success: showSuccess,
      error: errorCallback
    };
    $.ajax(data);
  }

  function errorCallback(xhr) {
    var errResponse = xhr.responseText;
    if (errResponse.toLowerCase().indexOf("has already received 3 messages in 24 hours") >= 0) {
      showError('duplication');
    } else {
      showError('service');
    }
  }

  function showError(name) {
    $('#t2d-footer-error').show();
    $('#t2d-footer-error-' + name).show();
    if ( dctk && dctk.onReady && dctk.trackEvent) {
      dctk.trackEvent({
        trackEvents: "event268",
        trackVars: {
          prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.INVALID',
          eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.INVALID'
        }
      });
    }
  }

  function showSuccess() {
    $('#t2d-footer-success').show();
    $('#t2d-footer-form input').attr('value', '');
    if ( dctk && dctk.onReady && dctk.trackEvent) {
      dctk.trackEvent({
        trackEvents: "event268",
        trackVars: {
          prop16: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.VALID',
          eVar28: 'GCF.Banner.App.GC.APP.FOOTER.V2.T2D.VALID'
        }
      });
    }
  }

  function showOSRelatedElements() {
    if (Modernizr.appleios) {
      showAppStoreLink('ios', 'mobile');
    } else if (Modernizr.android) {
      showAppStoreLink('android', 'mobile');
    } else {
      showAppStoreLink('ios', 'desktop');
      showAppStoreLink('android', 'desktop');
      $('#t2d-footer-form').css('display', 'block');
      $('#t2d-footer-form-legal').css('display', 'block');
    }
  }

  function showAppStoreLink(mobileOs, deviceType) {
    $('#t2d-footer-app-stores-' + mobileOs + '-' + deviceType).css('display', 'inline');
  }

  $(document).ready(init);

});

require(['gc/abTest', 'gc/pageModel', 'jquery'], function(abTest, pageModel, $) {
  var testEvaluation = abTest.get(14541, null, true);
  var epcContainerElement = $('#partner-add-hotel-container');
  var epcLinkElement = $('> a', epcContainerElement);

  if ($(epcContainerElement).length > 0 && $(epcLinkElement).length > 0 && (testEvaluation.value === 1 || testEvaluation.value === 2)) {

    testEvaluation.value === 2 && $(epcLinkElement).attr('target', '_blank');
    $(epcLinkElement).attr(
      'href',
      $(epcLinkElement).attr('href')
        .replace(
          /{POS}/g,
          pageModel.site.locale.substr(
            pageModel.site.locale.indexOf('_') + 1
          )
        )
        .replace(
          /{VARIANT}/g,
          testEvaluation.value
        )
    );
    $(epcContainerElement).show();
  }
});
